/*!
 * Webflow: Front-end site library
 * @license MIT
 * Inline scripts may access the api using an async handler:
 *   var Webflow = Webflow || [];
 *   Webflow.push(readyFunction);
 */

(() => {
  var OE = Object.create;
  var In = Object.defineProperty;
  var xE = Object.getOwnPropertyDescriptor;
  var RE = Object.getOwnPropertyNames;
  var wE = Object.getPrototypeOf,
    CE = Object.prototype.hasOwnProperty;
  var ne = (e, t) => () => (e && (t = e((e = 0))), t);
  var f = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports),
    me = (e, t) => {
      for (var n in t) In(e, n, { get: t[n], enumerable: !0 });
    },
    na = (e, t, n, r) => {
      if ((t && typeof t == "object") || typeof t == "function")
        for (let i of RE(t))
          !CE.call(e, i) &&
            i !== n &&
            In(e, i, {
              get: () => t[i],
              enumerable: !(r = xE(t, i)) || r.enumerable,
            });
      return e;
    };
  var $ = (e, t, n) => (
      (n = e != null ? OE(wE(e)) : {}),
      na(
        t || !e || !e.__esModule
          ? In(n, "default", { value: e, enumerable: !0 })
          : n,
        e
      )
    ),
    Me = (e) => na(In({}, "__esModule", { value: !0 }), e);
  var Fr = f(() => {
    "use strict";
    window.tram = (function (e) {
      function t(c, h) {
        var y = new le.Bare();
        return y.init(c, h);
      }
      function n(c) {
        return c.replace(/[A-Z]/g, function (h) {
          return "-" + h.toLowerCase();
        });
      }
      function r(c) {
        var h = parseInt(c.slice(1), 16),
          y = (h >> 16) & 255,
          T = (h >> 8) & 255,
          x = 255 & h;
        return [y, T, x];
      }
      function i(c, h, y) {
        return (
          "#" + ((1 << 24) | (c << 16) | (h << 8) | y).toString(16).slice(1)
        );
      }
      function o() {}
      function a(c, h) {
        l("Type warning: Expected: [" + c + "] Got: [" + typeof h + "] " + h);
      }
      function s(c, h, y) {
        l("Units do not match [" + c + "]: " + h + ", " + y);
      }
      function u(c, h, y) {
        if ((h !== void 0 && (y = h), c === void 0)) return y;
        var T = y;
        return (
          TE.test(c) || !ta.test(c)
            ? (T = parseInt(c, 10))
            : ta.test(c) && (T = 1e3 * parseFloat(c)),
          0 > T && (T = 0),
          T === T ? T : y
        );
      }
      function l(c) {
        Ee.debug && window && window.console.warn(c);
      }
      function g(c) {
        for (var h = -1, y = c ? c.length : 0, T = []; ++h < y; ) {
          var x = c[h];
          x && T.push(x);
        }
        return T;
      }
      var p = (function (c, h, y) {
          function T(H) {
            return typeof H == "object";
          }
          function x(H) {
            return typeof H == "function";
          }
          function S() {}
          function X(H, te) {
            function N() {
              var fe = new K();
              return x(fe.init) && fe.init.apply(fe, arguments), fe;
            }
            function K() {}
            te === y && ((te = H), (H = Object)), (N.Bare = K);
            var j,
              oe = (S[c] = H[c]),
              Ne = (K[c] = N[c] = new S());
            return (
              (Ne.constructor = N),
              (N.mixin = function (fe) {
                return (K[c] = N[c] = X(N, fe)[c]), N;
              }),
              (N.open = function (fe) {
                if (
                  ((j = {}),
                  x(fe) ? (j = fe.call(N, Ne, oe, N, H)) : T(fe) && (j = fe),
                  T(j))
                )
                  for (var Bt in j) h.call(j, Bt) && (Ne[Bt] = j[Bt]);
                return x(Ne.init) || (Ne.init = H), N;
              }),
              N.open(te)
            );
          }
          return X;
        })("prototype", {}.hasOwnProperty),
        d = {
          ease: [
            "ease",
            function (c, h, y, T) {
              var x = (c /= T) * c,
                S = x * c;
              return (
                h +
                y * (-2.75 * S * x + 11 * x * x + -15.5 * S + 8 * x + 0.25 * c)
              );
            },
          ],
          "ease-in": [
            "ease-in",
            function (c, h, y, T) {
              var x = (c /= T) * c,
                S = x * c;
              return h + y * (-1 * S * x + 3 * x * x + -3 * S + 2 * x);
            },
          ],
          "ease-out": [
            "ease-out",
            function (c, h, y, T) {
              var x = (c /= T) * c,
                S = x * c;
              return (
                h +
                y * (0.3 * S * x + -1.6 * x * x + 2.2 * S + -1.8 * x + 1.9 * c)
              );
            },
          ],
          "ease-in-out": [
            "ease-in-out",
            function (c, h, y, T) {
              var x = (c /= T) * c,
                S = x * c;
              return h + y * (2 * S * x + -5 * x * x + 2 * S + 2 * x);
            },
          ],
          linear: [
            "linear",
            function (c, h, y, T) {
              return (y * c) / T + h;
            },
          ],
          "ease-in-quad": [
            "cubic-bezier(0.550, 0.085, 0.680, 0.530)",
            function (c, h, y, T) {
              return y * (c /= T) * c + h;
            },
          ],
          "ease-out-quad": [
            "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
            function (c, h, y, T) {
              return -y * (c /= T) * (c - 2) + h;
            },
          ],
          "ease-in-out-quad": [
            "cubic-bezier(0.455, 0.030, 0.515, 0.955)",
            function (c, h, y, T) {
              return (c /= T / 2) < 1
                ? (y / 2) * c * c + h
                : (-y / 2) * (--c * (c - 2) - 1) + h;
            },
          ],
          "ease-in-cubic": [
            "cubic-bezier(0.550, 0.055, 0.675, 0.190)",
            function (c, h, y, T) {
              return y * (c /= T) * c * c + h;
            },
          ],
          "ease-out-cubic": [
            "cubic-bezier(0.215, 0.610, 0.355, 1)",
            function (c, h, y, T) {
              return y * ((c = c / T - 1) * c * c + 1) + h;
            },
          ],
          "ease-in-out-cubic": [
            "cubic-bezier(0.645, 0.045, 0.355, 1)",
            function (c, h, y, T) {
              return (c /= T / 2) < 1
                ? (y / 2) * c * c * c + h
                : (y / 2) * ((c -= 2) * c * c + 2) + h;
            },
          ],
          "ease-in-quart": [
            "cubic-bezier(0.895, 0.030, 0.685, 0.220)",
            function (c, h, y, T) {
              return y * (c /= T) * c * c * c + h;
            },
          ],
          "ease-out-quart": [
            "cubic-bezier(0.165, 0.840, 0.440, 1)",
            function (c, h, y, T) {
              return -y * ((c = c / T - 1) * c * c * c - 1) + h;
            },
          ],
          "ease-in-out-quart": [
            "cubic-bezier(0.770, 0, 0.175, 1)",
            function (c, h, y, T) {
              return (c /= T / 2) < 1
                ? (y / 2) * c * c * c * c + h
                : (-y / 2) * ((c -= 2) * c * c * c - 2) + h;
            },
          ],
          "ease-in-quint": [
            "cubic-bezier(0.755, 0.050, 0.855, 0.060)",
            function (c, h, y, T) {
              return y * (c /= T) * c * c * c * c + h;
            },
          ],
          "ease-out-quint": [
            "cubic-bezier(0.230, 1, 0.320, 1)",
            function (c, h, y, T) {
              return y * ((c = c / T - 1) * c * c * c * c + 1) + h;
            },
          ],
          "ease-in-out-quint": [
            "cubic-bezier(0.860, 0, 0.070, 1)",
            function (c, h, y, T) {
              return (c /= T / 2) < 1
                ? (y / 2) * c * c * c * c * c + h
                : (y / 2) * ((c -= 2) * c * c * c * c + 2) + h;
            },
          ],
          "ease-in-sine": [
            "cubic-bezier(0.470, 0, 0.745, 0.715)",
            function (c, h, y, T) {
              return -y * Math.cos((c / T) * (Math.PI / 2)) + y + h;
            },
          ],
          "ease-out-sine": [
            "cubic-bezier(0.390, 0.575, 0.565, 1)",
            function (c, h, y, T) {
              return y * Math.sin((c / T) * (Math.PI / 2)) + h;
            },
          ],
          "ease-in-out-sine": [
            "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
            function (c, h, y, T) {
              return (-y / 2) * (Math.cos((Math.PI * c) / T) - 1) + h;
            },
          ],
          "ease-in-expo": [
            "cubic-bezier(0.950, 0.050, 0.795, 0.035)",
            function (c, h, y, T) {
              return c === 0 ? h : y * Math.pow(2, 10 * (c / T - 1)) + h;
            },
          ],
          "ease-out-expo": [
            "cubic-bezier(0.190, 1, 0.220, 1)",
            function (c, h, y, T) {
              return c === T
                ? h + y
                : y * (-Math.pow(2, (-10 * c) / T) + 1) + h;
            },
          ],
          "ease-in-out-expo": [
            "cubic-bezier(1, 0, 0, 1)",
            function (c, h, y, T) {
              return c === 0
                ? h
                : c === T
                ? h + y
                : (c /= T / 2) < 1
                ? (y / 2) * Math.pow(2, 10 * (c - 1)) + h
                : (y / 2) * (-Math.pow(2, -10 * --c) + 2) + h;
            },
          ],
          "ease-in-circ": [
            "cubic-bezier(0.600, 0.040, 0.980, 0.335)",
            function (c, h, y, T) {
              return -y * (Math.sqrt(1 - (c /= T) * c) - 1) + h;
            },
          ],
          "ease-out-circ": [
            "cubic-bezier(0.075, 0.820, 0.165, 1)",
            function (c, h, y, T) {
              return y * Math.sqrt(1 - (c = c / T - 1) * c) + h;
            },
          ],
          "ease-in-out-circ": [
            "cubic-bezier(0.785, 0.135, 0.150, 0.860)",
            function (c, h, y, T) {
              return (c /= T / 2) < 1
                ? (-y / 2) * (Math.sqrt(1 - c * c) - 1) + h
                : (y / 2) * (Math.sqrt(1 - (c -= 2) * c) + 1) + h;
            },
          ],
          "ease-in-back": [
            "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
            function (c, h, y, T, x) {
              return (
                x === void 0 && (x = 1.70158),
                y * (c /= T) * c * ((x + 1) * c - x) + h
              );
            },
          ],
          "ease-out-back": [
            "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
            function (c, h, y, T, x) {
              return (
                x === void 0 && (x = 1.70158),
                y * ((c = c / T - 1) * c * ((x + 1) * c + x) + 1) + h
              );
            },
          ],
          "ease-in-out-back": [
            "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
            function (c, h, y, T, x) {
              return (
                x === void 0 && (x = 1.70158),
                (c /= T / 2) < 1
                  ? (y / 2) * c * c * (((x *= 1.525) + 1) * c - x) + h
                  : (y / 2) *
                      ((c -= 2) * c * (((x *= 1.525) + 1) * c + x) + 2) +
                    h
              );
            },
          ],
        },
        E = {
          "ease-in-back": "cubic-bezier(0.600, 0, 0.735, 0.045)",
          "ease-out-back": "cubic-bezier(0.175, 0.885, 0.320, 1)",
          "ease-in-out-back": "cubic-bezier(0.680, 0, 0.265, 1)",
        },
        I = document,
        v = window,
        b = "bkwld-tram",
        m = /[\-\.0-9]/g,
        O = /[A-Z]/,
        A = "number",
        P = /^(rgb|#)/,
        L = /(em|cm|mm|in|pt|pc|px)$/,
        R = /(em|cm|mm|in|pt|pc|px|%)$/,
        D = /(deg|rad|turn)$/,
        F = "unitless",
        G = /(all|none) 0s ease 0s/,
        U = /^(width|height)$/,
        B = " ",
        C = I.createElement("a"),
        _ = ["Webkit", "Moz", "O", "ms"],
        w = ["-webkit-", "-moz-", "-o-", "-ms-"],
        q = function (c) {
          if (c in C.style) return { dom: c, css: c };
          var h,
            y,
            T = "",
            x = c.split("-");
          for (h = 0; h < x.length; h++)
            T += x[h].charAt(0).toUpperCase() + x[h].slice(1);
          for (h = 0; h < _.length; h++)
            if (((y = _[h] + T), y in C.style))
              return { dom: y, css: w[h] + c };
        },
        M = (t.support = {
          bind: Function.prototype.bind,
          transform: q("transform"),
          transition: q("transition"),
          backface: q("backface-visibility"),
          timing: q("transition-timing-function"),
        });
      if (M.transition) {
        var W = M.timing.dom;
        if (((C.style[W] = d["ease-in-back"][0]), !C.style[W]))
          for (var k in E) d[k][0] = E[k];
      }
      var J = (t.frame = (function () {
          var c =
            v.requestAnimationFrame ||
            v.webkitRequestAnimationFrame ||
            v.mozRequestAnimationFrame ||
            v.oRequestAnimationFrame ||
            v.msRequestAnimationFrame;
          return c && M.bind
            ? c.bind(v)
            : function (h) {
                v.setTimeout(h, 16);
              };
        })()),
        Te = (t.now = (function () {
          var c = v.performance,
            h = c && (c.now || c.webkitNow || c.msNow || c.mozNow);
          return h && M.bind
            ? h.bind(c)
            : Date.now ||
                function () {
                  return +new Date();
                };
        })()),
        Ke = p(function (c) {
          function h(V, Y) {
            var re = g(("" + V).split(B)),
              Q = re[0];
            Y = Y || {};
            var de = Dr[Q];
            if (!de) return l("Unsupported property: " + Q);
            if (!Y.weak || !this.props[Q]) {
              var Oe = de[0],
                ye = this.props[Q];
              return (
                ye || (ye = this.props[Q] = new Oe.Bare()),
                ye.init(this.$el, re, de, Y),
                ye
              );
            }
          }
          function y(V, Y, re) {
            if (V) {
              var Q = typeof V;
              if (
                (Y ||
                  (this.timer && this.timer.destroy(),
                  (this.queue = []),
                  (this.active = !1)),
                Q == "number" && Y)
              )
                return (
                  (this.timer = new vn({
                    duration: V,
                    context: this,
                    complete: S,
                  })),
                  void (this.active = !0)
                );
              if (Q == "string" && Y) {
                switch (V) {
                  case "hide":
                    N.call(this);
                    break;
                  case "stop":
                    X.call(this);
                    break;
                  case "redraw":
                    K.call(this);
                    break;
                  default:
                    h.call(this, V, re && re[1]);
                }
                return S.call(this);
              }
              if (Q == "function") return void V.call(this, this);
              if (Q == "object") {
                var de = 0;
                Ne.call(
                  this,
                  V,
                  function (ae, SE) {
                    ae.span > de && (de = ae.span), ae.stop(), ae.animate(SE);
                  },
                  function (ae) {
                    "wait" in ae && (de = u(ae.wait, 0));
                  }
                ),
                  oe.call(this),
                  de > 0 &&
                    ((this.timer = new vn({ duration: de, context: this })),
                    (this.active = !0),
                    Y && (this.timer.complete = S));
                var Oe = this,
                  ye = !1,
                  _n = {};
                J(function () {
                  Ne.call(Oe, V, function (ae) {
                    ae.active && ((ye = !0), (_n[ae.name] = ae.nextStyle));
                  }),
                    ye && Oe.$el.css(_n);
                });
              }
            }
          }
          function T(V) {
            (V = u(V, 0)),
              this.active
                ? this.queue.push({ options: V })
                : ((this.timer = new vn({
                    duration: V,
                    context: this,
                    complete: S,
                  })),
                  (this.active = !0));
          }
          function x(V) {
            return this.active
              ? (this.queue.push({ options: V, args: arguments }),
                void (this.timer.complete = S))
              : l(
                  "No active transition timer. Use start() or wait() before then()."
                );
          }
          function S() {
            if (
              (this.timer && this.timer.destroy(),
              (this.active = !1),
              this.queue.length)
            ) {
              var V = this.queue.shift();
              y.call(this, V.options, !0, V.args);
            }
          }
          function X(V) {
            this.timer && this.timer.destroy(),
              (this.queue = []),
              (this.active = !1);
            var Y;
            typeof V == "string"
              ? ((Y = {}), (Y[V] = 1))
              : (Y = typeof V == "object" && V != null ? V : this.props),
              Ne.call(this, Y, fe),
              oe.call(this);
          }
          function H(V) {
            X.call(this, V), Ne.call(this, V, Bt, AE);
          }
          function te(V) {
            typeof V != "string" && (V = "block"), (this.el.style.display = V);
          }
          function N() {
            X.call(this), (this.el.style.display = "none");
          }
          function K() {
            this.el.offsetHeight;
          }
          function j() {
            X.call(this), e.removeData(this.el, b), (this.$el = this.el = null);
          }
          function oe() {
            var V,
              Y,
              re = [];
            this.upstream && re.push(this.upstream);
            for (V in this.props)
              (Y = this.props[V]), Y.active && re.push(Y.string);
            (re = re.join(",")),
              this.style !== re &&
                ((this.style = re), (this.el.style[M.transition.dom] = re));
          }
          function Ne(V, Y, re) {
            var Q,
              de,
              Oe,
              ye,
              _n = Y !== fe,
              ae = {};
            for (Q in V)
              (Oe = V[Q]),
                Q in je
                  ? (ae.transform || (ae.transform = {}),
                    (ae.transform[Q] = Oe))
                  : (O.test(Q) && (Q = n(Q)),
                    Q in Dr ? (ae[Q] = Oe) : (ye || (ye = {}), (ye[Q] = Oe)));
            for (Q in ae) {
              if (((Oe = ae[Q]), (de = this.props[Q]), !de)) {
                if (!_n) continue;
                de = h.call(this, Q);
              }
              Y.call(this, de, Oe);
            }
            re && ye && re.call(this, ye);
          }
          function fe(V) {
            V.stop();
          }
          function Bt(V, Y) {
            V.set(Y);
          }
          function AE(V) {
            this.$el.css(V);
          }
          function Se(V, Y) {
            c[V] = function () {
              return this.children
                ? bE.call(this, Y, arguments)
                : (this.el && Y.apply(this, arguments), this);
            };
          }
          function bE(V, Y) {
            var re,
              Q = this.children.length;
            for (re = 0; Q > re; re++) V.apply(this.children[re], Y);
            return this;
          }
          (c.init = function (V) {
            if (
              ((this.$el = e(V)),
              (this.el = this.$el[0]),
              (this.props = {}),
              (this.queue = []),
              (this.style = ""),
              (this.active = !1),
              Ee.keepInherited && !Ee.fallback)
            ) {
              var Y = Jo(this.el, "transition");
              Y && !G.test(Y) && (this.upstream = Y);
            }
            M.backface &&
              Ee.hideBackface &&
              lt(this.el, M.backface.css, "hidden");
          }),
            Se("add", h),
            Se("start", y),
            Se("wait", T),
            Se("then", x),
            Se("next", S),
            Se("stop", X),
            Se("set", H),
            Se("show", te),
            Se("hide", N),
            Se("redraw", K),
            Se("destroy", j);
        }),
        le = p(Ke, function (c) {
          function h(y, T) {
            var x = e.data(y, b) || e.data(y, b, new Ke.Bare());
            return x.el || x.init(y), T ? x.start(T) : x;
          }
          c.init = function (y, T) {
            var x = e(y);
            if (!x.length) return this;
            if (x.length === 1) return h(x[0], T);
            var S = [];
            return (
              x.each(function (X, H) {
                S.push(h(H, T));
              }),
              (this.children = S),
              this
            );
          };
        }),
        z = p(function (c) {
          function h() {
            var S = this.get();
            this.update("auto");
            var X = this.get();
            return this.update(S), X;
          }
          function y(S, X, H) {
            return X !== void 0 && (H = X), S in d ? S : H;
          }
          function T(S) {
            var X = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(S);
            return (X ? i(X[1], X[2], X[3]) : S).replace(
              /#(\w)(\w)(\w)$/,
              "#$1$1$2$2$3$3"
            );
          }
          var x = { duration: 500, ease: "ease", delay: 0 };
          (c.init = function (S, X, H, te) {
            (this.$el = S), (this.el = S[0]);
            var N = X[0];
            H[2] && (N = H[2]),
              ea[N] && (N = ea[N]),
              (this.name = N),
              (this.type = H[1]),
              (this.duration = u(X[1], this.duration, x.duration)),
              (this.ease = y(X[2], this.ease, x.ease)),
              (this.delay = u(X[3], this.delay, x.delay)),
              (this.span = this.duration + this.delay),
              (this.active = !1),
              (this.nextStyle = null),
              (this.auto = U.test(this.name)),
              (this.unit = te.unit || this.unit || Ee.defaultUnit),
              (this.angle = te.angle || this.angle || Ee.defaultAngle),
              Ee.fallback || te.fallback
                ? (this.animate = this.fallback)
                : ((this.animate = this.transition),
                  (this.string =
                    this.name +
                    B +
                    this.duration +
                    "ms" +
                    (this.ease != "ease" ? B + d[this.ease][0] : "") +
                    (this.delay ? B + this.delay + "ms" : "")));
          }),
            (c.set = function (S) {
              (S = this.convert(S, this.type)), this.update(S), this.redraw();
            }),
            (c.transition = function (S) {
              (this.active = !0),
                (S = this.convert(S, this.type)),
                this.auto &&
                  (this.el.style[this.name] == "auto" &&
                    (this.update(this.get()), this.redraw()),
                  S == "auto" && (S = h.call(this))),
                (this.nextStyle = S);
            }),
            (c.fallback = function (S) {
              var X =
                this.el.style[this.name] || this.convert(this.get(), this.type);
              (S = this.convert(S, this.type)),
                this.auto &&
                  (X == "auto" && (X = this.convert(this.get(), this.type)),
                  S == "auto" && (S = h.call(this))),
                (this.tween = new Ut({
                  from: X,
                  to: S,
                  duration: this.duration,
                  delay: this.delay,
                  ease: this.ease,
                  update: this.update,
                  context: this,
                }));
            }),
            (c.get = function () {
              return Jo(this.el, this.name);
            }),
            (c.update = function (S) {
              lt(this.el, this.name, S);
            }),
            (c.stop = function () {
              (this.active || this.nextStyle) &&
                ((this.active = !1),
                (this.nextStyle = null),
                lt(this.el, this.name, this.get()));
              var S = this.tween;
              S && S.context && S.destroy();
            }),
            (c.convert = function (S, X) {
              if (S == "auto" && this.auto) return S;
              var H,
                te = typeof S == "number",
                N = typeof S == "string";
              switch (X) {
                case A:
                  if (te) return S;
                  if (N && S.replace(m, "") === "") return +S;
                  H = "number(unitless)";
                  break;
                case P:
                  if (N) {
                    if (S === "" && this.original) return this.original;
                    if (X.test(S))
                      return S.charAt(0) == "#" && S.length == 7 ? S : T(S);
                  }
                  H = "hex or rgb string";
                  break;
                case L:
                  if (te) return S + this.unit;
                  if (N && X.test(S)) return S;
                  H = "number(px) or string(unit)";
                  break;
                case R:
                  if (te) return S + this.unit;
                  if (N && X.test(S)) return S;
                  H = "number(px) or string(unit or %)";
                  break;
                case D:
                  if (te) return S + this.angle;
                  if (N && X.test(S)) return S;
                  H = "number(deg) or string(angle)";
                  break;
                case F:
                  if (te || (N && R.test(S))) return S;
                  H = "number(unitless) or string(unit or %)";
              }
              return a(H, S), S;
            }),
            (c.redraw = function () {
              this.el.offsetHeight;
            });
        }),
        be = p(z, function (c, h) {
          c.init = function () {
            h.init.apply(this, arguments),
              this.original || (this.original = this.convert(this.get(), P));
          };
        }),
        Vt = p(z, function (c, h) {
          (c.init = function () {
            h.init.apply(this, arguments), (this.animate = this.fallback);
          }),
            (c.get = function () {
              return this.$el[this.name]();
            }),
            (c.update = function (y) {
              this.$el[this.name](y);
            });
        }),
        mn = p(z, function (c, h) {
          function y(T, x) {
            var S, X, H, te, N;
            for (S in T)
              (te = je[S]),
                (H = te[0]),
                (X = te[1] || S),
                (N = this.convert(T[S], H)),
                x.call(this, X, N, H);
          }
          (c.init = function () {
            h.init.apply(this, arguments),
              this.current ||
                ((this.current = {}),
                je.perspective &&
                  Ee.perspective &&
                  ((this.current.perspective = Ee.perspective),
                  lt(this.el, this.name, this.style(this.current)),
                  this.redraw()));
          }),
            (c.set = function (T) {
              y.call(this, T, function (x, S) {
                this.current[x] = S;
              }),
                lt(this.el, this.name, this.style(this.current)),
                this.redraw();
            }),
            (c.transition = function (T) {
              var x = this.values(T);
              this.tween = new Zo({
                current: this.current,
                values: x,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
              });
              var S,
                X = {};
              for (S in this.current) X[S] = S in x ? x[S] : this.current[S];
              (this.active = !0), (this.nextStyle = this.style(X));
            }),
            (c.fallback = function (T) {
              var x = this.values(T);
              this.tween = new Zo({
                current: this.current,
                values: x,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
                update: this.update,
                context: this,
              });
            }),
            (c.update = function () {
              lt(this.el, this.name, this.style(this.current));
            }),
            (c.style = function (T) {
              var x,
                S = "";
              for (x in T) S += x + "(" + T[x] + ") ";
              return S;
            }),
            (c.values = function (T) {
              var x,
                S = {};
              return (
                y.call(this, T, function (X, H, te) {
                  (S[X] = H),
                    this.current[X] === void 0 &&
                      ((x = 0),
                      ~X.indexOf("scale") && (x = 1),
                      (this.current[X] = this.convert(x, te)));
                }),
                S
              );
            });
        }),
        Ut = p(function (c) {
          function h(N) {
            H.push(N) === 1 && J(y);
          }
          function y() {
            var N,
              K,
              j,
              oe = H.length;
            if (oe)
              for (J(y), K = Te(), N = oe; N--; ) (j = H[N]), j && j.render(K);
          }
          function T(N) {
            var K,
              j = e.inArray(N, H);
            j >= 0 &&
              ((K = H.slice(j + 1)),
              (H.length = j),
              K.length && (H = H.concat(K)));
          }
          function x(N) {
            return Math.round(N * te) / te;
          }
          function S(N, K, j) {
            return i(
              N[0] + j * (K[0] - N[0]),
              N[1] + j * (K[1] - N[1]),
              N[2] + j * (K[2] - N[2])
            );
          }
          var X = { ease: d.ease[1], from: 0, to: 1 };
          (c.init = function (N) {
            (this.duration = N.duration || 0), (this.delay = N.delay || 0);
            var K = N.ease || X.ease;
            d[K] && (K = d[K][1]),
              typeof K != "function" && (K = X.ease),
              (this.ease = K),
              (this.update = N.update || o),
              (this.complete = N.complete || o),
              (this.context = N.context || this),
              (this.name = N.name);
            var j = N.from,
              oe = N.to;
            j === void 0 && (j = X.from),
              oe === void 0 && (oe = X.to),
              (this.unit = N.unit || ""),
              typeof j == "number" && typeof oe == "number"
                ? ((this.begin = j), (this.change = oe - j))
                : this.format(oe, j),
              (this.value = this.begin + this.unit),
              (this.start = Te()),
              N.autoplay !== !1 && this.play();
          }),
            (c.play = function () {
              this.active ||
                (this.start || (this.start = Te()),
                (this.active = !0),
                h(this));
            }),
            (c.stop = function () {
              this.active && ((this.active = !1), T(this));
            }),
            (c.render = function (N) {
              var K,
                j = N - this.start;
              if (this.delay) {
                if (j <= this.delay) return;
                j -= this.delay;
              }
              if (j < this.duration) {
                var oe = this.ease(j, 0, 1, this.duration);
                return (
                  (K = this.startRGB
                    ? S(this.startRGB, this.endRGB, oe)
                    : x(this.begin + oe * this.change)),
                  (this.value = K + this.unit),
                  void this.update.call(this.context, this.value)
                );
              }
              (K = this.endHex || this.begin + this.change),
                (this.value = K + this.unit),
                this.update.call(this.context, this.value),
                this.complete.call(this.context),
                this.destroy();
            }),
            (c.format = function (N, K) {
              if (((K += ""), (N += ""), N.charAt(0) == "#"))
                return (
                  (this.startRGB = r(K)),
                  (this.endRGB = r(N)),
                  (this.endHex = N),
                  (this.begin = 0),
                  void (this.change = 1)
                );
              if (!this.unit) {
                var j = K.replace(m, ""),
                  oe = N.replace(m, "");
                j !== oe && s("tween", K, N), (this.unit = j);
              }
              (K = parseFloat(K)),
                (N = parseFloat(N)),
                (this.begin = this.value = K),
                (this.change = N - K);
            }),
            (c.destroy = function () {
              this.stop(),
                (this.context = null),
                (this.ease = this.update = this.complete = o);
            });
          var H = [],
            te = 1e3;
        }),
        vn = p(Ut, function (c) {
          (c.init = function (h) {
            (this.duration = h.duration || 0),
              (this.complete = h.complete || o),
              (this.context = h.context),
              this.play();
          }),
            (c.render = function (h) {
              var y = h - this.start;
              y < this.duration ||
                (this.complete.call(this.context), this.destroy());
            });
        }),
        Zo = p(Ut, function (c, h) {
          (c.init = function (y) {
            (this.context = y.context),
              (this.update = y.update),
              (this.tweens = []),
              (this.current = y.current);
            var T, x;
            for (T in y.values)
              (x = y.values[T]),
                this.current[T] !== x &&
                  this.tweens.push(
                    new Ut({
                      name: T,
                      from: this.current[T],
                      to: x,
                      duration: y.duration,
                      delay: y.delay,
                      ease: y.ease,
                      autoplay: !1,
                    })
                  );
            this.play();
          }),
            (c.render = function (y) {
              var T,
                x,
                S = this.tweens.length,
                X = !1;
              for (T = S; T--; )
                (x = this.tweens[T]),
                  x.context &&
                    (x.render(y), (this.current[x.name] = x.value), (X = !0));
              return X
                ? void (this.update && this.update.call(this.context))
                : this.destroy();
            }),
            (c.destroy = function () {
              if ((h.destroy.call(this), this.tweens)) {
                var y,
                  T = this.tweens.length;
                for (y = T; y--; ) this.tweens[y].destroy();
                (this.tweens = null), (this.current = null);
              }
            });
        }),
        Ee = (t.config = {
          debug: !1,
          defaultUnit: "px",
          defaultAngle: "deg",
          keepInherited: !1,
          hideBackface: !1,
          perspective: "",
          fallback: !M.transition,
          agentTests: [],
        });
      (t.fallback = function (c) {
        if (!M.transition) return (Ee.fallback = !0);
        Ee.agentTests.push("(" + c + ")");
        var h = new RegExp(Ee.agentTests.join("|"), "i");
        Ee.fallback = h.test(navigator.userAgent);
      }),
        t.fallback("6.0.[2-5] Safari"),
        (t.tween = function (c) {
          return new Ut(c);
        }),
        (t.delay = function (c, h, y) {
          return new vn({ complete: h, duration: c, context: y });
        }),
        (e.fn.tram = function (c) {
          return t.call(null, this, c);
        });
      var lt = e.style,
        Jo = e.css,
        ea = { transform: M.transform && M.transform.css },
        Dr = {
          color: [be, P],
          background: [be, P, "background-color"],
          "outline-color": [be, P],
          "border-color": [be, P],
          "border-top-color": [be, P],
          "border-right-color": [be, P],
          "border-bottom-color": [be, P],
          "border-left-color": [be, P],
          "border-width": [z, L],
          "border-top-width": [z, L],
          "border-right-width": [z, L],
          "border-bottom-width": [z, L],
          "border-left-width": [z, L],
          "border-spacing": [z, L],
          "letter-spacing": [z, L],
          margin: [z, L],
          "margin-top": [z, L],
          "margin-right": [z, L],
          "margin-bottom": [z, L],
          "margin-left": [z, L],
          padding: [z, L],
          "padding-top": [z, L],
          "padding-right": [z, L],
          "padding-bottom": [z, L],
          "padding-left": [z, L],
          "outline-width": [z, L],
          opacity: [z, A],
          top: [z, R],
          right: [z, R],
          bottom: [z, R],
          left: [z, R],
          "font-size": [z, R],
          "text-indent": [z, R],
          "word-spacing": [z, R],
          width: [z, R],
          "min-width": [z, R],
          "max-width": [z, R],
          height: [z, R],
          "min-height": [z, R],
          "max-height": [z, R],
          "line-height": [z, F],
          "scroll-top": [Vt, A, "scrollTop"],
          "scroll-left": [Vt, A, "scrollLeft"],
        },
        je = {};
      M.transform &&
        ((Dr.transform = [mn]),
        (je = {
          x: [R, "translateX"],
          y: [R, "translateY"],
          rotate: [D],
          rotateX: [D],
          rotateY: [D],
          scale: [A],
          scaleX: [A],
          scaleY: [A],
          skew: [D],
          skewX: [D],
          skewY: [D],
        })),
        M.transform &&
          M.backface &&
          ((je.z = [R, "translateZ"]),
          (je.rotateZ = [D]),
          (je.scaleZ = [A]),
          (je.perspective = [L]));
      var TE = /ms/,
        ta = /s|\./;
      return (e.tram = t);
    })(window.jQuery);
  });
  var ia = f((aF, ra) => {
    "use strict";
    var PE = window.$,
      LE = Fr() && PE.tram;
    ra.exports = (function () {
      var e = {};
      e.VERSION = "1.6.0-Webflow";
      var t = {},
        n = Array.prototype,
        r = Object.prototype,
        i = Function.prototype,
        o = n.push,
        a = n.slice,
        s = n.concat,
        u = r.toString,
        l = r.hasOwnProperty,
        g = n.forEach,
        p = n.map,
        d = n.reduce,
        E = n.reduceRight,
        I = n.filter,
        v = n.every,
        b = n.some,
        m = n.indexOf,
        O = n.lastIndexOf,
        A = Array.isArray,
        P = Object.keys,
        L = i.bind,
        R =
          (e.each =
          e.forEach =
            function (_, w, q) {
              if (_ == null) return _;
              if (g && _.forEach === g) _.forEach(w, q);
              else if (_.length === +_.length) {
                for (var M = 0, W = _.length; M < W; M++)
                  if (w.call(q, _[M], M, _) === t) return;
              } else
                for (var k = e.keys(_), M = 0, W = k.length; M < W; M++)
                  if (w.call(q, _[k[M]], k[M], _) === t) return;
              return _;
            });
      (e.map = e.collect =
        function (_, w, q) {
          var M = [];
          return _ == null
            ? M
            : p && _.map === p
            ? _.map(w, q)
            : (R(_, function (W, k, J) {
                M.push(w.call(q, W, k, J));
              }),
              M);
        }),
        (e.find = e.detect =
          function (_, w, q) {
            var M;
            return (
              D(_, function (W, k, J) {
                if (w.call(q, W, k, J)) return (M = W), !0;
              }),
              M
            );
          }),
        (e.filter = e.select =
          function (_, w, q) {
            var M = [];
            return _ == null
              ? M
              : I && _.filter === I
              ? _.filter(w, q)
              : (R(_, function (W, k, J) {
                  w.call(q, W, k, J) && M.push(W);
                }),
                M);
          });
      var D =
        (e.some =
        e.any =
          function (_, w, q) {
            w || (w = e.identity);
            var M = !1;
            return _ == null
              ? M
              : b && _.some === b
              ? _.some(w, q)
              : (R(_, function (W, k, J) {
                  if (M || (M = w.call(q, W, k, J))) return t;
                }),
                !!M);
          });
      (e.contains = e.include =
        function (_, w) {
          return _ == null
            ? !1
            : m && _.indexOf === m
            ? _.indexOf(w) != -1
            : D(_, function (q) {
                return q === w;
              });
        }),
        (e.delay = function (_, w) {
          var q = a.call(arguments, 2);
          return setTimeout(function () {
            return _.apply(null, q);
          }, w);
        }),
        (e.defer = function (_) {
          return e.delay.apply(e, [_, 1].concat(a.call(arguments, 1)));
        }),
        (e.throttle = function (_) {
          var w, q, M;
          return function () {
            w ||
              ((w = !0),
              (q = arguments),
              (M = this),
              LE.frame(function () {
                (w = !1), _.apply(M, q);
              }));
          };
        }),
        (e.debounce = function (_, w, q) {
          var M,
            W,
            k,
            J,
            Te,
            Ke = function () {
              var le = e.now() - J;
              le < w
                ? (M = setTimeout(Ke, w - le))
                : ((M = null), q || ((Te = _.apply(k, W)), (k = W = null)));
            };
          return function () {
            (k = this), (W = arguments), (J = e.now());
            var le = q && !M;
            return (
              M || (M = setTimeout(Ke, w)),
              le && ((Te = _.apply(k, W)), (k = W = null)),
              Te
            );
          };
        }),
        (e.defaults = function (_) {
          if (!e.isObject(_)) return _;
          for (var w = 1, q = arguments.length; w < q; w++) {
            var M = arguments[w];
            for (var W in M) _[W] === void 0 && (_[W] = M[W]);
          }
          return _;
        }),
        (e.keys = function (_) {
          if (!e.isObject(_)) return [];
          if (P) return P(_);
          var w = [];
          for (var q in _) e.has(_, q) && w.push(q);
          return w;
        }),
        (e.has = function (_, w) {
          return l.call(_, w);
        }),
        (e.isObject = function (_) {
          return _ === Object(_);
        }),
        (e.now =
          Date.now ||
          function () {
            return new Date().getTime();
          }),
        (e.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g,
        });
      var F = /(.)^/,
        G = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029",
        },
        U = /\\|'|\r|\n|\u2028|\u2029/g,
        B = function (_) {
          return "\\" + G[_];
        },
        C = /^\s*(\w|\$)+\s*$/;
      return (
        (e.template = function (_, w, q) {
          !w && q && (w = q), (w = e.defaults({}, w, e.templateSettings));
          var M = RegExp(
              [
                (w.escape || F).source,
                (w.interpolate || F).source,
                (w.evaluate || F).source,
              ].join("|") + "|$",
              "g"
            ),
            W = 0,
            k = "__p+='";
          _.replace(M, function (le, z, be, Vt, mn) {
            return (
              (k += _.slice(W, mn).replace(U, B)),
              (W = mn + le.length),
              z
                ? (k +=
                    `'+
((__t=(` +
                    z +
                    `))==null?'':_.escape(__t))+
'`)
                : be
                ? (k +=
                    `'+
((__t=(` +
                    be +
                    `))==null?'':__t)+
'`)
                : Vt &&
                  (k +=
                    `';
` +
                    Vt +
                    `
__p+='`),
              le
            );
          }),
            (k += `';
`);
          var J = w.variable;
          if (J) {
            if (!C.test(J))
              throw new Error("variable is not a bare identifier: " + J);
          } else
            (k =
              `with(obj||{}){
` +
              k +
              `}
`),
              (J = "obj");
          k =
            `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` +
            k +
            `return __p;
`;
          var Te;
          try {
            Te = new Function(w.variable || "obj", "_", k);
          } catch (le) {
            throw ((le.source = k), le);
          }
          var Ke = function (le) {
            return Te.call(this, le, e);
          };
          return (
            (Ke.source =
              "function(" +
              J +
              `){
` +
              k +
              "}"),
            Ke
          );
        }),
        e
      );
    })();
  });
  var $e = f((sF, da) => {
    "use strict";
    var Z = {},
      ft = {},
      dt = [],
      Gr = window.Webflow || [],
      Ye = window.jQuery,
      Re = Ye(window),
      NE = Ye(document),
      De = Ye.isFunction,
      xe = (Z._ = ia()),
      aa = (Z.tram = Fr() && Ye.tram),
      An = !1,
      Xr = !1;
    aa.config.hideBackface = !1;
    aa.config.keepInherited = !0;
    Z.define = function (e, t, n) {
      ft[e] && ua(ft[e]);
      var r = (ft[e] = t(Ye, xe, n) || {});
      return sa(r), r;
    };
    Z.require = function (e) {
      return ft[e];
    };
    function sa(e) {
      Z.env() &&
        (De(e.design) && Re.on("__wf_design", e.design),
        De(e.preview) && Re.on("__wf_preview", e.preview)),
        De(e.destroy) && Re.on("__wf_destroy", e.destroy),
        e.ready && De(e.ready) && ME(e);
    }
    function ME(e) {
      if (An) {
        e.ready();
        return;
      }
      xe.contains(dt, e.ready) || dt.push(e.ready);
    }
    function ua(e) {
      De(e.design) && Re.off("__wf_design", e.design),
        De(e.preview) && Re.off("__wf_preview", e.preview),
        De(e.destroy) && Re.off("__wf_destroy", e.destroy),
        e.ready && De(e.ready) && DE(e);
    }
    function DE(e) {
      dt = xe.filter(dt, function (t) {
        return t !== e.ready;
      });
    }
    Z.push = function (e) {
      if (An) {
        De(e) && e();
        return;
      }
      Gr.push(e);
    };
    Z.env = function (e) {
      var t = window.__wf_design,
        n = typeof t < "u";
      if (!e) return n;
      if (e === "design") return n && t;
      if (e === "preview") return n && !t;
      if (e === "slug") return n && window.__wf_slug;
      if (e === "editor") return window.WebflowEditor;
      if (e === "test") return window.__wf_test;
      if (e === "frame") return window !== window.top;
    };
    var Tn = navigator.userAgent.toLowerCase(),
      ca = (Z.env.touch =
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch)),
      FE = (Z.env.chrome =
        /chrome/.test(Tn) &&
        /Google/.test(navigator.vendor) &&
        parseInt(Tn.match(/chrome\/(\d+)\./)[1], 10)),
      qE = (Z.env.ios = /(ipod|iphone|ipad)/.test(Tn));
    Z.env.safari = /safari/.test(Tn) && !FE && !qE;
    var qr;
    ca &&
      NE.on("touchstart mousedown", function (e) {
        qr = e.target;
      });
    Z.validClick = ca
      ? function (e) {
          return e === qr || Ye.contains(e, qr);
        }
      : function () {
          return !0;
        };
    var la = "resize.webflow orientationchange.webflow load.webflow",
      GE = "scroll.webflow " + la;
    Z.resize = Vr(Re, la);
    Z.scroll = Vr(Re, GE);
    Z.redraw = Vr();
    function Vr(e, t) {
      var n = [],
        r = {};
      return (
        (r.up = xe.throttle(function (i) {
          xe.each(n, function (o) {
            o(i);
          });
        })),
        e && t && e.on(t, r.up),
        (r.on = function (i) {
          typeof i == "function" && (xe.contains(n, i) || n.push(i));
        }),
        (r.off = function (i) {
          if (!arguments.length) {
            n = [];
            return;
          }
          n = xe.filter(n, function (o) {
            return o !== i;
          });
        }),
        r
      );
    }
    Z.location = function (e) {
      window.location = e;
    };
    Z.env() && (Z.location = function () {});
    Z.ready = function () {
      (An = !0), Xr ? XE() : xe.each(dt, oa), xe.each(Gr, oa), Z.resize.up();
    };
    function oa(e) {
      De(e) && e();
    }
    function XE() {
      (Xr = !1), xe.each(ft, sa);
    }
    var nt;
    Z.load = function (e) {
      nt.then(e);
    };
    function fa() {
      nt && (nt.reject(), Re.off("load", nt.resolve)),
        (nt = new Ye.Deferred()),
        Re.on("load", nt.resolve);
    }
    Z.destroy = function (e) {
      (e = e || {}),
        (Xr = !0),
        Re.triggerHandler("__wf_destroy"),
        e.domready != null && (An = e.domready),
        xe.each(ft, ua),
        Z.resize.off(),
        Z.scroll.off(),
        Z.redraw.off(),
        (dt = []),
        (Gr = []),
        nt.state() === "pending" && fa();
    };
    Ye(Z.ready);
    fa();
    da.exports = window.Webflow = Z;
  });
  var ha = f((uF, ga) => {
    "use strict";
    var pa = $e();
    pa.define(
      "brand",
      (ga.exports = function (e) {
        var t = {},
          n = document,
          r = e("html"),
          i = e("body"),
          o = ".w-webflow-badge",
          a = window.location,
          s = /PhantomJS/i.test(navigator.userAgent),
          u =
            "fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange",
          l;
        t.ready = function () {
          var E = r.attr("data-wf-status"),
            I = r.attr("data-wf-domain") || "";
          /\.webflow\.io$/i.test(I) && a.hostname !== I && (E = !0),
            E &&
              !s &&
              ((l = l || p()),
              d(),
              setTimeout(d, 500),
              e(n).off(u, g).on(u, g));
        };
        function g() {
          var E =
            n.fullScreen ||
            n.mozFullScreen ||
            n.webkitIsFullScreen ||
            n.msFullscreenElement ||
            !!n.webkitFullscreenElement;
          e(l).attr("style", E ? "display: none !important;" : "");
        }
        function p() {
          var E = e('<a class="w-webflow-badge"></a>').attr(
              "href",
              "https://webflow.com?utm_campaign=brandjs"
            ),
            I = e("<img>")
              .attr(
                "src",
                "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-icon-d2.89e12c322e.svg"
              )
              .attr("alt", "")
              .css({ marginRight: "4px", width: "26px" }),
            v = e("<img>")
              .attr(
                "src",
                "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-text-d2.c82cec3b78.svg"
              )
              .attr("alt", "Made in Webflow");
          return E.append(I, v), E[0];
        }
        function d() {
          var E = i.children(o),
            I = E.length && E.get(0) === l,
            v = pa.env("editor");
          if (I) {
            v && E.remove();
            return;
          }
          E.length && E.remove(), v || i.append(l);
        }
        return t;
      })
    );
  });
  var ya = f((cF, Ea) => {
    "use strict";
    var VE = $e();
    VE.define(
      "focus-visible",
      (Ea.exports = function () {
        function e(n) {
          var r = !0,
            i = !1,
            o = null,
            a = {
              text: !0,
              search: !0,
              url: !0,
              tel: !0,
              email: !0,
              password: !0,
              number: !0,
              date: !0,
              month: !0,
              week: !0,
              time: !0,
              datetime: !0,
              "datetime-local": !0,
            };
          function s(A) {
            return !!(
              A &&
              A !== document &&
              A.nodeName !== "HTML" &&
              A.nodeName !== "BODY" &&
              "classList" in A &&
              "contains" in A.classList
            );
          }
          function u(A) {
            var P = A.type,
              L = A.tagName;
            return !!(
              (L === "INPUT" && a[P] && !A.readOnly) ||
              (L === "TEXTAREA" && !A.readOnly) ||
              A.isContentEditable
            );
          }
          function l(A) {
            A.getAttribute("data-wf-focus-visible") ||
              A.setAttribute("data-wf-focus-visible", "true");
          }
          function g(A) {
            A.getAttribute("data-wf-focus-visible") &&
              A.removeAttribute("data-wf-focus-visible");
          }
          function p(A) {
            A.metaKey ||
              A.altKey ||
              A.ctrlKey ||
              (s(n.activeElement) && l(n.activeElement), (r = !0));
          }
          function d() {
            r = !1;
          }
          function E(A) {
            s(A.target) && (r || u(A.target)) && l(A.target);
          }
          function I(A) {
            s(A.target) &&
              A.target.hasAttribute("data-wf-focus-visible") &&
              ((i = !0),
              window.clearTimeout(o),
              (o = window.setTimeout(function () {
                i = !1;
              }, 100)),
              g(A.target));
          }
          function v() {
            document.visibilityState === "hidden" && (i && (r = !0), b());
          }
          function b() {
            document.addEventListener("mousemove", O),
              document.addEventListener("mousedown", O),
              document.addEventListener("mouseup", O),
              document.addEventListener("pointermove", O),
              document.addEventListener("pointerdown", O),
              document.addEventListener("pointerup", O),
              document.addEventListener("touchmove", O),
              document.addEventListener("touchstart", O),
              document.addEventListener("touchend", O);
          }
          function m() {
            document.removeEventListener("mousemove", O),
              document.removeEventListener("mousedown", O),
              document.removeEventListener("mouseup", O),
              document.removeEventListener("pointermove", O),
              document.removeEventListener("pointerdown", O),
              document.removeEventListener("pointerup", O),
              document.removeEventListener("touchmove", O),
              document.removeEventListener("touchstart", O),
              document.removeEventListener("touchend", O);
          }
          function O(A) {
            (A.target.nodeName && A.target.nodeName.toLowerCase() === "html") ||
              ((r = !1), m());
          }
          document.addEventListener("keydown", p, !0),
            document.addEventListener("mousedown", d, !0),
            document.addEventListener("pointerdown", d, !0),
            document.addEventListener("touchstart", d, !0),
            document.addEventListener("visibilitychange", v, !0),
            b(),
            n.addEventListener("focus", E, !0),
            n.addEventListener("blur", I, !0);
        }
        function t() {
          if (typeof document < "u")
            try {
              document.querySelector(":focus-visible");
            } catch {
              e(document);
            }
        }
        return { ready: t };
      })
    );
  });
  var _a = f((lF, va) => {
    "use strict";
    var ma = $e();
    ma.define(
      "focus",
      (va.exports = function () {
        var e = [],
          t = !1;
        function n(a) {
          t &&
            (a.preventDefault(),
            a.stopPropagation(),
            a.stopImmediatePropagation(),
            e.unshift(a));
        }
        function r(a) {
          var s = a.target,
            u = s.tagName;
          return (
            (/^a$/i.test(u) && s.href != null) ||
            (/^(button|textarea)$/i.test(u) && s.disabled !== !0) ||
            (/^input$/i.test(u) &&
              /^(button|reset|submit|radio|checkbox)$/i.test(s.type) &&
              !s.disabled) ||
            (!/^(button|input|textarea|select|a)$/i.test(u) &&
              !Number.isNaN(Number.parseFloat(s.tabIndex))) ||
            /^audio$/i.test(u) ||
            (/^video$/i.test(u) && s.controls === !0)
          );
        }
        function i(a) {
          r(a) &&
            ((t = !0),
            setTimeout(() => {
              for (t = !1, a.target.focus(); e.length > 0; ) {
                var s = e.pop();
                s.target.dispatchEvent(new MouseEvent(s.type, s));
              }
            }, 0));
        }
        function o() {
          typeof document < "u" &&
            document.body.hasAttribute("data-wf-focus-within") &&
            ma.env.safari &&
            (document.addEventListener("mousedown", i, !0),
            document.addEventListener("mouseup", n, !0),
            document.addEventListener("click", n, !0));
        }
        return { ready: o };
      })
    );
  });
  var Aa = f((fF, Ta) => {
    "use strict";
    var Ur = window.jQuery,
      Fe = {},
      bn = [],
      Ia = ".w-ix",
      Sn = {
        reset: function (e, t) {
          t.__wf_intro = null;
        },
        intro: function (e, t) {
          t.__wf_intro ||
            ((t.__wf_intro = !0), Ur(t).triggerHandler(Fe.types.INTRO));
        },
        outro: function (e, t) {
          t.__wf_intro &&
            ((t.__wf_intro = null), Ur(t).triggerHandler(Fe.types.OUTRO));
        },
      };
    Fe.triggers = {};
    Fe.types = { INTRO: "w-ix-intro" + Ia, OUTRO: "w-ix-outro" + Ia };
    Fe.init = function () {
      for (var e = bn.length, t = 0; t < e; t++) {
        var n = bn[t];
        n[0](0, n[1]);
      }
      (bn = []), Ur.extend(Fe.triggers, Sn);
    };
    Fe.async = function () {
      for (var e in Sn) {
        var t = Sn[e];
        Sn.hasOwnProperty(e) &&
          (Fe.triggers[e] = function (n, r) {
            bn.push([t, r]);
          });
      }
    };
    Fe.async();
    Ta.exports = Fe;
  });
  var xa = f((dF, Oa) => {
    "use strict";
    var Br = Aa();
    function ba(e, t) {
      var n = document.createEvent("CustomEvent");
      n.initCustomEvent(t, !0, !0, null), e.dispatchEvent(n);
    }
    var UE = window.jQuery,
      On = {},
      Sa = ".w-ix",
      BE = {
        reset: function (e, t) {
          Br.triggers.reset(e, t);
        },
        intro: function (e, t) {
          Br.triggers.intro(e, t), ba(t, "COMPONENT_ACTIVE");
        },
        outro: function (e, t) {
          Br.triggers.outro(e, t), ba(t, "COMPONENT_INACTIVE");
        },
      };
    On.triggers = {};
    On.types = { INTRO: "w-ix-intro" + Sa, OUTRO: "w-ix-outro" + Sa };
    UE.extend(On.triggers, BE);
    Oa.exports = On;
  });
  var Hr = f((pF, Ra) => {
    var HE =
      typeof global == "object" && global && global.Object === Object && global;
    Ra.exports = HE;
  });
  var we = f((gF, wa) => {
    var kE = Hr(),
      WE = typeof self == "object" && self && self.Object === Object && self,
      zE = kE || WE || Function("return this")();
    wa.exports = zE;
  });
  var pt = f((hF, Ca) => {
    var KE = we(),
      jE = KE.Symbol;
    Ca.exports = jE;
  });
  var Ma = f((EF, Na) => {
    var Pa = pt(),
      La = Object.prototype,
      YE = La.hasOwnProperty,
      $E = La.toString,
      Ht = Pa ? Pa.toStringTag : void 0;
    function QE(e) {
      var t = YE.call(e, Ht),
        n = e[Ht];
      try {
        e[Ht] = void 0;
        var r = !0;
      } catch {}
      var i = $E.call(e);
      return r && (t ? (e[Ht] = n) : delete e[Ht]), i;
    }
    Na.exports = QE;
  });
  var Fa = f((yF, Da) => {
    var ZE = Object.prototype,
      JE = ZE.toString;
    function ey(e) {
      return JE.call(e);
    }
    Da.exports = ey;
  });
  var Qe = f((mF, Xa) => {
    var qa = pt(),
      ty = Ma(),
      ny = Fa(),
      ry = "[object Null]",
      iy = "[object Undefined]",
      Ga = qa ? qa.toStringTag : void 0;
    function oy(e) {
      return e == null
        ? e === void 0
          ? iy
          : ry
        : Ga && Ga in Object(e)
        ? ty(e)
        : ny(e);
    }
    Xa.exports = oy;
  });
  var kr = f((vF, Va) => {
    function ay(e, t) {
      return function (n) {
        return e(t(n));
      };
    }
    Va.exports = ay;
  });
  var Wr = f((_F, Ua) => {
    var sy = kr(),
      uy = sy(Object.getPrototypeOf, Object);
    Ua.exports = uy;
  });
  var Be = f((IF, Ba) => {
    function cy(e) {
      return e != null && typeof e == "object";
    }
    Ba.exports = cy;
  });
  var zr = f((TF, ka) => {
    var ly = Qe(),
      fy = Wr(),
      dy = Be(),
      py = "[object Object]",
      gy = Function.prototype,
      hy = Object.prototype,
      Ha = gy.toString,
      Ey = hy.hasOwnProperty,
      yy = Ha.call(Object);
    function my(e) {
      if (!dy(e) || ly(e) != py) return !1;
      var t = fy(e);
      if (t === null) return !0;
      var n = Ey.call(t, "constructor") && t.constructor;
      return typeof n == "function" && n instanceof n && Ha.call(n) == yy;
    }
    ka.exports = my;
  });
  var Wa = f((Kr) => {
    "use strict";
    Object.defineProperty(Kr, "__esModule", { value: !0 });
    Kr.default = vy;
    function vy(e) {
      var t,
        n = e.Symbol;
      return (
        typeof n == "function"
          ? n.observable
            ? (t = n.observable)
            : ((t = n("observable")), (n.observable = t))
          : (t = "@@observable"),
        t
      );
    }
  });
  var za = f((Yr, jr) => {
    "use strict";
    Object.defineProperty(Yr, "__esModule", { value: !0 });
    var _y = Wa(),
      Iy = Ty(_y);
    function Ty(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var gt;
    typeof self < "u"
      ? (gt = self)
      : typeof window < "u"
      ? (gt = window)
      : typeof global < "u"
      ? (gt = global)
      : typeof jr < "u"
      ? (gt = jr)
      : (gt = Function("return this")());
    var Ay = (0, Iy.default)(gt);
    Yr.default = Ay;
  });
  var $r = f((kt) => {
    "use strict";
    kt.__esModule = !0;
    kt.ActionTypes = void 0;
    kt.default = $a;
    var by = zr(),
      Sy = Ya(by),
      Oy = za(),
      Ka = Ya(Oy);
    function Ya(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var ja = (kt.ActionTypes = { INIT: "@@redux/INIT" });
    function $a(e, t, n) {
      var r;
      if (
        (typeof t == "function" && typeof n > "u" && ((n = t), (t = void 0)),
        typeof n < "u")
      ) {
        if (typeof n != "function")
          throw new Error("Expected the enhancer to be a function.");
        return n($a)(e, t);
      }
      if (typeof e != "function")
        throw new Error("Expected the reducer to be a function.");
      var i = e,
        o = t,
        a = [],
        s = a,
        u = !1;
      function l() {
        s === a && (s = a.slice());
      }
      function g() {
        return o;
      }
      function p(v) {
        if (typeof v != "function")
          throw new Error("Expected listener to be a function.");
        var b = !0;
        return (
          l(),
          s.push(v),
          function () {
            if (b) {
              (b = !1), l();
              var O = s.indexOf(v);
              s.splice(O, 1);
            }
          }
        );
      }
      function d(v) {
        if (!(0, Sy.default)(v))
          throw new Error(
            "Actions must be plain objects. Use custom middleware for async actions."
          );
        if (typeof v.type > "u")
          throw new Error(
            'Actions may not have an undefined "type" property. Have you misspelled a constant?'
          );
        if (u) throw new Error("Reducers may not dispatch actions.");
        try {
          (u = !0), (o = i(o, v));
        } finally {
          u = !1;
        }
        for (var b = (a = s), m = 0; m < b.length; m++) b[m]();
        return v;
      }
      function E(v) {
        if (typeof v != "function")
          throw new Error("Expected the nextReducer to be a function.");
        (i = v), d({ type: ja.INIT });
      }
      function I() {
        var v,
          b = p;
        return (
          (v = {
            subscribe: function (O) {
              if (typeof O != "object")
                throw new TypeError("Expected the observer to be an object.");
              function A() {
                O.next && O.next(g());
              }
              A();
              var P = b(A);
              return { unsubscribe: P };
            },
          }),
          (v[Ka.default] = function () {
            return this;
          }),
          v
        );
      }
      return (
        d({ type: ja.INIT }),
        (r = { dispatch: d, subscribe: p, getState: g, replaceReducer: E }),
        (r[Ka.default] = I),
        r
      );
    }
  });
  var Zr = f((Qr) => {
    "use strict";
    Qr.__esModule = !0;
    Qr.default = xy;
    function xy(e) {
      typeof console < "u" &&
        typeof console.error == "function" &&
        console.error(e);
      try {
        throw new Error(e);
      } catch {}
    }
  });
  var Ja = f((Jr) => {
    "use strict";
    Jr.__esModule = !0;
    Jr.default = Ly;
    var Qa = $r(),
      Ry = zr(),
      OF = Za(Ry),
      wy = Zr(),
      xF = Za(wy);
    function Za(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function Cy(e, t) {
      var n = t && t.type,
        r = (n && '"' + n.toString() + '"') || "an action";
      return (
        "Given action " +
        r +
        ', reducer "' +
        e +
        '" returned undefined. To ignore an action, you must explicitly return the previous state.'
      );
    }
    function Py(e) {
      Object.keys(e).forEach(function (t) {
        var n = e[t],
          r = n(void 0, { type: Qa.ActionTypes.INIT });
        if (typeof r > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined.'
          );
        var i =
          "@@redux/PROBE_UNKNOWN_ACTION_" +
          Math.random().toString(36).substring(7).split("").join(".");
        if (typeof n(void 0, { type: i }) > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined when probed with a random type. ' +
              ("Don't try to handle " +
                Qa.ActionTypes.INIT +
                ' or other actions in "redux/*" ') +
              "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined."
          );
      });
    }
    function Ly(e) {
      for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
        var i = t[r];
        typeof e[i] == "function" && (n[i] = e[i]);
      }
      var o = Object.keys(n);
      if (!1) var a;
      var s;
      try {
        Py(n);
      } catch (u) {
        s = u;
      }
      return function () {
        var l =
            arguments.length <= 0 || arguments[0] === void 0
              ? {}
              : arguments[0],
          g = arguments[1];
        if (s) throw s;
        if (!1) var p;
        for (var d = !1, E = {}, I = 0; I < o.length; I++) {
          var v = o[I],
            b = n[v],
            m = l[v],
            O = b(m, g);
          if (typeof O > "u") {
            var A = Cy(v, g);
            throw new Error(A);
          }
          (E[v] = O), (d = d || O !== m);
        }
        return d ? E : l;
      };
    }
  });
  var ts = f((ei) => {
    "use strict";
    ei.__esModule = !0;
    ei.default = Ny;
    function es(e, t) {
      return function () {
        return t(e.apply(void 0, arguments));
      };
    }
    function Ny(e, t) {
      if (typeof e == "function") return es(e, t);
      if (typeof e != "object" || e === null)
        throw new Error(
          "bindActionCreators expected an object or a function, instead received " +
            (e === null ? "null" : typeof e) +
            '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?'
        );
      for (var n = Object.keys(e), r = {}, i = 0; i < n.length; i++) {
        var o = n[i],
          a = e[o];
        typeof a == "function" && (r[o] = es(a, t));
      }
      return r;
    }
  });
  var ni = f((ti) => {
    "use strict";
    ti.__esModule = !0;
    ti.default = My;
    function My() {
      for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
        t[n] = arguments[n];
      if (t.length === 0)
        return function (o) {
          return o;
        };
      if (t.length === 1) return t[0];
      var r = t[t.length - 1],
        i = t.slice(0, -1);
      return function () {
        return i.reduceRight(function (o, a) {
          return a(o);
        }, r.apply(void 0, arguments));
      };
    }
  });
  var ns = f((ri) => {
    "use strict";
    ri.__esModule = !0;
    var Dy =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n)
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      };
    ri.default = Xy;
    var Fy = ni(),
      qy = Gy(Fy);
    function Gy(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function Xy() {
      for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
        t[n] = arguments[n];
      return function (r) {
        return function (i, o, a) {
          var s = r(i, o, a),
            u = s.dispatch,
            l = [],
            g = {
              getState: s.getState,
              dispatch: function (d) {
                return u(d);
              },
            };
          return (
            (l = t.map(function (p) {
              return p(g);
            })),
            (u = qy.default.apply(void 0, l)(s.dispatch)),
            Dy({}, s, { dispatch: u })
          );
        };
      };
    }
  });
  var ii = f((Ae) => {
    "use strict";
    Ae.__esModule = !0;
    Ae.compose =
      Ae.applyMiddleware =
      Ae.bindActionCreators =
      Ae.combineReducers =
      Ae.createStore =
        void 0;
    var Vy = $r(),
      Uy = ht(Vy),
      By = Ja(),
      Hy = ht(By),
      ky = ts(),
      Wy = ht(ky),
      zy = ns(),
      Ky = ht(zy),
      jy = ni(),
      Yy = ht(jy),
      $y = Zr(),
      LF = ht($y);
    function ht(e) {
      return e && e.__esModule ? e : { default: e };
    }
    Ae.createStore = Uy.default;
    Ae.combineReducers = Hy.default;
    Ae.bindActionCreators = Wy.default;
    Ae.applyMiddleware = Ky.default;
    Ae.compose = Yy.default;
  });
  var Ce,
    oi,
    qe,
    Qy,
    Zy,
    xn,
    Jy,
    ai = ne(() => {
      "use strict";
      (Ce = {
        NAVBAR_OPEN: "NAVBAR_OPEN",
        NAVBAR_CLOSE: "NAVBAR_CLOSE",
        TAB_ACTIVE: "TAB_ACTIVE",
        TAB_INACTIVE: "TAB_INACTIVE",
        SLIDER_ACTIVE: "SLIDER_ACTIVE",
        SLIDER_INACTIVE: "SLIDER_INACTIVE",
        DROPDOWN_OPEN: "DROPDOWN_OPEN",
        DROPDOWN_CLOSE: "DROPDOWN_CLOSE",
        MOUSE_CLICK: "MOUSE_CLICK",
        MOUSE_SECOND_CLICK: "MOUSE_SECOND_CLICK",
        MOUSE_DOWN: "MOUSE_DOWN",
        MOUSE_UP: "MOUSE_UP",
        MOUSE_OVER: "MOUSE_OVER",
        MOUSE_OUT: "MOUSE_OUT",
        MOUSE_MOVE: "MOUSE_MOVE",
        MOUSE_MOVE_IN_VIEWPORT: "MOUSE_MOVE_IN_VIEWPORT",
        SCROLL_INTO_VIEW: "SCROLL_INTO_VIEW",
        SCROLL_OUT_OF_VIEW: "SCROLL_OUT_OF_VIEW",
        SCROLLING_IN_VIEW: "SCROLLING_IN_VIEW",
        ECOMMERCE_CART_OPEN: "ECOMMERCE_CART_OPEN",
        ECOMMERCE_CART_CLOSE: "ECOMMERCE_CART_CLOSE",
        PAGE_START: "PAGE_START",
        PAGE_FINISH: "PAGE_FINISH",
        PAGE_SCROLL_UP: "PAGE_SCROLL_UP",
        PAGE_SCROLL_DOWN: "PAGE_SCROLL_DOWN",
        PAGE_SCROLL: "PAGE_SCROLL",
      }),
        (oi = { ELEMENT: "ELEMENT", CLASS: "CLASS", PAGE: "PAGE" }),
        (qe = { ELEMENT: "ELEMENT", VIEWPORT: "VIEWPORT" }),
        (Qy = { X_AXIS: "X_AXIS", Y_AXIS: "Y_AXIS" }),
        (Zy = {
          CHILDREN: "CHILDREN",
          SIBLINGS: "SIBLINGS",
          IMMEDIATE_CHILDREN: "IMMEDIATE_CHILDREN",
        }),
        (xn = {
          FADE_EFFECT: "FADE_EFFECT",
          SLIDE_EFFECT: "SLIDE_EFFECT",
          GROW_EFFECT: "GROW_EFFECT",
          SHRINK_EFFECT: "SHRINK_EFFECT",
          SPIN_EFFECT: "SPIN_EFFECT",
          FLY_EFFECT: "FLY_EFFECT",
          POP_EFFECT: "POP_EFFECT",
          FLIP_EFFECT: "FLIP_EFFECT",
          JIGGLE_EFFECT: "JIGGLE_EFFECT",
          PULSE_EFFECT: "PULSE_EFFECT",
          DROP_EFFECT: "DROP_EFFECT",
          BLINK_EFFECT: "BLINK_EFFECT",
          BOUNCE_EFFECT: "BOUNCE_EFFECT",
          FLIP_LEFT_TO_RIGHT_EFFECT: "FLIP_LEFT_TO_RIGHT_EFFECT",
          FLIP_RIGHT_TO_LEFT_EFFECT: "FLIP_RIGHT_TO_LEFT_EFFECT",
          RUBBER_BAND_EFFECT: "RUBBER_BAND_EFFECT",
          JELLO_EFFECT: "JELLO_EFFECT",
          GROW_BIG_EFFECT: "GROW_BIG_EFFECT",
          SHRINK_BIG_EFFECT: "SHRINK_BIG_EFFECT",
          PLUGIN_LOTTIE_EFFECT: "PLUGIN_LOTTIE_EFFECT",
        }),
        (Jy = {
          LEFT: "LEFT",
          RIGHT: "RIGHT",
          BOTTOM: "BOTTOM",
          TOP: "TOP",
          BOTTOM_LEFT: "BOTTOM_LEFT",
          BOTTOM_RIGHT: "BOTTOM_RIGHT",
          TOP_RIGHT: "TOP_RIGHT",
          TOP_LEFT: "TOP_LEFT",
          CLOCKWISE: "CLOCKWISE",
          COUNTER_CLOCKWISE: "COUNTER_CLOCKWISE",
        });
    });
  var pe,
    em,
    Rn = ne(() => {
      "use strict";
      (pe = {
        TRANSFORM_MOVE: "TRANSFORM_MOVE",
        TRANSFORM_SCALE: "TRANSFORM_SCALE",
        TRANSFORM_ROTATE: "TRANSFORM_ROTATE",
        TRANSFORM_SKEW: "TRANSFORM_SKEW",
        STYLE_OPACITY: "STYLE_OPACITY",
        STYLE_SIZE: "STYLE_SIZE",
        STYLE_FILTER: "STYLE_FILTER",
        STYLE_FONT_VARIATION: "STYLE_FONT_VARIATION",
        STYLE_BACKGROUND_COLOR: "STYLE_BACKGROUND_COLOR",
        STYLE_BORDER: "STYLE_BORDER",
        STYLE_TEXT_COLOR: "STYLE_TEXT_COLOR",
        OBJECT_VALUE: "OBJECT_VALUE",
        PLUGIN_LOTTIE: "PLUGIN_LOTTIE",
        PLUGIN_SPLINE: "PLUGIN_SPLINE",
        PLUGIN_RIVE: "PLUGIN_RIVE",
        PLUGIN_VARIABLE: "PLUGIN_VARIABLE",
        GENERAL_DISPLAY: "GENERAL_DISPLAY",
        GENERAL_START_ACTION: "GENERAL_START_ACTION",
        GENERAL_CONTINUOUS_ACTION: "GENERAL_CONTINUOUS_ACTION",
        GENERAL_COMBO_CLASS: "GENERAL_COMBO_CLASS",
        GENERAL_STOP_ACTION: "GENERAL_STOP_ACTION",
        GENERAL_LOOP: "GENERAL_LOOP",
        STYLE_BOX_SHADOW: "STYLE_BOX_SHADOW",
      }),
        (em = {
          ELEMENT: "ELEMENT",
          ELEMENT_CLASS: "ELEMENT_CLASS",
          TRIGGER_ELEMENT: "TRIGGER_ELEMENT",
        });
    });
  var tm,
    rs = ne(() => {
      "use strict";
      tm = {
        MOUSE_CLICK_INTERACTION: "MOUSE_CLICK_INTERACTION",
        MOUSE_HOVER_INTERACTION: "MOUSE_HOVER_INTERACTION",
        MOUSE_MOVE_INTERACTION: "MOUSE_MOVE_INTERACTION",
        SCROLL_INTO_VIEW_INTERACTION: "SCROLL_INTO_VIEW_INTERACTION",
        SCROLLING_IN_VIEW_INTERACTION: "SCROLLING_IN_VIEW_INTERACTION",
        MOUSE_MOVE_IN_VIEWPORT_INTERACTION:
          "MOUSE_MOVE_IN_VIEWPORT_INTERACTION",
        PAGE_IS_SCROLLING_INTERACTION: "PAGE_IS_SCROLLING_INTERACTION",
        PAGE_LOAD_INTERACTION: "PAGE_LOAD_INTERACTION",
        PAGE_SCROLLED_INTERACTION: "PAGE_SCROLLED_INTERACTION",
        NAVBAR_INTERACTION: "NAVBAR_INTERACTION",
        DROPDOWN_INTERACTION: "DROPDOWN_INTERACTION",
        ECOMMERCE_CART_INTERACTION: "ECOMMERCE_CART_INTERACTION",
        TAB_INTERACTION: "TAB_INTERACTION",
        SLIDER_INTERACTION: "SLIDER_INTERACTION",
      };
    });
  var nm,
    rm,
    im,
    om,
    am,
    sm,
    um,
    si,
    is = ne(() => {
      "use strict";
      Rn();
      ({
        TRANSFORM_MOVE: nm,
        TRANSFORM_SCALE: rm,
        TRANSFORM_ROTATE: im,
        TRANSFORM_SKEW: om,
        STYLE_SIZE: am,
        STYLE_FILTER: sm,
        STYLE_FONT_VARIATION: um,
      } = pe),
        (si = {
          [nm]: !0,
          [rm]: !0,
          [im]: !0,
          [om]: !0,
          [am]: !0,
          [sm]: !0,
          [um]: !0,
        });
    });
  var se = {};
  me(se, {
    IX2_ACTION_LIST_PLAYBACK_CHANGED: () => Sm,
    IX2_ANIMATION_FRAME_CHANGED: () => vm,
    IX2_CLEAR_REQUESTED: () => Em,
    IX2_ELEMENT_STATE_CHANGED: () => bm,
    IX2_EVENT_LISTENER_ADDED: () => ym,
    IX2_EVENT_STATE_CHANGED: () => mm,
    IX2_INSTANCE_ADDED: () => Im,
    IX2_INSTANCE_REMOVED: () => Am,
    IX2_INSTANCE_STARTED: () => Tm,
    IX2_MEDIA_QUERIES_DEFINED: () => xm,
    IX2_PARAMETER_CHANGED: () => _m,
    IX2_PLAYBACK_REQUESTED: () => gm,
    IX2_PREVIEW_REQUESTED: () => pm,
    IX2_RAW_DATA_IMPORTED: () => cm,
    IX2_SESSION_INITIALIZED: () => lm,
    IX2_SESSION_STARTED: () => fm,
    IX2_SESSION_STOPPED: () => dm,
    IX2_STOP_REQUESTED: () => hm,
    IX2_TEST_FRAME_RENDERED: () => Rm,
    IX2_VIEWPORT_WIDTH_CHANGED: () => Om,
  });
  var cm,
    lm,
    fm,
    dm,
    pm,
    gm,
    hm,
    Em,
    ym,
    mm,
    vm,
    _m,
    Im,
    Tm,
    Am,
    bm,
    Sm,
    Om,
    xm,
    Rm,
    os = ne(() => {
      "use strict";
      (cm = "IX2_RAW_DATA_IMPORTED"),
        (lm = "IX2_SESSION_INITIALIZED"),
        (fm = "IX2_SESSION_STARTED"),
        (dm = "IX2_SESSION_STOPPED"),
        (pm = "IX2_PREVIEW_REQUESTED"),
        (gm = "IX2_PLAYBACK_REQUESTED"),
        (hm = "IX2_STOP_REQUESTED"),
        (Em = "IX2_CLEAR_REQUESTED"),
        (ym = "IX2_EVENT_LISTENER_ADDED"),
        (mm = "IX2_EVENT_STATE_CHANGED"),
        (vm = "IX2_ANIMATION_FRAME_CHANGED"),
        (_m = "IX2_PARAMETER_CHANGED"),
        (Im = "IX2_INSTANCE_ADDED"),
        (Tm = "IX2_INSTANCE_STARTED"),
        (Am = "IX2_INSTANCE_REMOVED"),
        (bm = "IX2_ELEMENT_STATE_CHANGED"),
        (Sm = "IX2_ACTION_LIST_PLAYBACK_CHANGED"),
        (Om = "IX2_VIEWPORT_WIDTH_CHANGED"),
        (xm = "IX2_MEDIA_QUERIES_DEFINED"),
        (Rm = "IX2_TEST_FRAME_RENDERED");
    });
  var ce = {};
  me(ce, {
    ABSTRACT_NODE: () => Ov,
    AUTO: () => hv,
    BACKGROUND: () => cv,
    BACKGROUND_COLOR: () => uv,
    BAR_DELIMITER: () => mv,
    BORDER_COLOR: () => lv,
    BOUNDARY_SELECTOR: () => Nm,
    CHILDREN: () => vv,
    COLON_DELIMITER: () => yv,
    COLOR: () => fv,
    COMMA_DELIMITER: () => Ev,
    CONFIG_UNIT: () => Um,
    CONFIG_VALUE: () => qm,
    CONFIG_X_UNIT: () => Gm,
    CONFIG_X_VALUE: () => Mm,
    CONFIG_Y_UNIT: () => Xm,
    CONFIG_Y_VALUE: () => Dm,
    CONFIG_Z_UNIT: () => Vm,
    CONFIG_Z_VALUE: () => Fm,
    DISPLAY: () => dv,
    FILTER: () => iv,
    FLEX: () => pv,
    FONT_VARIATION_SETTINGS: () => ov,
    HEIGHT: () => sv,
    HTML_ELEMENT: () => bv,
    IMMEDIATE_CHILDREN: () => _v,
    IX2_ID_DELIMITER: () => wm,
    OPACITY: () => rv,
    PARENT: () => Tv,
    PLAIN_OBJECT: () => Sv,
    PRESERVE_3D: () => Av,
    RENDER_GENERAL: () => Rv,
    RENDER_PLUGIN: () => Cv,
    RENDER_STYLE: () => wv,
    RENDER_TRANSFORM: () => xv,
    ROTATE_X: () => Qm,
    ROTATE_Y: () => Zm,
    ROTATE_Z: () => Jm,
    SCALE_3D: () => $m,
    SCALE_X: () => Km,
    SCALE_Y: () => jm,
    SCALE_Z: () => Ym,
    SIBLINGS: () => Iv,
    SKEW: () => ev,
    SKEW_X: () => tv,
    SKEW_Y: () => nv,
    TRANSFORM: () => Bm,
    TRANSLATE_3D: () => zm,
    TRANSLATE_X: () => Hm,
    TRANSLATE_Y: () => km,
    TRANSLATE_Z: () => Wm,
    WF_PAGE: () => Cm,
    WIDTH: () => av,
    WILL_CHANGE: () => gv,
    W_MOD_IX: () => Lm,
    W_MOD_JS: () => Pm,
  });
  var wm,
    Cm,
    Pm,
    Lm,
    Nm,
    Mm,
    Dm,
    Fm,
    qm,
    Gm,
    Xm,
    Vm,
    Um,
    Bm,
    Hm,
    km,
    Wm,
    zm,
    Km,
    jm,
    Ym,
    $m,
    Qm,
    Zm,
    Jm,
    ev,
    tv,
    nv,
    rv,
    iv,
    ov,
    av,
    sv,
    uv,
    cv,
    lv,
    fv,
    dv,
    pv,
    gv,
    hv,
    Ev,
    yv,
    mv,
    vv,
    _v,
    Iv,
    Tv,
    Av,
    bv,
    Sv,
    Ov,
    xv,
    Rv,
    wv,
    Cv,
    as = ne(() => {
      "use strict";
      (wm = "|"),
        (Cm = "data-wf-page"),
        (Pm = "w-mod-js"),
        (Lm = "w-mod-ix"),
        (Nm = ".w-dyn-item"),
        (Mm = "xValue"),
        (Dm = "yValue"),
        (Fm = "zValue"),
        (qm = "value"),
        (Gm = "xUnit"),
        (Xm = "yUnit"),
        (Vm = "zUnit"),
        (Um = "unit"),
        (Bm = "transform"),
        (Hm = "translateX"),
        (km = "translateY"),
        (Wm = "translateZ"),
        (zm = "translate3d"),
        (Km = "scaleX"),
        (jm = "scaleY"),
        (Ym = "scaleZ"),
        ($m = "scale3d"),
        (Qm = "rotateX"),
        (Zm = "rotateY"),
        (Jm = "rotateZ"),
        (ev = "skew"),
        (tv = "skewX"),
        (nv = "skewY"),
        (rv = "opacity"),
        (iv = "filter"),
        (ov = "font-variation-settings"),
        (av = "width"),
        (sv = "height"),
        (uv = "backgroundColor"),
        (cv = "background"),
        (lv = "borderColor"),
        (fv = "color"),
        (dv = "display"),
        (pv = "flex"),
        (gv = "willChange"),
        (hv = "AUTO"),
        (Ev = ","),
        (yv = ":"),
        (mv = "|"),
        (vv = "CHILDREN"),
        (_v = "IMMEDIATE_CHILDREN"),
        (Iv = "SIBLINGS"),
        (Tv = "PARENT"),
        (Av = "preserve-3d"),
        (bv = "HTML_ELEMENT"),
        (Sv = "PLAIN_OBJECT"),
        (Ov = "ABSTRACT_NODE"),
        (xv = "RENDER_TRANSFORM"),
        (Rv = "RENDER_GENERAL"),
        (wv = "RENDER_STYLE"),
        (Cv = "RENDER_PLUGIN");
    });
  var ss = {};
  me(ss, {
    ActionAppliesTo: () => em,
    ActionTypeConsts: () => pe,
    EventAppliesTo: () => oi,
    EventBasedOn: () => qe,
    EventContinuousMouseAxes: () => Qy,
    EventLimitAffectedElements: () => Zy,
    EventTypeConsts: () => Ce,
    IX2EngineActionTypes: () => se,
    IX2EngineConstants: () => ce,
    InteractionTypeConsts: () => tm,
    QuickEffectDirectionConsts: () => Jy,
    QuickEffectIds: () => xn,
    ReducedMotionTypes: () => si,
  });
  var ve = ne(() => {
    "use strict";
    ai();
    Rn();
    rs();
    is();
    os();
    as();
    Rn();
    ai();
  });
  var Pv,
    us,
    cs = ne(() => {
      "use strict";
      ve();
      ({ IX2_RAW_DATA_IMPORTED: Pv } = se),
        (us = (e = Object.freeze({}), t) => {
          switch (t.type) {
            case Pv:
              return t.payload.ixData || Object.freeze({});
            default:
              return e;
          }
        });
    });
  var Et = f((ie) => {
    "use strict";
    Object.defineProperty(ie, "__esModule", { value: !0 });
    var Lv =
      typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              typeof Symbol == "function" &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          };
    ie.clone = Cn;
    ie.addLast = ds;
    ie.addFirst = ps;
    ie.removeLast = gs;
    ie.removeFirst = hs;
    ie.insert = Es;
    ie.removeAt = ys;
    ie.replaceAt = ms;
    ie.getIn = Pn;
    ie.set = Ln;
    ie.setIn = Nn;
    ie.update = _s;
    ie.updateIn = Is;
    ie.merge = Ts;
    ie.mergeDeep = As;
    ie.mergeIn = bs;
    ie.omit = Ss;
    ie.addDefaults = Os;
    var ls = "INVALID_ARGS";
    function fs(e) {
      throw new Error(e);
    }
    function ui(e) {
      var t = Object.keys(e);
      return Object.getOwnPropertySymbols
        ? t.concat(Object.getOwnPropertySymbols(e))
        : t;
    }
    var Nv = {}.hasOwnProperty;
    function Cn(e) {
      if (Array.isArray(e)) return e.slice();
      for (var t = ui(e), n = {}, r = 0; r < t.length; r++) {
        var i = t[r];
        n[i] = e[i];
      }
      return n;
    }
    function _e(e, t, n) {
      var r = n;
      r == null && fs(ls);
      for (
        var i = !1, o = arguments.length, a = Array(o > 3 ? o - 3 : 0), s = 3;
        s < o;
        s++
      )
        a[s - 3] = arguments[s];
      for (var u = 0; u < a.length; u++) {
        var l = a[u];
        if (l != null) {
          var g = ui(l);
          if (g.length)
            for (var p = 0; p <= g.length; p++) {
              var d = g[p];
              if (!(e && r[d] !== void 0)) {
                var E = l[d];
                t && wn(r[d]) && wn(E) && (E = _e(e, t, r[d], E)),
                  !(E === void 0 || E === r[d]) &&
                    (i || ((i = !0), (r = Cn(r))), (r[d] = E));
              }
            }
        }
      }
      return r;
    }
    function wn(e) {
      var t = typeof e > "u" ? "undefined" : Lv(e);
      return e != null && (t === "object" || t === "function");
    }
    function ds(e, t) {
      return Array.isArray(t) ? e.concat(t) : e.concat([t]);
    }
    function ps(e, t) {
      return Array.isArray(t) ? t.concat(e) : [t].concat(e);
    }
    function gs(e) {
      return e.length ? e.slice(0, e.length - 1) : e;
    }
    function hs(e) {
      return e.length ? e.slice(1) : e;
    }
    function Es(e, t, n) {
      return e
        .slice(0, t)
        .concat(Array.isArray(n) ? n : [n])
        .concat(e.slice(t));
    }
    function ys(e, t) {
      return t >= e.length || t < 0 ? e : e.slice(0, t).concat(e.slice(t + 1));
    }
    function ms(e, t, n) {
      if (e[t] === n) return e;
      for (var r = e.length, i = Array(r), o = 0; o < r; o++) i[o] = e[o];
      return (i[t] = n), i;
    }
    function Pn(e, t) {
      if ((!Array.isArray(t) && fs(ls), e != null)) {
        for (var n = e, r = 0; r < t.length; r++) {
          var i = t[r];
          if (((n = n?.[i]), n === void 0)) return n;
        }
        return n;
      }
    }
    function Ln(e, t, n) {
      var r = typeof t == "number" ? [] : {},
        i = e ?? r;
      if (i[t] === n) return i;
      var o = Cn(i);
      return (o[t] = n), o;
    }
    function vs(e, t, n, r) {
      var i = void 0,
        o = t[r];
      if (r === t.length - 1) i = n;
      else {
        var a =
          wn(e) && wn(e[o]) ? e[o] : typeof t[r + 1] == "number" ? [] : {};
        i = vs(a, t, n, r + 1);
      }
      return Ln(e, o, i);
    }
    function Nn(e, t, n) {
      return t.length ? vs(e, t, n, 0) : n;
    }
    function _s(e, t, n) {
      var r = e?.[t],
        i = n(r);
      return Ln(e, t, i);
    }
    function Is(e, t, n) {
      var r = Pn(e, t),
        i = n(r);
      return Nn(e, t, i);
    }
    function Ts(e, t, n, r, i, o) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), u = 6;
        u < a;
        u++
      )
        s[u - 6] = arguments[u];
      return s.length
        ? _e.call.apply(_e, [null, !1, !1, e, t, n, r, i, o].concat(s))
        : _e(!1, !1, e, t, n, r, i, o);
    }
    function As(e, t, n, r, i, o) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), u = 6;
        u < a;
        u++
      )
        s[u - 6] = arguments[u];
      return s.length
        ? _e.call.apply(_e, [null, !1, !0, e, t, n, r, i, o].concat(s))
        : _e(!1, !0, e, t, n, r, i, o);
    }
    function bs(e, t, n, r, i, o, a) {
      var s = Pn(e, t);
      s == null && (s = {});
      for (
        var u = void 0,
          l = arguments.length,
          g = Array(l > 7 ? l - 7 : 0),
          p = 7;
        p < l;
        p++
      )
        g[p - 7] = arguments[p];
      return (
        g.length
          ? (u = _e.call.apply(_e, [null, !1, !1, s, n, r, i, o, a].concat(g)))
          : (u = _e(!1, !1, s, n, r, i, o, a)),
        Nn(e, t, u)
      );
    }
    function Ss(e, t) {
      for (var n = Array.isArray(t) ? t : [t], r = !1, i = 0; i < n.length; i++)
        if (Nv.call(e, n[i])) {
          r = !0;
          break;
        }
      if (!r) return e;
      for (var o = {}, a = ui(e), s = 0; s < a.length; s++) {
        var u = a[s];
        n.indexOf(u) >= 0 || (o[u] = e[u]);
      }
      return o;
    }
    function Os(e, t, n, r, i, o) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), u = 6;
        u < a;
        u++
      )
        s[u - 6] = arguments[u];
      return s.length
        ? _e.call.apply(_e, [null, !0, !1, e, t, n, r, i, o].concat(s))
        : _e(!0, !1, e, t, n, r, i, o);
    }
    var Mv = {
      clone: Cn,
      addLast: ds,
      addFirst: ps,
      removeLast: gs,
      removeFirst: hs,
      insert: Es,
      removeAt: ys,
      replaceAt: ms,
      getIn: Pn,
      set: Ln,
      setIn: Nn,
      update: _s,
      updateIn: Is,
      merge: Ts,
      mergeDeep: As,
      mergeIn: bs,
      omit: Ss,
      addDefaults: Os,
    };
    ie.default = Mv;
  });
  var Rs,
    Dv,
    Fv,
    qv,
    Gv,
    Xv,
    xs,
    ws,
    Cs = ne(() => {
      "use strict";
      ve();
      (Rs = $(Et())),
        ({
          IX2_PREVIEW_REQUESTED: Dv,
          IX2_PLAYBACK_REQUESTED: Fv,
          IX2_STOP_REQUESTED: qv,
          IX2_CLEAR_REQUESTED: Gv,
        } = se),
        (Xv = { preview: {}, playback: {}, stop: {}, clear: {} }),
        (xs = Object.create(null, {
          [Dv]: { value: "preview" },
          [Fv]: { value: "playback" },
          [qv]: { value: "stop" },
          [Gv]: { value: "clear" },
        })),
        (ws = (e = Xv, t) => {
          if (t.type in xs) {
            let n = [xs[t.type]];
            return (0, Rs.setIn)(e, [n], { ...t.payload });
          }
          return e;
        });
    });
  var ge,
    Vv,
    Uv,
    Bv,
    Hv,
    kv,
    Wv,
    zv,
    Kv,
    jv,
    Yv,
    Ps,
    $v,
    Ls,
    Ns = ne(() => {
      "use strict";
      ve();
      (ge = $(Et())),
        ({
          IX2_SESSION_INITIALIZED: Vv,
          IX2_SESSION_STARTED: Uv,
          IX2_TEST_FRAME_RENDERED: Bv,
          IX2_SESSION_STOPPED: Hv,
          IX2_EVENT_LISTENER_ADDED: kv,
          IX2_EVENT_STATE_CHANGED: Wv,
          IX2_ANIMATION_FRAME_CHANGED: zv,
          IX2_ACTION_LIST_PLAYBACK_CHANGED: Kv,
          IX2_VIEWPORT_WIDTH_CHANGED: jv,
          IX2_MEDIA_QUERIES_DEFINED: Yv,
        } = se),
        (Ps = {
          active: !1,
          tick: 0,
          eventListeners: [],
          eventState: {},
          playbackState: {},
          viewportWidth: 0,
          mediaQueryKey: null,
          hasBoundaryNodes: !1,
          hasDefinedMediaQueries: !1,
          reducedMotion: !1,
        }),
        ($v = 20),
        (Ls = (e = Ps, t) => {
          switch (t.type) {
            case Vv: {
              let { hasBoundaryNodes: n, reducedMotion: r } = t.payload;
              return (0, ge.merge)(e, {
                hasBoundaryNodes: n,
                reducedMotion: r,
              });
            }
            case Uv:
              return (0, ge.set)(e, "active", !0);
            case Bv: {
              let {
                payload: { step: n = $v },
              } = t;
              return (0, ge.set)(e, "tick", e.tick + n);
            }
            case Hv:
              return Ps;
            case zv: {
              let {
                payload: { now: n },
              } = t;
              return (0, ge.set)(e, "tick", n);
            }
            case kv: {
              let n = (0, ge.addLast)(e.eventListeners, t.payload);
              return (0, ge.set)(e, "eventListeners", n);
            }
            case Wv: {
              let { stateKey: n, newState: r } = t.payload;
              return (0, ge.setIn)(e, ["eventState", n], r);
            }
            case Kv: {
              let { actionListId: n, isPlaying: r } = t.payload;
              return (0, ge.setIn)(e, ["playbackState", n], r);
            }
            case jv: {
              let { width: n, mediaQueries: r } = t.payload,
                i = r.length,
                o = null;
              for (let a = 0; a < i; a++) {
                let { key: s, min: u, max: l } = r[a];
                if (n >= u && n <= l) {
                  o = s;
                  break;
                }
              }
              return (0, ge.merge)(e, { viewportWidth: n, mediaQueryKey: o });
            }
            case Yv:
              return (0, ge.set)(e, "hasDefinedMediaQueries", !0);
            default:
              return e;
          }
        });
    });
  var Ds = f((ZF, Ms) => {
    function Qv() {
      (this.__data__ = []), (this.size = 0);
    }
    Ms.exports = Qv;
  });
  var Mn = f((JF, Fs) => {
    function Zv(e, t) {
      return e === t || (e !== e && t !== t);
    }
    Fs.exports = Zv;
  });
  var Wt = f((e2, qs) => {
    var Jv = Mn();
    function e_(e, t) {
      for (var n = e.length; n--; ) if (Jv(e[n][0], t)) return n;
      return -1;
    }
    qs.exports = e_;
  });
  var Xs = f((t2, Gs) => {
    var t_ = Wt(),
      n_ = Array.prototype,
      r_ = n_.splice;
    function i_(e) {
      var t = this.__data__,
        n = t_(t, e);
      if (n < 0) return !1;
      var r = t.length - 1;
      return n == r ? t.pop() : r_.call(t, n, 1), --this.size, !0;
    }
    Gs.exports = i_;
  });
  var Us = f((n2, Vs) => {
    var o_ = Wt();
    function a_(e) {
      var t = this.__data__,
        n = o_(t, e);
      return n < 0 ? void 0 : t[n][1];
    }
    Vs.exports = a_;
  });
  var Hs = f((r2, Bs) => {
    var s_ = Wt();
    function u_(e) {
      return s_(this.__data__, e) > -1;
    }
    Bs.exports = u_;
  });
  var Ws = f((i2, ks) => {
    var c_ = Wt();
    function l_(e, t) {
      var n = this.__data__,
        r = c_(n, e);
      return r < 0 ? (++this.size, n.push([e, t])) : (n[r][1] = t), this;
    }
    ks.exports = l_;
  });
  var zt = f((o2, zs) => {
    var f_ = Ds(),
      d_ = Xs(),
      p_ = Us(),
      g_ = Hs(),
      h_ = Ws();
    function yt(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.clear(); ++t < n; ) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    yt.prototype.clear = f_;
    yt.prototype.delete = d_;
    yt.prototype.get = p_;
    yt.prototype.has = g_;
    yt.prototype.set = h_;
    zs.exports = yt;
  });
  var js = f((a2, Ks) => {
    var E_ = zt();
    function y_() {
      (this.__data__ = new E_()), (this.size = 0);
    }
    Ks.exports = y_;
  });
  var $s = f((s2, Ys) => {
    function m_(e) {
      var t = this.__data__,
        n = t.delete(e);
      return (this.size = t.size), n;
    }
    Ys.exports = m_;
  });
  var Zs = f((u2, Qs) => {
    function v_(e) {
      return this.__data__.get(e);
    }
    Qs.exports = v_;
  });
  var eu = f((c2, Js) => {
    function __(e) {
      return this.__data__.has(e);
    }
    Js.exports = __;
  });
  var Ge = f((l2, tu) => {
    function I_(e) {
      var t = typeof e;
      return e != null && (t == "object" || t == "function");
    }
    tu.exports = I_;
  });
  var ci = f((f2, nu) => {
    var T_ = Qe(),
      A_ = Ge(),
      b_ = "[object AsyncFunction]",
      S_ = "[object Function]",
      O_ = "[object GeneratorFunction]",
      x_ = "[object Proxy]";
    function R_(e) {
      if (!A_(e)) return !1;
      var t = T_(e);
      return t == S_ || t == O_ || t == b_ || t == x_;
    }
    nu.exports = R_;
  });
  var iu = f((d2, ru) => {
    var w_ = we(),
      C_ = w_["__core-js_shared__"];
    ru.exports = C_;
  });
  var su = f((p2, au) => {
    var li = iu(),
      ou = (function () {
        var e = /[^.]+$/.exec((li && li.keys && li.keys.IE_PROTO) || "");
        return e ? "Symbol(src)_1." + e : "";
      })();
    function P_(e) {
      return !!ou && ou in e;
    }
    au.exports = P_;
  });
  var fi = f((g2, uu) => {
    var L_ = Function.prototype,
      N_ = L_.toString;
    function M_(e) {
      if (e != null) {
        try {
          return N_.call(e);
        } catch {}
        try {
          return e + "";
        } catch {}
      }
      return "";
    }
    uu.exports = M_;
  });
  var lu = f((h2, cu) => {
    var D_ = ci(),
      F_ = su(),
      q_ = Ge(),
      G_ = fi(),
      X_ = /[\\^$.*+?()[\]{}|]/g,
      V_ = /^\[object .+?Constructor\]$/,
      U_ = Function.prototype,
      B_ = Object.prototype,
      H_ = U_.toString,
      k_ = B_.hasOwnProperty,
      W_ = RegExp(
        "^" +
          H_.call(k_)
            .replace(X_, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?"
            ) +
          "$"
      );
    function z_(e) {
      if (!q_(e) || F_(e)) return !1;
      var t = D_(e) ? W_ : V_;
      return t.test(G_(e));
    }
    cu.exports = z_;
  });
  var du = f((E2, fu) => {
    function K_(e, t) {
      return e?.[t];
    }
    fu.exports = K_;
  });
  var Ze = f((y2, pu) => {
    var j_ = lu(),
      Y_ = du();
    function $_(e, t) {
      var n = Y_(e, t);
      return j_(n) ? n : void 0;
    }
    pu.exports = $_;
  });
  var Dn = f((m2, gu) => {
    var Q_ = Ze(),
      Z_ = we(),
      J_ = Q_(Z_, "Map");
    gu.exports = J_;
  });
  var Kt = f((v2, hu) => {
    var eI = Ze(),
      tI = eI(Object, "create");
    hu.exports = tI;
  });
  var mu = f((_2, yu) => {
    var Eu = Kt();
    function nI() {
      (this.__data__ = Eu ? Eu(null) : {}), (this.size = 0);
    }
    yu.exports = nI;
  });
  var _u = f((I2, vu) => {
    function rI(e) {
      var t = this.has(e) && delete this.__data__[e];
      return (this.size -= t ? 1 : 0), t;
    }
    vu.exports = rI;
  });
  var Tu = f((T2, Iu) => {
    var iI = Kt(),
      oI = "__lodash_hash_undefined__",
      aI = Object.prototype,
      sI = aI.hasOwnProperty;
    function uI(e) {
      var t = this.__data__;
      if (iI) {
        var n = t[e];
        return n === oI ? void 0 : n;
      }
      return sI.call(t, e) ? t[e] : void 0;
    }
    Iu.exports = uI;
  });
  var bu = f((A2, Au) => {
    var cI = Kt(),
      lI = Object.prototype,
      fI = lI.hasOwnProperty;
    function dI(e) {
      var t = this.__data__;
      return cI ? t[e] !== void 0 : fI.call(t, e);
    }
    Au.exports = dI;
  });
  var Ou = f((b2, Su) => {
    var pI = Kt(),
      gI = "__lodash_hash_undefined__";
    function hI(e, t) {
      var n = this.__data__;
      return (
        (this.size += this.has(e) ? 0 : 1),
        (n[e] = pI && t === void 0 ? gI : t),
        this
      );
    }
    Su.exports = hI;
  });
  var Ru = f((S2, xu) => {
    var EI = mu(),
      yI = _u(),
      mI = Tu(),
      vI = bu(),
      _I = Ou();
    function mt(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.clear(); ++t < n; ) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    mt.prototype.clear = EI;
    mt.prototype.delete = yI;
    mt.prototype.get = mI;
    mt.prototype.has = vI;
    mt.prototype.set = _I;
    xu.exports = mt;
  });
  var Pu = f((O2, Cu) => {
    var wu = Ru(),
      II = zt(),
      TI = Dn();
    function AI() {
      (this.size = 0),
        (this.__data__ = {
          hash: new wu(),
          map: new (TI || II)(),
          string: new wu(),
        });
    }
    Cu.exports = AI;
  });
  var Nu = f((x2, Lu) => {
    function bI(e) {
      var t = typeof e;
      return t == "string" || t == "number" || t == "symbol" || t == "boolean"
        ? e !== "__proto__"
        : e === null;
    }
    Lu.exports = bI;
  });
  var jt = f((R2, Mu) => {
    var SI = Nu();
    function OI(e, t) {
      var n = e.__data__;
      return SI(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
    }
    Mu.exports = OI;
  });
  var Fu = f((w2, Du) => {
    var xI = jt();
    function RI(e) {
      var t = xI(this, e).delete(e);
      return (this.size -= t ? 1 : 0), t;
    }
    Du.exports = RI;
  });
  var Gu = f((C2, qu) => {
    var wI = jt();
    function CI(e) {
      return wI(this, e).get(e);
    }
    qu.exports = CI;
  });
  var Vu = f((P2, Xu) => {
    var PI = jt();
    function LI(e) {
      return PI(this, e).has(e);
    }
    Xu.exports = LI;
  });
  var Bu = f((L2, Uu) => {
    var NI = jt();
    function MI(e, t) {
      var n = NI(this, e),
        r = n.size;
      return n.set(e, t), (this.size += n.size == r ? 0 : 1), this;
    }
    Uu.exports = MI;
  });
  var Fn = f((N2, Hu) => {
    var DI = Pu(),
      FI = Fu(),
      qI = Gu(),
      GI = Vu(),
      XI = Bu();
    function vt(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.clear(); ++t < n; ) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    vt.prototype.clear = DI;
    vt.prototype.delete = FI;
    vt.prototype.get = qI;
    vt.prototype.has = GI;
    vt.prototype.set = XI;
    Hu.exports = vt;
  });
  var Wu = f((M2, ku) => {
    var VI = zt(),
      UI = Dn(),
      BI = Fn(),
      HI = 200;
    function kI(e, t) {
      var n = this.__data__;
      if (n instanceof VI) {
        var r = n.__data__;
        if (!UI || r.length < HI - 1)
          return r.push([e, t]), (this.size = ++n.size), this;
        n = this.__data__ = new BI(r);
      }
      return n.set(e, t), (this.size = n.size), this;
    }
    ku.exports = kI;
  });
  var di = f((D2, zu) => {
    var WI = zt(),
      zI = js(),
      KI = $s(),
      jI = Zs(),
      YI = eu(),
      $I = Wu();
    function _t(e) {
      var t = (this.__data__ = new WI(e));
      this.size = t.size;
    }
    _t.prototype.clear = zI;
    _t.prototype.delete = KI;
    _t.prototype.get = jI;
    _t.prototype.has = YI;
    _t.prototype.set = $I;
    zu.exports = _t;
  });
  var ju = f((F2, Ku) => {
    var QI = "__lodash_hash_undefined__";
    function ZI(e) {
      return this.__data__.set(e, QI), this;
    }
    Ku.exports = ZI;
  });
  var $u = f((q2, Yu) => {
    function JI(e) {
      return this.__data__.has(e);
    }
    Yu.exports = JI;
  });
  var Zu = f((G2, Qu) => {
    var eT = Fn(),
      tT = ju(),
      nT = $u();
    function qn(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.__data__ = new eT(); ++t < n; ) this.add(e[t]);
    }
    qn.prototype.add = qn.prototype.push = tT;
    qn.prototype.has = nT;
    Qu.exports = qn;
  });
  var ec = f((X2, Ju) => {
    function rT(e, t) {
      for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
        if (t(e[n], n, e)) return !0;
      return !1;
    }
    Ju.exports = rT;
  });
  var nc = f((V2, tc) => {
    function iT(e, t) {
      return e.has(t);
    }
    tc.exports = iT;
  });
  var pi = f((U2, rc) => {
    var oT = Zu(),
      aT = ec(),
      sT = nc(),
      uT = 1,
      cT = 2;
    function lT(e, t, n, r, i, o) {
      var a = n & uT,
        s = e.length,
        u = t.length;
      if (s != u && !(a && u > s)) return !1;
      var l = o.get(e),
        g = o.get(t);
      if (l && g) return l == t && g == e;
      var p = -1,
        d = !0,
        E = n & cT ? new oT() : void 0;
      for (o.set(e, t), o.set(t, e); ++p < s; ) {
        var I = e[p],
          v = t[p];
        if (r) var b = a ? r(v, I, p, t, e, o) : r(I, v, p, e, t, o);
        if (b !== void 0) {
          if (b) continue;
          d = !1;
          break;
        }
        if (E) {
          if (
            !aT(t, function (m, O) {
              if (!sT(E, O) && (I === m || i(I, m, n, r, o))) return E.push(O);
            })
          ) {
            d = !1;
            break;
          }
        } else if (!(I === v || i(I, v, n, r, o))) {
          d = !1;
          break;
        }
      }
      return o.delete(e), o.delete(t), d;
    }
    rc.exports = lT;
  });
  var oc = f((B2, ic) => {
    var fT = we(),
      dT = fT.Uint8Array;
    ic.exports = dT;
  });
  var sc = f((H2, ac) => {
    function pT(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (r, i) {
          n[++t] = [i, r];
        }),
        n
      );
    }
    ac.exports = pT;
  });
  var cc = f((k2, uc) => {
    function gT(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (r) {
          n[++t] = r;
        }),
        n
      );
    }
    uc.exports = gT;
  });
  var gc = f((W2, pc) => {
    var lc = pt(),
      fc = oc(),
      hT = Mn(),
      ET = pi(),
      yT = sc(),
      mT = cc(),
      vT = 1,
      _T = 2,
      IT = "[object Boolean]",
      TT = "[object Date]",
      AT = "[object Error]",
      bT = "[object Map]",
      ST = "[object Number]",
      OT = "[object RegExp]",
      xT = "[object Set]",
      RT = "[object String]",
      wT = "[object Symbol]",
      CT = "[object ArrayBuffer]",
      PT = "[object DataView]",
      dc = lc ? lc.prototype : void 0,
      gi = dc ? dc.valueOf : void 0;
    function LT(e, t, n, r, i, o, a) {
      switch (n) {
        case PT:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
            return !1;
          (e = e.buffer), (t = t.buffer);
        case CT:
          return !(e.byteLength != t.byteLength || !o(new fc(e), new fc(t)));
        case IT:
        case TT:
        case ST:
          return hT(+e, +t);
        case AT:
          return e.name == t.name && e.message == t.message;
        case OT:
        case RT:
          return e == t + "";
        case bT:
          var s = yT;
        case xT:
          var u = r & vT;
          if ((s || (s = mT), e.size != t.size && !u)) return !1;
          var l = a.get(e);
          if (l) return l == t;
          (r |= _T), a.set(e, t);
          var g = ET(s(e), s(t), r, i, o, a);
          return a.delete(e), g;
        case wT:
          if (gi) return gi.call(e) == gi.call(t);
      }
      return !1;
    }
    pc.exports = LT;
  });
  var Gn = f((z2, hc) => {
    function NT(e, t) {
      for (var n = -1, r = t.length, i = e.length; ++n < r; ) e[i + n] = t[n];
      return e;
    }
    hc.exports = NT;
  });
  var ue = f((K2, Ec) => {
    var MT = Array.isArray;
    Ec.exports = MT;
  });
  var hi = f((j2, yc) => {
    var DT = Gn(),
      FT = ue();
    function qT(e, t, n) {
      var r = t(e);
      return FT(e) ? r : DT(r, n(e));
    }
    yc.exports = qT;
  });
  var vc = f((Y2, mc) => {
    function GT(e, t) {
      for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
        var a = e[n];
        t(a, n, e) && (o[i++] = a);
      }
      return o;
    }
    mc.exports = GT;
  });
  var Ei = f(($2, _c) => {
    function XT() {
      return [];
    }
    _c.exports = XT;
  });
  var yi = f((Q2, Tc) => {
    var VT = vc(),
      UT = Ei(),
      BT = Object.prototype,
      HT = BT.propertyIsEnumerable,
      Ic = Object.getOwnPropertySymbols,
      kT = Ic
        ? function (e) {
            return e == null
              ? []
              : ((e = Object(e)),
                VT(Ic(e), function (t) {
                  return HT.call(e, t);
                }));
          }
        : UT;
    Tc.exports = kT;
  });
  var bc = f((Z2, Ac) => {
    function WT(e, t) {
      for (var n = -1, r = Array(e); ++n < e; ) r[n] = t(n);
      return r;
    }
    Ac.exports = WT;
  });
  var Oc = f((J2, Sc) => {
    var zT = Qe(),
      KT = Be(),
      jT = "[object Arguments]";
    function YT(e) {
      return KT(e) && zT(e) == jT;
    }
    Sc.exports = YT;
  });
  var Yt = f((eq, wc) => {
    var xc = Oc(),
      $T = Be(),
      Rc = Object.prototype,
      QT = Rc.hasOwnProperty,
      ZT = Rc.propertyIsEnumerable,
      JT = xc(
        (function () {
          return arguments;
        })()
      )
        ? xc
        : function (e) {
            return $T(e) && QT.call(e, "callee") && !ZT.call(e, "callee");
          };
    wc.exports = JT;
  });
  var Pc = f((tq, Cc) => {
    function eA() {
      return !1;
    }
    Cc.exports = eA;
  });
  var Xn = f(($t, It) => {
    var tA = we(),
      nA = Pc(),
      Mc = typeof $t == "object" && $t && !$t.nodeType && $t,
      Lc = Mc && typeof It == "object" && It && !It.nodeType && It,
      rA = Lc && Lc.exports === Mc,
      Nc = rA ? tA.Buffer : void 0,
      iA = Nc ? Nc.isBuffer : void 0,
      oA = iA || nA;
    It.exports = oA;
  });
  var Vn = f((nq, Dc) => {
    var aA = 9007199254740991,
      sA = /^(?:0|[1-9]\d*)$/;
    function uA(e, t) {
      var n = typeof e;
      return (
        (t = t ?? aA),
        !!t &&
          (n == "number" || (n != "symbol" && sA.test(e))) &&
          e > -1 &&
          e % 1 == 0 &&
          e < t
      );
    }
    Dc.exports = uA;
  });
  var Un = f((rq, Fc) => {
    var cA = 9007199254740991;
    function lA(e) {
      return typeof e == "number" && e > -1 && e % 1 == 0 && e <= cA;
    }
    Fc.exports = lA;
  });
  var Gc = f((iq, qc) => {
    var fA = Qe(),
      dA = Un(),
      pA = Be(),
      gA = "[object Arguments]",
      hA = "[object Array]",
      EA = "[object Boolean]",
      yA = "[object Date]",
      mA = "[object Error]",
      vA = "[object Function]",
      _A = "[object Map]",
      IA = "[object Number]",
      TA = "[object Object]",
      AA = "[object RegExp]",
      bA = "[object Set]",
      SA = "[object String]",
      OA = "[object WeakMap]",
      xA = "[object ArrayBuffer]",
      RA = "[object DataView]",
      wA = "[object Float32Array]",
      CA = "[object Float64Array]",
      PA = "[object Int8Array]",
      LA = "[object Int16Array]",
      NA = "[object Int32Array]",
      MA = "[object Uint8Array]",
      DA = "[object Uint8ClampedArray]",
      FA = "[object Uint16Array]",
      qA = "[object Uint32Array]",
      ee = {};
    ee[wA] =
      ee[CA] =
      ee[PA] =
      ee[LA] =
      ee[NA] =
      ee[MA] =
      ee[DA] =
      ee[FA] =
      ee[qA] =
        !0;
    ee[gA] =
      ee[hA] =
      ee[xA] =
      ee[EA] =
      ee[RA] =
      ee[yA] =
      ee[mA] =
      ee[vA] =
      ee[_A] =
      ee[IA] =
      ee[TA] =
      ee[AA] =
      ee[bA] =
      ee[SA] =
      ee[OA] =
        !1;
    function GA(e) {
      return pA(e) && dA(e.length) && !!ee[fA(e)];
    }
    qc.exports = GA;
  });
  var Vc = f((oq, Xc) => {
    function XA(e) {
      return function (t) {
        return e(t);
      };
    }
    Xc.exports = XA;
  });
  var Bc = f((Qt, Tt) => {
    var VA = Hr(),
      Uc = typeof Qt == "object" && Qt && !Qt.nodeType && Qt,
      Zt = Uc && typeof Tt == "object" && Tt && !Tt.nodeType && Tt,
      UA = Zt && Zt.exports === Uc,
      mi = UA && VA.process,
      BA = (function () {
        try {
          var e = Zt && Zt.require && Zt.require("util").types;
          return e || (mi && mi.binding && mi.binding("util"));
        } catch {}
      })();
    Tt.exports = BA;
  });
  var Bn = f((aq, Wc) => {
    var HA = Gc(),
      kA = Vc(),
      Hc = Bc(),
      kc = Hc && Hc.isTypedArray,
      WA = kc ? kA(kc) : HA;
    Wc.exports = WA;
  });
  var vi = f((sq, zc) => {
    var zA = bc(),
      KA = Yt(),
      jA = ue(),
      YA = Xn(),
      $A = Vn(),
      QA = Bn(),
      ZA = Object.prototype,
      JA = ZA.hasOwnProperty;
    function eb(e, t) {
      var n = jA(e),
        r = !n && KA(e),
        i = !n && !r && YA(e),
        o = !n && !r && !i && QA(e),
        a = n || r || i || o,
        s = a ? zA(e.length, String) : [],
        u = s.length;
      for (var l in e)
        (t || JA.call(e, l)) &&
          !(
            a &&
            (l == "length" ||
              (i && (l == "offset" || l == "parent")) ||
              (o &&
                (l == "buffer" || l == "byteLength" || l == "byteOffset")) ||
              $A(l, u))
          ) &&
          s.push(l);
      return s;
    }
    zc.exports = eb;
  });
  var Hn = f((uq, Kc) => {
    var tb = Object.prototype;
    function nb(e) {
      var t = e && e.constructor,
        n = (typeof t == "function" && t.prototype) || tb;
      return e === n;
    }
    Kc.exports = nb;
  });
  var Yc = f((cq, jc) => {
    var rb = kr(),
      ib = rb(Object.keys, Object);
    jc.exports = ib;
  });
  var kn = f((lq, $c) => {
    var ob = Hn(),
      ab = Yc(),
      sb = Object.prototype,
      ub = sb.hasOwnProperty;
    function cb(e) {
      if (!ob(e)) return ab(e);
      var t = [];
      for (var n in Object(e)) ub.call(e, n) && n != "constructor" && t.push(n);
      return t;
    }
    $c.exports = cb;
  });
  var rt = f((fq, Qc) => {
    var lb = ci(),
      fb = Un();
    function db(e) {
      return e != null && fb(e.length) && !lb(e);
    }
    Qc.exports = db;
  });
  var Jt = f((dq, Zc) => {
    var pb = vi(),
      gb = kn(),
      hb = rt();
    function Eb(e) {
      return hb(e) ? pb(e) : gb(e);
    }
    Zc.exports = Eb;
  });
  var el = f((pq, Jc) => {
    var yb = hi(),
      mb = yi(),
      vb = Jt();
    function _b(e) {
      return yb(e, vb, mb);
    }
    Jc.exports = _b;
  });
  var rl = f((gq, nl) => {
    var tl = el(),
      Ib = 1,
      Tb = Object.prototype,
      Ab = Tb.hasOwnProperty;
    function bb(e, t, n, r, i, o) {
      var a = n & Ib,
        s = tl(e),
        u = s.length,
        l = tl(t),
        g = l.length;
      if (u != g && !a) return !1;
      for (var p = u; p--; ) {
        var d = s[p];
        if (!(a ? d in t : Ab.call(t, d))) return !1;
      }
      var E = o.get(e),
        I = o.get(t);
      if (E && I) return E == t && I == e;
      var v = !0;
      o.set(e, t), o.set(t, e);
      for (var b = a; ++p < u; ) {
        d = s[p];
        var m = e[d],
          O = t[d];
        if (r) var A = a ? r(O, m, d, t, e, o) : r(m, O, d, e, t, o);
        if (!(A === void 0 ? m === O || i(m, O, n, r, o) : A)) {
          v = !1;
          break;
        }
        b || (b = d == "constructor");
      }
      if (v && !b) {
        var P = e.constructor,
          L = t.constructor;
        P != L &&
          "constructor" in e &&
          "constructor" in t &&
          !(
            typeof P == "function" &&
            P instanceof P &&
            typeof L == "function" &&
            L instanceof L
          ) &&
          (v = !1);
      }
      return o.delete(e), o.delete(t), v;
    }
    nl.exports = bb;
  });
  var ol = f((hq, il) => {
    var Sb = Ze(),
      Ob = we(),
      xb = Sb(Ob, "DataView");
    il.exports = xb;
  });
  var sl = f((Eq, al) => {
    var Rb = Ze(),
      wb = we(),
      Cb = Rb(wb, "Promise");
    al.exports = Cb;
  });
  var cl = f((yq, ul) => {
    var Pb = Ze(),
      Lb = we(),
      Nb = Pb(Lb, "Set");
    ul.exports = Nb;
  });
  var _i = f((mq, ll) => {
    var Mb = Ze(),
      Db = we(),
      Fb = Mb(Db, "WeakMap");
    ll.exports = Fb;
  });
  var Wn = f((vq, yl) => {
    var Ii = ol(),
      Ti = Dn(),
      Ai = sl(),
      bi = cl(),
      Si = _i(),
      El = Qe(),
      At = fi(),
      fl = "[object Map]",
      qb = "[object Object]",
      dl = "[object Promise]",
      pl = "[object Set]",
      gl = "[object WeakMap]",
      hl = "[object DataView]",
      Gb = At(Ii),
      Xb = At(Ti),
      Vb = At(Ai),
      Ub = At(bi),
      Bb = At(Si),
      it = El;
    ((Ii && it(new Ii(new ArrayBuffer(1))) != hl) ||
      (Ti && it(new Ti()) != fl) ||
      (Ai && it(Ai.resolve()) != dl) ||
      (bi && it(new bi()) != pl) ||
      (Si && it(new Si()) != gl)) &&
      (it = function (e) {
        var t = El(e),
          n = t == qb ? e.constructor : void 0,
          r = n ? At(n) : "";
        if (r)
          switch (r) {
            case Gb:
              return hl;
            case Xb:
              return fl;
            case Vb:
              return dl;
            case Ub:
              return pl;
            case Bb:
              return gl;
          }
        return t;
      });
    yl.exports = it;
  });
  var Sl = f((_q, bl) => {
    var Oi = di(),
      Hb = pi(),
      kb = gc(),
      Wb = rl(),
      ml = Wn(),
      vl = ue(),
      _l = Xn(),
      zb = Bn(),
      Kb = 1,
      Il = "[object Arguments]",
      Tl = "[object Array]",
      zn = "[object Object]",
      jb = Object.prototype,
      Al = jb.hasOwnProperty;
    function Yb(e, t, n, r, i, o) {
      var a = vl(e),
        s = vl(t),
        u = a ? Tl : ml(e),
        l = s ? Tl : ml(t);
      (u = u == Il ? zn : u), (l = l == Il ? zn : l);
      var g = u == zn,
        p = l == zn,
        d = u == l;
      if (d && _l(e)) {
        if (!_l(t)) return !1;
        (a = !0), (g = !1);
      }
      if (d && !g)
        return (
          o || (o = new Oi()),
          a || zb(e) ? Hb(e, t, n, r, i, o) : kb(e, t, u, n, r, i, o)
        );
      if (!(n & Kb)) {
        var E = g && Al.call(e, "__wrapped__"),
          I = p && Al.call(t, "__wrapped__");
        if (E || I) {
          var v = E ? e.value() : e,
            b = I ? t.value() : t;
          return o || (o = new Oi()), i(v, b, n, r, o);
        }
      }
      return d ? (o || (o = new Oi()), Wb(e, t, n, r, i, o)) : !1;
    }
    bl.exports = Yb;
  });
  var xi = f((Iq, Rl) => {
    var $b = Sl(),
      Ol = Be();
    function xl(e, t, n, r, i) {
      return e === t
        ? !0
        : e == null || t == null || (!Ol(e) && !Ol(t))
        ? e !== e && t !== t
        : $b(e, t, n, r, xl, i);
    }
    Rl.exports = xl;
  });
  var Cl = f((Tq, wl) => {
    var Qb = di(),
      Zb = xi(),
      Jb = 1,
      e0 = 2;
    function t0(e, t, n, r) {
      var i = n.length,
        o = i,
        a = !r;
      if (e == null) return !o;
      for (e = Object(e); i--; ) {
        var s = n[i];
        if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
      }
      for (; ++i < o; ) {
        s = n[i];
        var u = s[0],
          l = e[u],
          g = s[1];
        if (a && s[2]) {
          if (l === void 0 && !(u in e)) return !1;
        } else {
          var p = new Qb();
          if (r) var d = r(l, g, u, e, t, p);
          if (!(d === void 0 ? Zb(g, l, Jb | e0, r, p) : d)) return !1;
        }
      }
      return !0;
    }
    wl.exports = t0;
  });
  var Ri = f((Aq, Pl) => {
    var n0 = Ge();
    function r0(e) {
      return e === e && !n0(e);
    }
    Pl.exports = r0;
  });
  var Nl = f((bq, Ll) => {
    var i0 = Ri(),
      o0 = Jt();
    function a0(e) {
      for (var t = o0(e), n = t.length; n--; ) {
        var r = t[n],
          i = e[r];
        t[n] = [r, i, i0(i)];
      }
      return t;
    }
    Ll.exports = a0;
  });
  var wi = f((Sq, Ml) => {
    function s0(e, t) {
      return function (n) {
        return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
      };
    }
    Ml.exports = s0;
  });
  var Fl = f((Oq, Dl) => {
    var u0 = Cl(),
      c0 = Nl(),
      l0 = wi();
    function f0(e) {
      var t = c0(e);
      return t.length == 1 && t[0][2]
        ? l0(t[0][0], t[0][1])
        : function (n) {
            return n === e || u0(n, e, t);
          };
    }
    Dl.exports = f0;
  });
  var en = f((xq, ql) => {
    var d0 = Qe(),
      p0 = Be(),
      g0 = "[object Symbol]";
    function h0(e) {
      return typeof e == "symbol" || (p0(e) && d0(e) == g0);
    }
    ql.exports = h0;
  });
  var Kn = f((Rq, Gl) => {
    var E0 = ue(),
      y0 = en(),
      m0 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      v0 = /^\w*$/;
    function _0(e, t) {
      if (E0(e)) return !1;
      var n = typeof e;
      return n == "number" ||
        n == "symbol" ||
        n == "boolean" ||
        e == null ||
        y0(e)
        ? !0
        : v0.test(e) || !m0.test(e) || (t != null && e in Object(t));
    }
    Gl.exports = _0;
  });
  var Ul = f((wq, Vl) => {
    var Xl = Fn(),
      I0 = "Expected a function";
    function Ci(e, t) {
      if (typeof e != "function" || (t != null && typeof t != "function"))
        throw new TypeError(I0);
      var n = function () {
        var r = arguments,
          i = t ? t.apply(this, r) : r[0],
          o = n.cache;
        if (o.has(i)) return o.get(i);
        var a = e.apply(this, r);
        return (n.cache = o.set(i, a) || o), a;
      };
      return (n.cache = new (Ci.Cache || Xl)()), n;
    }
    Ci.Cache = Xl;
    Vl.exports = Ci;
  });
  var Hl = f((Cq, Bl) => {
    var T0 = Ul(),
      A0 = 500;
    function b0(e) {
      var t = T0(e, function (r) {
          return n.size === A0 && n.clear(), r;
        }),
        n = t.cache;
      return t;
    }
    Bl.exports = b0;
  });
  var Wl = f((Pq, kl) => {
    var S0 = Hl(),
      O0 =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      x0 = /\\(\\)?/g,
      R0 = S0(function (e) {
        var t = [];
        return (
          e.charCodeAt(0) === 46 && t.push(""),
          e.replace(O0, function (n, r, i, o) {
            t.push(i ? o.replace(x0, "$1") : r || n);
          }),
          t
        );
      });
    kl.exports = R0;
  });
  var Pi = f((Lq, zl) => {
    function w0(e, t) {
      for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
        i[n] = t(e[n], n, e);
      return i;
    }
    zl.exports = w0;
  });
  var Zl = f((Nq, Ql) => {
    var Kl = pt(),
      C0 = Pi(),
      P0 = ue(),
      L0 = en(),
      N0 = 1 / 0,
      jl = Kl ? Kl.prototype : void 0,
      Yl = jl ? jl.toString : void 0;
    function $l(e) {
      if (typeof e == "string") return e;
      if (P0(e)) return C0(e, $l) + "";
      if (L0(e)) return Yl ? Yl.call(e) : "";
      var t = e + "";
      return t == "0" && 1 / e == -N0 ? "-0" : t;
    }
    Ql.exports = $l;
  });
  var ef = f((Mq, Jl) => {
    var M0 = Zl();
    function D0(e) {
      return e == null ? "" : M0(e);
    }
    Jl.exports = D0;
  });
  var tn = f((Dq, tf) => {
    var F0 = ue(),
      q0 = Kn(),
      G0 = Wl(),
      X0 = ef();
    function V0(e, t) {
      return F0(e) ? e : q0(e, t) ? [e] : G0(X0(e));
    }
    tf.exports = V0;
  });
  var bt = f((Fq, nf) => {
    var U0 = en(),
      B0 = 1 / 0;
    function H0(e) {
      if (typeof e == "string" || U0(e)) return e;
      var t = e + "";
      return t == "0" && 1 / e == -B0 ? "-0" : t;
    }
    nf.exports = H0;
  });
  var jn = f((qq, rf) => {
    var k0 = tn(),
      W0 = bt();
    function z0(e, t) {
      t = k0(t, e);
      for (var n = 0, r = t.length; e != null && n < r; ) e = e[W0(t[n++])];
      return n && n == r ? e : void 0;
    }
    rf.exports = z0;
  });
  var Yn = f((Gq, of) => {
    var K0 = jn();
    function j0(e, t, n) {
      var r = e == null ? void 0 : K0(e, t);
      return r === void 0 ? n : r;
    }
    of.exports = j0;
  });
  var sf = f((Xq, af) => {
    function Y0(e, t) {
      return e != null && t in Object(e);
    }
    af.exports = Y0;
  });
  var cf = f((Vq, uf) => {
    var $0 = tn(),
      Q0 = Yt(),
      Z0 = ue(),
      J0 = Vn(),
      eS = Un(),
      tS = bt();
    function nS(e, t, n) {
      t = $0(t, e);
      for (var r = -1, i = t.length, o = !1; ++r < i; ) {
        var a = tS(t[r]);
        if (!(o = e != null && n(e, a))) break;
        e = e[a];
      }
      return o || ++r != i
        ? o
        : ((i = e == null ? 0 : e.length),
          !!i && eS(i) && J0(a, i) && (Z0(e) || Q0(e)));
    }
    uf.exports = nS;
  });
  var ff = f((Uq, lf) => {
    var rS = sf(),
      iS = cf();
    function oS(e, t) {
      return e != null && iS(e, t, rS);
    }
    lf.exports = oS;
  });
  var pf = f((Bq, df) => {
    var aS = xi(),
      sS = Yn(),
      uS = ff(),
      cS = Kn(),
      lS = Ri(),
      fS = wi(),
      dS = bt(),
      pS = 1,
      gS = 2;
    function hS(e, t) {
      return cS(e) && lS(t)
        ? fS(dS(e), t)
        : function (n) {
            var r = sS(n, e);
            return r === void 0 && r === t ? uS(n, e) : aS(t, r, pS | gS);
          };
    }
    df.exports = hS;
  });
  var $n = f((Hq, gf) => {
    function ES(e) {
      return e;
    }
    gf.exports = ES;
  });
  var Li = f((kq, hf) => {
    function yS(e) {
      return function (t) {
        return t?.[e];
      };
    }
    hf.exports = yS;
  });
  var yf = f((Wq, Ef) => {
    var mS = jn();
    function vS(e) {
      return function (t) {
        return mS(t, e);
      };
    }
    Ef.exports = vS;
  });
  var vf = f((zq, mf) => {
    var _S = Li(),
      IS = yf(),
      TS = Kn(),
      AS = bt();
    function bS(e) {
      return TS(e) ? _S(AS(e)) : IS(e);
    }
    mf.exports = bS;
  });
  var Je = f((Kq, _f) => {
    var SS = Fl(),
      OS = pf(),
      xS = $n(),
      RS = ue(),
      wS = vf();
    function CS(e) {
      return typeof e == "function"
        ? e
        : e == null
        ? xS
        : typeof e == "object"
        ? RS(e)
          ? OS(e[0], e[1])
          : SS(e)
        : wS(e);
    }
    _f.exports = CS;
  });
  var Ni = f((jq, If) => {
    var PS = Je(),
      LS = rt(),
      NS = Jt();
    function MS(e) {
      return function (t, n, r) {
        var i = Object(t);
        if (!LS(t)) {
          var o = PS(n, 3);
          (t = NS(t)),
            (n = function (s) {
              return o(i[s], s, i);
            });
        }
        var a = e(t, n, r);
        return a > -1 ? i[o ? t[a] : a] : void 0;
      };
    }
    If.exports = MS;
  });
  var Mi = f((Yq, Tf) => {
    function DS(e, t, n, r) {
      for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
        if (t(e[o], o, e)) return o;
      return -1;
    }
    Tf.exports = DS;
  });
  var bf = f(($q, Af) => {
    var FS = /\s/;
    function qS(e) {
      for (var t = e.length; t-- && FS.test(e.charAt(t)); );
      return t;
    }
    Af.exports = qS;
  });
  var Of = f((Qq, Sf) => {
    var GS = bf(),
      XS = /^\s+/;
    function VS(e) {
      return e && e.slice(0, GS(e) + 1).replace(XS, "");
    }
    Sf.exports = VS;
  });
  var Qn = f((Zq, wf) => {
    var US = Of(),
      xf = Ge(),
      BS = en(),
      Rf = 0 / 0,
      HS = /^[-+]0x[0-9a-f]+$/i,
      kS = /^0b[01]+$/i,
      WS = /^0o[0-7]+$/i,
      zS = parseInt;
    function KS(e) {
      if (typeof e == "number") return e;
      if (BS(e)) return Rf;
      if (xf(e)) {
        var t = typeof e.valueOf == "function" ? e.valueOf() : e;
        e = xf(t) ? t + "" : t;
      }
      if (typeof e != "string") return e === 0 ? e : +e;
      e = US(e);
      var n = kS.test(e);
      return n || WS.test(e) ? zS(e.slice(2), n ? 2 : 8) : HS.test(e) ? Rf : +e;
    }
    wf.exports = KS;
  });
  var Lf = f((Jq, Pf) => {
    var jS = Qn(),
      Cf = 1 / 0,
      YS = 17976931348623157e292;
    function $S(e) {
      if (!e) return e === 0 ? e : 0;
      if (((e = jS(e)), e === Cf || e === -Cf)) {
        var t = e < 0 ? -1 : 1;
        return t * YS;
      }
      return e === e ? e : 0;
    }
    Pf.exports = $S;
  });
  var Di = f((e1, Nf) => {
    var QS = Lf();
    function ZS(e) {
      var t = QS(e),
        n = t % 1;
      return t === t ? (n ? t - n : t) : 0;
    }
    Nf.exports = ZS;
  });
  var Df = f((t1, Mf) => {
    var JS = Mi(),
      eO = Je(),
      tO = Di(),
      nO = Math.max;
    function rO(e, t, n) {
      var r = e == null ? 0 : e.length;
      if (!r) return -1;
      var i = n == null ? 0 : tO(n);
      return i < 0 && (i = nO(r + i, 0)), JS(e, eO(t, 3), i);
    }
    Mf.exports = rO;
  });
  var Fi = f((n1, Ff) => {
    var iO = Ni(),
      oO = Df(),
      aO = iO(oO);
    Ff.exports = aO;
  });
  var Xf = {};
  me(Xf, {
    ELEMENT_MATCHES: () => sO,
    FLEX_PREFIXED: () => qi,
    IS_BROWSER_ENV: () => Pe,
    TRANSFORM_PREFIXED: () => et,
    TRANSFORM_STYLE_PREFIXED: () => Jn,
    withBrowser: () => Zn,
  });
  var Gf,
    Pe,
    Zn,
    sO,
    qi,
    et,
    qf,
    Jn,
    er = ne(() => {
      "use strict";
      (Gf = $(Fi())),
        (Pe = typeof window < "u"),
        (Zn = (e, t) => (Pe ? e() : t)),
        (sO = Zn(() =>
          (0, Gf.default)(
            [
              "matches",
              "matchesSelector",
              "mozMatchesSelector",
              "msMatchesSelector",
              "oMatchesSelector",
              "webkitMatchesSelector",
            ],
            (e) => e in Element.prototype
          )
        )),
        (qi = Zn(() => {
          let e = document.createElement("i"),
            t = [
              "flex",
              "-webkit-flex",
              "-ms-flexbox",
              "-moz-box",
              "-webkit-box",
            ],
            n = "";
          try {
            let { length: r } = t;
            for (let i = 0; i < r; i++) {
              let o = t[i];
              if (((e.style.display = o), e.style.display === o)) return o;
            }
            return n;
          } catch {
            return n;
          }
        }, "flex")),
        (et = Zn(() => {
          let e = document.createElement("i");
          if (e.style.transform == null) {
            let t = ["Webkit", "Moz", "ms"],
              n = "Transform",
              { length: r } = t;
            for (let i = 0; i < r; i++) {
              let o = t[i] + n;
              if (e.style[o] !== void 0) return o;
            }
          }
          return "transform";
        }, "transform")),
        (qf = et.split("transform")[0]),
        (Jn = qf ? qf + "TransformStyle" : "transformStyle");
    });
  var Gi = f((r1, kf) => {
    var uO = 4,
      cO = 0.001,
      lO = 1e-7,
      fO = 10,
      nn = 11,
      tr = 1 / (nn - 1),
      dO = typeof Float32Array == "function";
    function Vf(e, t) {
      return 1 - 3 * t + 3 * e;
    }
    function Uf(e, t) {
      return 3 * t - 6 * e;
    }
    function Bf(e) {
      return 3 * e;
    }
    function nr(e, t, n) {
      return ((Vf(t, n) * e + Uf(t, n)) * e + Bf(t)) * e;
    }
    function Hf(e, t, n) {
      return 3 * Vf(t, n) * e * e + 2 * Uf(t, n) * e + Bf(t);
    }
    function pO(e, t, n, r, i) {
      var o,
        a,
        s = 0;
      do
        (a = t + (n - t) / 2), (o = nr(a, r, i) - e), o > 0 ? (n = a) : (t = a);
      while (Math.abs(o) > lO && ++s < fO);
      return a;
    }
    function gO(e, t, n, r) {
      for (var i = 0; i < uO; ++i) {
        var o = Hf(t, n, r);
        if (o === 0) return t;
        var a = nr(t, n, r) - e;
        t -= a / o;
      }
      return t;
    }
    kf.exports = function (t, n, r, i) {
      if (!(0 <= t && t <= 1 && 0 <= r && r <= 1))
        throw new Error("bezier x values must be in [0, 1] range");
      var o = dO ? new Float32Array(nn) : new Array(nn);
      if (t !== n || r !== i)
        for (var a = 0; a < nn; ++a) o[a] = nr(a * tr, t, r);
      function s(u) {
        for (var l = 0, g = 1, p = nn - 1; g !== p && o[g] <= u; ++g) l += tr;
        --g;
        var d = (u - o[g]) / (o[g + 1] - o[g]),
          E = l + d * tr,
          I = Hf(E, t, r);
        return I >= cO ? gO(u, E, t, r) : I === 0 ? E : pO(u, l, l + tr, t, r);
      }
      return function (l) {
        return t === n && r === i
          ? l
          : l === 0
          ? 0
          : l === 1
          ? 1
          : nr(s(l), n, i);
      };
    };
  });
  var on = {};
  me(on, {
    bounce: () => $O,
    bouncePast: () => QO,
    ease: () => hO,
    easeIn: () => EO,
    easeInOut: () => mO,
    easeOut: () => yO,
    inBack: () => UO,
    inCirc: () => qO,
    inCubic: () => TO,
    inElastic: () => kO,
    inExpo: () => MO,
    inOutBack: () => HO,
    inOutCirc: () => XO,
    inOutCubic: () => bO,
    inOutElastic: () => zO,
    inOutExpo: () => FO,
    inOutQuad: () => IO,
    inOutQuart: () => xO,
    inOutQuint: () => CO,
    inOutSine: () => NO,
    inQuad: () => vO,
    inQuart: () => SO,
    inQuint: () => RO,
    inSine: () => PO,
    outBack: () => BO,
    outBounce: () => VO,
    outCirc: () => GO,
    outCubic: () => AO,
    outElastic: () => WO,
    outExpo: () => DO,
    outQuad: () => _O,
    outQuart: () => OO,
    outQuint: () => wO,
    outSine: () => LO,
    swingFrom: () => jO,
    swingFromTo: () => KO,
    swingTo: () => YO,
  });
  function vO(e) {
    return Math.pow(e, 2);
  }
  function _O(e) {
    return -(Math.pow(e - 1, 2) - 1);
  }
  function IO(e) {
    return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 2) : -0.5 * ((e -= 2) * e - 2);
  }
  function TO(e) {
    return Math.pow(e, 3);
  }
  function AO(e) {
    return Math.pow(e - 1, 3) + 1;
  }
  function bO(e) {
    return (e /= 0.5) < 1
      ? 0.5 * Math.pow(e, 3)
      : 0.5 * (Math.pow(e - 2, 3) + 2);
  }
  function SO(e) {
    return Math.pow(e, 4);
  }
  function OO(e) {
    return -(Math.pow(e - 1, 4) - 1);
  }
  function xO(e) {
    return (e /= 0.5) < 1
      ? 0.5 * Math.pow(e, 4)
      : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2);
  }
  function RO(e) {
    return Math.pow(e, 5);
  }
  function wO(e) {
    return Math.pow(e - 1, 5) + 1;
  }
  function CO(e) {
    return (e /= 0.5) < 1
      ? 0.5 * Math.pow(e, 5)
      : 0.5 * (Math.pow(e - 2, 5) + 2);
  }
  function PO(e) {
    return -Math.cos(e * (Math.PI / 2)) + 1;
  }
  function LO(e) {
    return Math.sin(e * (Math.PI / 2));
  }
  function NO(e) {
    return -0.5 * (Math.cos(Math.PI * e) - 1);
  }
  function MO(e) {
    return e === 0 ? 0 : Math.pow(2, 10 * (e - 1));
  }
  function DO(e) {
    return e === 1 ? 1 : -Math.pow(2, -10 * e) + 1;
  }
  function FO(e) {
    return e === 0
      ? 0
      : e === 1
      ? 1
      : (e /= 0.5) < 1
      ? 0.5 * Math.pow(2, 10 * (e - 1))
      : 0.5 * (-Math.pow(2, -10 * --e) + 2);
  }
  function qO(e) {
    return -(Math.sqrt(1 - e * e) - 1);
  }
  function GO(e) {
    return Math.sqrt(1 - Math.pow(e - 1, 2));
  }
  function XO(e) {
    return (e /= 0.5) < 1
      ? -0.5 * (Math.sqrt(1 - e * e) - 1)
      : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
  }
  function VO(e) {
    return e < 1 / 2.75
      ? 7.5625 * e * e
      : e < 2 / 2.75
      ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
      : e < 2.5 / 2.75
      ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
      : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  }
  function UO(e) {
    let t = He;
    return e * e * ((t + 1) * e - t);
  }
  function BO(e) {
    let t = He;
    return (e -= 1) * e * ((t + 1) * e + t) + 1;
  }
  function HO(e) {
    let t = He;
    return (e /= 0.5) < 1
      ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
      : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  }
  function kO(e) {
    let t = He,
      n = 0,
      r = 1;
    return e === 0
      ? 0
      : e === 1
      ? 1
      : (n || (n = 0.3),
        r < 1
          ? ((r = 1), (t = n / 4))
          : (t = (n / (2 * Math.PI)) * Math.asin(1 / r)),
        -(
          r *
          Math.pow(2, 10 * (e -= 1)) *
          Math.sin(((e - t) * (2 * Math.PI)) / n)
        ));
  }
  function WO(e) {
    let t = He,
      n = 0,
      r = 1;
    return e === 0
      ? 0
      : e === 1
      ? 1
      : (n || (n = 0.3),
        r < 1
          ? ((r = 1), (t = n / 4))
          : (t = (n / (2 * Math.PI)) * Math.asin(1 / r)),
        r * Math.pow(2, -10 * e) * Math.sin(((e - t) * (2 * Math.PI)) / n) + 1);
  }
  function zO(e) {
    let t = He,
      n = 0,
      r = 1;
    return e === 0
      ? 0
      : (e /= 1 / 2) === 2
      ? 1
      : (n || (n = 0.3 * 1.5),
        r < 1
          ? ((r = 1), (t = n / 4))
          : (t = (n / (2 * Math.PI)) * Math.asin(1 / r)),
        e < 1
          ? -0.5 *
            (r *
              Math.pow(2, 10 * (e -= 1)) *
              Math.sin(((e - t) * (2 * Math.PI)) / n))
          : r *
              Math.pow(2, -10 * (e -= 1)) *
              Math.sin(((e - t) * (2 * Math.PI)) / n) *
              0.5 +
            1);
  }
  function KO(e) {
    let t = He;
    return (e /= 0.5) < 1
      ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
      : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  }
  function jO(e) {
    let t = He;
    return e * e * ((t + 1) * e - t);
  }
  function YO(e) {
    let t = He;
    return (e -= 1) * e * ((t + 1) * e + t) + 1;
  }
  function $O(e) {
    return e < 1 / 2.75
      ? 7.5625 * e * e
      : e < 2 / 2.75
      ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
      : e < 2.5 / 2.75
      ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
      : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  }
  function QO(e) {
    return e < 1 / 2.75
      ? 7.5625 * e * e
      : e < 2 / 2.75
      ? 2 - (7.5625 * (e -= 1.5 / 2.75) * e + 0.75)
      : e < 2.5 / 2.75
      ? 2 - (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375)
      : 2 - (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375);
  }
  var rn,
    He,
    hO,
    EO,
    yO,
    mO,
    Xi = ne(() => {
      "use strict";
      (rn = $(Gi())),
        (He = 1.70158),
        (hO = (0, rn.default)(0.25, 0.1, 0.25, 1)),
        (EO = (0, rn.default)(0.42, 0, 1, 1)),
        (yO = (0, rn.default)(0, 0, 0.58, 1)),
        (mO = (0, rn.default)(0.42, 0, 0.58, 1));
    });
  var zf = {};
  me(zf, {
    applyEasing: () => JO,
    createBezierEasing: () => ZO,
    optimizeFloat: () => an,
  });
  function an(e, t = 5, n = 10) {
    let r = Math.pow(n, t),
      i = Number(Math.round(e * r) / r);
    return Math.abs(i) > 1e-4 ? i : 0;
  }
  function ZO(e) {
    return (0, Wf.default)(...e);
  }
  function JO(e, t, n) {
    return t === 0
      ? 0
      : t === 1
      ? 1
      : an(n ? (t > 0 ? n(t) : t) : t > 0 && e && on[e] ? on[e](t) : t);
  }
  var Wf,
    Vi = ne(() => {
      "use strict";
      Xi();
      Wf = $(Gi());
    });
  var Yf = {};
  me(Yf, {
    createElementState: () => jf,
    ixElements: () => px,
    mergeActionState: () => Ui,
  });
  function jf(e, t, n, r, i) {
    let o =
      n === ex ? (0, St.getIn)(i, ["config", "target", "objectId"]) : null;
    return (0, St.mergeIn)(e, [r], { id: r, ref: t, refId: o, refType: n });
  }
  function Ui(e, t, n, r, i) {
    let o = hx(i);
    return (0, St.mergeIn)(e, [t, dx, n], r, o);
  }
  function hx(e) {
    let { config: t } = e;
    return gx.reduce((n, r) => {
      let i = r[0],
        o = r[1],
        a = t[i],
        s = t[o];
      return a != null && s != null && (n[o] = s), n;
    }, {});
  }
  var St,
    o1,
    ex,
    a1,
    tx,
    nx,
    rx,
    ix,
    ox,
    ax,
    sx,
    ux,
    cx,
    lx,
    fx,
    Kf,
    dx,
    px,
    gx,
    $f = ne(() => {
      "use strict";
      St = $(Et());
      ve();
      ({
        HTML_ELEMENT: o1,
        PLAIN_OBJECT: ex,
        ABSTRACT_NODE: a1,
        CONFIG_X_VALUE: tx,
        CONFIG_Y_VALUE: nx,
        CONFIG_Z_VALUE: rx,
        CONFIG_VALUE: ix,
        CONFIG_X_UNIT: ox,
        CONFIG_Y_UNIT: ax,
        CONFIG_Z_UNIT: sx,
        CONFIG_UNIT: ux,
      } = ce),
        ({
          IX2_SESSION_STOPPED: cx,
          IX2_INSTANCE_ADDED: lx,
          IX2_ELEMENT_STATE_CHANGED: fx,
        } = se),
        (Kf = {}),
        (dx = "refState"),
        (px = (e = Kf, t = {}) => {
          switch (t.type) {
            case cx:
              return Kf;
            case lx: {
              let {
                  elementId: n,
                  element: r,
                  origin: i,
                  actionItem: o,
                  refType: a,
                } = t.payload,
                { actionTypeId: s } = o,
                u = e;
              return (
                (0, St.getIn)(u, [n, r]) !== r && (u = jf(u, r, a, n, o)),
                Ui(u, n, s, i, o)
              );
            }
            case fx: {
              let {
                elementId: n,
                actionTypeId: r,
                current: i,
                actionItem: o,
              } = t.payload;
              return Ui(e, n, r, i, o);
            }
            default:
              return e;
          }
        });
      gx = [
        [tx, ox],
        [nx, ax],
        [rx, sx],
        [ix, ux],
      ];
    });
  var Qf = f((Bi) => {
    "use strict";
    Object.defineProperty(Bi, "__esModule", { value: !0 });
    function Ex(e, t) {
      for (var n in t)
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }
    Ex(Bi, {
      clearPlugin: function () {
        return Ax;
      },
      createPluginInstance: function () {
        return Ix;
      },
      getPluginConfig: function () {
        return yx;
      },
      getPluginDestination: function () {
        return _x;
      },
      getPluginDuration: function () {
        return mx;
      },
      getPluginOrigin: function () {
        return vx;
      },
      renderPlugin: function () {
        return Tx;
      },
    });
    var yx = (e) => e.value,
      mx = (e, t) => {
        if (t.config.duration !== "auto") return null;
        let n = parseFloat(e.getAttribute("data-duration"));
        return n > 0
          ? n * 1e3
          : parseFloat(e.getAttribute("data-default-duration")) * 1e3;
      },
      vx = (e) => e || { value: 0 },
      _x = (e) => ({ value: e.value }),
      Ix = (e) => {
        let t = window.Webflow.require("lottie").createInstance(e);
        return t.stop(), t.setSubframe(!0), t;
      },
      Tx = (e, t, n) => {
        if (!e) return;
        let r = t[n.actionTypeId].value / 100;
        e.goToFrame(e.frames * r);
      },
      Ax = (e) => {
        window.Webflow.require("lottie").createInstance(e).stop();
      };
  });
  var Jf = f((Hi) => {
    "use strict";
    Object.defineProperty(Hi, "__esModule", { value: !0 });
    function bx(e, t) {
      for (var n in t)
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }
    bx(Hi, {
      clearPlugin: function () {
        return Mx;
      },
      createPluginInstance: function () {
        return Lx;
      },
      getPluginConfig: function () {
        return Rx;
      },
      getPluginDestination: function () {
        return Px;
      },
      getPluginDuration: function () {
        return wx;
      },
      getPluginOrigin: function () {
        return Cx;
      },
      renderPlugin: function () {
        return Nx;
      },
    });
    var Sx = (e) => document.querySelector(`[data-w-id="${e}"]`),
      Ox = () => window.Webflow.require("spline"),
      xx = (e, t) => e.filter((n) => !t.includes(n)),
      Rx = (e, t) => e.value[t],
      wx = () => null,
      Zf = Object.freeze({
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1,
      }),
      Cx = (e, t) => {
        let n = t.config.value,
          r = Object.keys(n);
        if (e) {
          let o = Object.keys(e),
            a = xx(r, o);
          return a.length ? a.reduce((u, l) => ((u[l] = Zf[l]), u), e) : e;
        }
        return r.reduce((o, a) => ((o[a] = Zf[a]), o), {});
      },
      Px = (e) => e.value,
      Lx = (e, t) => {
        let n = t?.config?.target?.pluginElement;
        return n ? Sx(n) : null;
      },
      Nx = (e, t, n) => {
        let r = Ox(),
          i = r.getInstance(e),
          o = n.config.target.objectId,
          a = (s) => {
            if (!s)
              throw new Error("Invalid spline app passed to renderSpline");
            let u = o && s.findObjectById(o);
            if (!u) return;
            let { PLUGIN_SPLINE: l } = t;
            l.positionX != null && (u.position.x = l.positionX),
              l.positionY != null && (u.position.y = l.positionY),
              l.positionZ != null && (u.position.z = l.positionZ),
              l.rotationX != null && (u.rotation.x = l.rotationX),
              l.rotationY != null && (u.rotation.y = l.rotationY),
              l.rotationZ != null && (u.rotation.z = l.rotationZ),
              l.scaleX != null && (u.scale.x = l.scaleX),
              l.scaleY != null && (u.scale.y = l.scaleY),
              l.scaleZ != null && (u.scale.z = l.scaleZ);
          };
        i ? a(i.spline) : r.setLoadHandler(e, a);
      },
      Mx = () => null;
  });
  var ed = f((zi) => {
    "use strict";
    Object.defineProperty(zi, "__esModule", { value: !0 });
    function Dx(e, t) {
      for (var n in t)
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }
    Dx(zi, {
      clearPlugin: function () {
        return kx;
      },
      createPluginInstance: function () {
        return Bx;
      },
      getPluginConfig: function () {
        return Gx;
      },
      getPluginDestination: function () {
        return Ux;
      },
      getPluginDuration: function () {
        return Xx;
      },
      getPluginOrigin: function () {
        return Vx;
      },
      renderPlugin: function () {
        return Hx;
      },
    });
    var ki = "--wf-rive-fit",
      Wi = "--wf-rive-alignment",
      Fx = (e) => document.querySelector(`[data-w-id="${e}"]`),
      qx = () => window.Webflow.require("rive"),
      Gx = (e, t) => e.value.inputs[t],
      Xx = () => null,
      Vx = (e, t) => {
        if (e) return e;
        let n = {},
          { inputs: r = {} } = t.config.value;
        for (let i in r) r[i] == null && (n[i] = 0);
        return n;
      },
      Ux = (e) => e.value.inputs ?? {},
      Bx = (e, t) => {
        if ((t.config?.target?.selectorGuids || []).length > 0) return e;
        let r = t?.config?.target?.pluginElement;
        return r ? Fx(r) : null;
      },
      Hx = (e, { PLUGIN_RIVE: t }, n) => {
        let r = qx(),
          i = r.getInstance(e),
          o = r.rive.StateMachineInputType,
          { name: a, inputs: s = {} } = n.config.value || {};
        function u(l) {
          if (l.loaded) g();
          else {
            let p = () => {
              g(), l?.off("load", p);
            };
            l?.on("load", p);
          }
          function g() {
            let p = l.stateMachineInputs(a);
            if (p != null) {
              if ((l.isPlaying || l.play(a, !1), ki in s || Wi in s)) {
                let d = l.layout,
                  E = s[ki] ?? d.fit,
                  I = s[Wi] ?? d.alignment;
                (E !== d.fit || I !== d.alignment) &&
                  (l.layout = d.copyWith({ fit: E, alignment: I }));
              }
              for (let d in s) {
                if (d === ki || d === Wi) continue;
                let E = p.find((I) => I.name === d);
                if (E != null)
                  switch (E.type) {
                    case o.Boolean: {
                      if (s[d] != null) {
                        let I = !!s[d];
                        E.value = I;
                      }
                      break;
                    }
                    case o.Number: {
                      let I = t[d];
                      I != null && (E.value = I);
                      break;
                    }
                    case o.Trigger: {
                      s[d] && E.fire();
                      break;
                    }
                  }
              }
            }
          }
        }
        i?.rive ? u(i.rive) : r.setLoadHandler(e, u);
      },
      kx = (e, t) => null;
  });
  var ji = f((Ki) => {
    "use strict";
    Object.defineProperty(Ki, "__esModule", { value: !0 });
    Object.defineProperty(Ki, "normalizeColor", {
      enumerable: !0,
      get: function () {
        return Wx;
      },
    });
    var td = {
      aliceblue: "#F0F8FF",
      antiquewhite: "#FAEBD7",
      aqua: "#00FFFF",
      aquamarine: "#7FFFD4",
      azure: "#F0FFFF",
      beige: "#F5F5DC",
      bisque: "#FFE4C4",
      black: "#000000",
      blanchedalmond: "#FFEBCD",
      blue: "#0000FF",
      blueviolet: "#8A2BE2",
      brown: "#A52A2A",
      burlywood: "#DEB887",
      cadetblue: "#5F9EA0",
      chartreuse: "#7FFF00",
      chocolate: "#D2691E",
      coral: "#FF7F50",
      cornflowerblue: "#6495ED",
      cornsilk: "#FFF8DC",
      crimson: "#DC143C",
      cyan: "#00FFFF",
      darkblue: "#00008B",
      darkcyan: "#008B8B",
      darkgoldenrod: "#B8860B",
      darkgray: "#A9A9A9",
      darkgreen: "#006400",
      darkgrey: "#A9A9A9",
      darkkhaki: "#BDB76B",
      darkmagenta: "#8B008B",
      darkolivegreen: "#556B2F",
      darkorange: "#FF8C00",
      darkorchid: "#9932CC",
      darkred: "#8B0000",
      darksalmon: "#E9967A",
      darkseagreen: "#8FBC8F",
      darkslateblue: "#483D8B",
      darkslategray: "#2F4F4F",
      darkslategrey: "#2F4F4F",
      darkturquoise: "#00CED1",
      darkviolet: "#9400D3",
      deeppink: "#FF1493",
      deepskyblue: "#00BFFF",
      dimgray: "#696969",
      dimgrey: "#696969",
      dodgerblue: "#1E90FF",
      firebrick: "#B22222",
      floralwhite: "#FFFAF0",
      forestgreen: "#228B22",
      fuchsia: "#FF00FF",
      gainsboro: "#DCDCDC",
      ghostwhite: "#F8F8FF",
      gold: "#FFD700",
      goldenrod: "#DAA520",
      gray: "#808080",
      green: "#008000",
      greenyellow: "#ADFF2F",
      grey: "#808080",
      honeydew: "#F0FFF0",
      hotpink: "#FF69B4",
      indianred: "#CD5C5C",
      indigo: "#4B0082",
      ivory: "#FFFFF0",
      khaki: "#F0E68C",
      lavender: "#E6E6FA",
      lavenderblush: "#FFF0F5",
      lawngreen: "#7CFC00",
      lemonchiffon: "#FFFACD",
      lightblue: "#ADD8E6",
      lightcoral: "#F08080",
      lightcyan: "#E0FFFF",
      lightgoldenrodyellow: "#FAFAD2",
      lightgray: "#D3D3D3",
      lightgreen: "#90EE90",
      lightgrey: "#D3D3D3",
      lightpink: "#FFB6C1",
      lightsalmon: "#FFA07A",
      lightseagreen: "#20B2AA",
      lightskyblue: "#87CEFA",
      lightslategray: "#778899",
      lightslategrey: "#778899",
      lightsteelblue: "#B0C4DE",
      lightyellow: "#FFFFE0",
      lime: "#00FF00",
      limegreen: "#32CD32",
      linen: "#FAF0E6",
      magenta: "#FF00FF",
      maroon: "#800000",
      mediumaquamarine: "#66CDAA",
      mediumblue: "#0000CD",
      mediumorchid: "#BA55D3",
      mediumpurple: "#9370DB",
      mediumseagreen: "#3CB371",
      mediumslateblue: "#7B68EE",
      mediumspringgreen: "#00FA9A",
      mediumturquoise: "#48D1CC",
      mediumvioletred: "#C71585",
      midnightblue: "#191970",
      mintcream: "#F5FFFA",
      mistyrose: "#FFE4E1",
      moccasin: "#FFE4B5",
      navajowhite: "#FFDEAD",
      navy: "#000080",
      oldlace: "#FDF5E6",
      olive: "#808000",
      olivedrab: "#6B8E23",
      orange: "#FFA500",
      orangered: "#FF4500",
      orchid: "#DA70D6",
      palegoldenrod: "#EEE8AA",
      palegreen: "#98FB98",
      paleturquoise: "#AFEEEE",
      palevioletred: "#DB7093",
      papayawhip: "#FFEFD5",
      peachpuff: "#FFDAB9",
      peru: "#CD853F",
      pink: "#FFC0CB",
      plum: "#DDA0DD",
      powderblue: "#B0E0E6",
      purple: "#800080",
      rebeccapurple: "#663399",
      red: "#FF0000",
      rosybrown: "#BC8F8F",
      royalblue: "#4169E1",
      saddlebrown: "#8B4513",
      salmon: "#FA8072",
      sandybrown: "#F4A460",
      seagreen: "#2E8B57",
      seashell: "#FFF5EE",
      sienna: "#A0522D",
      silver: "#C0C0C0",
      skyblue: "#87CEEB",
      slateblue: "#6A5ACD",
      slategray: "#708090",
      slategrey: "#708090",
      snow: "#FFFAFA",
      springgreen: "#00FF7F",
      steelblue: "#4682B4",
      tan: "#D2B48C",
      teal: "#008080",
      thistle: "#D8BFD8",
      tomato: "#FF6347",
      turquoise: "#40E0D0",
      violet: "#EE82EE",
      wheat: "#F5DEB3",
      white: "#FFFFFF",
      whitesmoke: "#F5F5F5",
      yellow: "#FFFF00",
      yellowgreen: "#9ACD32",
    };
    function Wx(e) {
      let t,
        n,
        r,
        i = 1,
        o = e.replace(/\s/g, "").toLowerCase(),
        s = (typeof td[o] == "string" ? td[o].toLowerCase() : null) || o;
      if (s.startsWith("#")) {
        let u = s.substring(1);
        u.length === 3 || u.length === 4
          ? ((t = parseInt(u[0] + u[0], 16)),
            (n = parseInt(u[1] + u[1], 16)),
            (r = parseInt(u[2] + u[2], 16)),
            u.length === 4 && (i = parseInt(u[3] + u[3], 16) / 255))
          : (u.length === 6 || u.length === 8) &&
            ((t = parseInt(u.substring(0, 2), 16)),
            (n = parseInt(u.substring(2, 4), 16)),
            (r = parseInt(u.substring(4, 6), 16)),
            u.length === 8 && (i = parseInt(u.substring(6, 8), 16) / 255));
      } else if (s.startsWith("rgba")) {
        let u = s.match(/rgba\(([^)]+)\)/)[1].split(",");
        (t = parseInt(u[0], 10)),
          (n = parseInt(u[1], 10)),
          (r = parseInt(u[2], 10)),
          (i = parseFloat(u[3]));
      } else if (s.startsWith("rgb")) {
        let u = s.match(/rgb\(([^)]+)\)/)[1].split(",");
        (t = parseInt(u[0], 10)),
          (n = parseInt(u[1], 10)),
          (r = parseInt(u[2], 10));
      } else if (s.startsWith("hsla")) {
        let u = s.match(/hsla\(([^)]+)\)/)[1].split(","),
          l = parseFloat(u[0]),
          g = parseFloat(u[1].replace("%", "")) / 100,
          p = parseFloat(u[2].replace("%", "")) / 100;
        i = parseFloat(u[3]);
        let d = (1 - Math.abs(2 * p - 1)) * g,
          E = d * (1 - Math.abs(((l / 60) % 2) - 1)),
          I = p - d / 2,
          v,
          b,
          m;
        l >= 0 && l < 60
          ? ((v = d), (b = E), (m = 0))
          : l >= 60 && l < 120
          ? ((v = E), (b = d), (m = 0))
          : l >= 120 && l < 180
          ? ((v = 0), (b = d), (m = E))
          : l >= 180 && l < 240
          ? ((v = 0), (b = E), (m = d))
          : l >= 240 && l < 300
          ? ((v = E), (b = 0), (m = d))
          : ((v = d), (b = 0), (m = E)),
          (t = Math.round((v + I) * 255)),
          (n = Math.round((b + I) * 255)),
          (r = Math.round((m + I) * 255));
      } else if (s.startsWith("hsl")) {
        let u = s.match(/hsl\(([^)]+)\)/)[1].split(","),
          l = parseFloat(u[0]),
          g = parseFloat(u[1].replace("%", "")) / 100,
          p = parseFloat(u[2].replace("%", "")) / 100,
          d = (1 - Math.abs(2 * p - 1)) * g,
          E = d * (1 - Math.abs(((l / 60) % 2) - 1)),
          I = p - d / 2,
          v,
          b,
          m;
        l >= 0 && l < 60
          ? ((v = d), (b = E), (m = 0))
          : l >= 60 && l < 120
          ? ((v = E), (b = d), (m = 0))
          : l >= 120 && l < 180
          ? ((v = 0), (b = d), (m = E))
          : l >= 180 && l < 240
          ? ((v = 0), (b = E), (m = d))
          : l >= 240 && l < 300
          ? ((v = E), (b = 0), (m = d))
          : ((v = d), (b = 0), (m = E)),
          (t = Math.round((v + I) * 255)),
          (n = Math.round((b + I) * 255)),
          (r = Math.round((m + I) * 255));
      }
      if (Number.isNaN(t) || Number.isNaN(n) || Number.isNaN(r))
        throw new Error(
          `Invalid color in [ix2/shared/utils/normalizeColor.js] '${e}'`
        );
      return { red: t, green: n, blue: r, alpha: i };
    }
  });
  var nd = f((Yi) => {
    "use strict";
    Object.defineProperty(Yi, "__esModule", { value: !0 });
    function zx(e, t) {
      for (var n in t)
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }
    zx(Yi, {
      clearPlugin: function () {
        return eR;
      },
      createPluginInstance: function () {
        return Zx;
      },
      getPluginConfig: function () {
        return jx;
      },
      getPluginDestination: function () {
        return Qx;
      },
      getPluginDuration: function () {
        return Yx;
      },
      getPluginOrigin: function () {
        return $x;
      },
      renderPlugin: function () {
        return Jx;
      },
    });
    var Kx = ji(),
      jx = (e, t) => e.value[t],
      Yx = () => null,
      $x = (e, t) => {
        if (e) return e;
        let n = t.config.value,
          r = t.config.target.objectId,
          i = getComputedStyle(document.documentElement).getPropertyValue(r);
        if (n.size != null) return { size: parseInt(i, 10) };
        if (n.red != null && n.green != null && n.blue != null)
          return (0, Kx.normalizeColor)(i);
      },
      Qx = (e) => e.value,
      Zx = () => null,
      Jx = (e, t, n) => {
        let r = n.config.target.objectId,
          i = n.config.value.unit,
          { PLUGIN_VARIABLE: o } = t,
          { size: a, red: s, green: u, blue: l, alpha: g } = o,
          p;
        a != null && (p = a + i),
          s != null &&
            l != null &&
            u != null &&
            g != null &&
            (p = `rgba(${s}, ${u}, ${l}, ${g})`),
          p != null && document.documentElement.style.setProperty(r, p);
      },
      eR = (e, t) => {
        let n = t.config.target.objectId;
        document.documentElement.style.removeProperty(n);
      };
  });
  var id = f(($i) => {
    "use strict";
    Object.defineProperty($i, "__esModule", { value: !0 });
    Object.defineProperty($i, "pluginMethodMap", {
      enumerable: !0,
      get: function () {
        return oR;
      },
    });
    var rr = (ve(), Me(ss)),
      tR = ir(Qf()),
      nR = ir(Jf()),
      rR = ir(ed()),
      iR = ir(nd());
    function rd(e) {
      if (typeof WeakMap != "function") return null;
      var t = new WeakMap(),
        n = new WeakMap();
      return (rd = function (r) {
        return r ? n : t;
      })(e);
    }
    function ir(e, t) {
      if (!t && e && e.__esModule) return e;
      if (e === null || (typeof e != "object" && typeof e != "function"))
        return { default: e };
      var n = rd(t);
      if (n && n.has(e)) return n.get(e);
      var r = { __proto__: null },
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var o in e)
        if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
          var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
          a && (a.get || a.set)
            ? Object.defineProperty(r, o, a)
            : (r[o] = e[o]);
        }
      return (r.default = e), n && n.set(e, r), r;
    }
    var oR = new Map([
      [rr.ActionTypeConsts.PLUGIN_LOTTIE, { ...tR }],
      [rr.ActionTypeConsts.PLUGIN_SPLINE, { ...nR }],
      [rr.ActionTypeConsts.PLUGIN_RIVE, { ...rR }],
      [rr.ActionTypeConsts.PLUGIN_VARIABLE, { ...iR }],
    ]);
  });
  var od = {};
  me(od, {
    clearPlugin: () => no,
    createPluginInstance: () => sR,
    getPluginConfig: () => Zi,
    getPluginDestination: () => eo,
    getPluginDuration: () => aR,
    getPluginOrigin: () => Ji,
    isPluginType: () => ot,
    renderPlugin: () => to,
  });
  function ot(e) {
    return Qi.pluginMethodMap.has(e);
  }
  var Qi,
    at,
    Zi,
    Ji,
    aR,
    eo,
    sR,
    to,
    no,
    ro = ne(() => {
      "use strict";
      er();
      Qi = $(id());
      (at = (e) => (t) => {
        if (!Pe) return () => null;
        let n = Qi.pluginMethodMap.get(t);
        if (!n) throw new Error(`IX2 no plugin configured for: ${t}`);
        let r = n[e];
        if (!r) throw new Error(`IX2 invalid plugin method: ${e}`);
        return r;
      }),
        (Zi = at("getPluginConfig")),
        (Ji = at("getPluginOrigin")),
        (aR = at("getPluginDuration")),
        (eo = at("getPluginDestination")),
        (sR = at("createPluginInstance")),
        (to = at("renderPlugin")),
        (no = at("clearPlugin"));
    });
  var sd = f((g1, ad) => {
    function uR(e, t) {
      return e == null || e !== e ? t : e;
    }
    ad.exports = uR;
  });
  var cd = f((h1, ud) => {
    function cR(e, t, n, r) {
      var i = -1,
        o = e == null ? 0 : e.length;
      for (r && o && (n = e[++i]); ++i < o; ) n = t(n, e[i], i, e);
      return n;
    }
    ud.exports = cR;
  });
  var fd = f((E1, ld) => {
    function lR(e) {
      return function (t, n, r) {
        for (var i = -1, o = Object(t), a = r(t), s = a.length; s--; ) {
          var u = a[e ? s : ++i];
          if (n(o[u], u, o) === !1) break;
        }
        return t;
      };
    }
    ld.exports = lR;
  });
  var pd = f((y1, dd) => {
    var fR = fd(),
      dR = fR();
    dd.exports = dR;
  });
  var io = f((m1, gd) => {
    var pR = pd(),
      gR = Jt();
    function hR(e, t) {
      return e && pR(e, t, gR);
    }
    gd.exports = hR;
  });
  var Ed = f((v1, hd) => {
    var ER = rt();
    function yR(e, t) {
      return function (n, r) {
        if (n == null) return n;
        if (!ER(n)) return e(n, r);
        for (
          var i = n.length, o = t ? i : -1, a = Object(n);
          (t ? o-- : ++o < i) && r(a[o], o, a) !== !1;

        );
        return n;
      };
    }
    hd.exports = yR;
  });
  var oo = f((_1, yd) => {
    var mR = io(),
      vR = Ed(),
      _R = vR(mR);
    yd.exports = _R;
  });
  var vd = f((I1, md) => {
    function IR(e, t, n, r, i) {
      return (
        i(e, function (o, a, s) {
          n = r ? ((r = !1), o) : t(n, o, a, s);
        }),
        n
      );
    }
    md.exports = IR;
  });
  var Id = f((T1, _d) => {
    var TR = cd(),
      AR = oo(),
      bR = Je(),
      SR = vd(),
      OR = ue();
    function xR(e, t, n) {
      var r = OR(e) ? TR : SR,
        i = arguments.length < 3;
      return r(e, bR(t, 4), n, i, AR);
    }
    _d.exports = xR;
  });
  var Ad = f((A1, Td) => {
    var RR = Mi(),
      wR = Je(),
      CR = Di(),
      PR = Math.max,
      LR = Math.min;
    function NR(e, t, n) {
      var r = e == null ? 0 : e.length;
      if (!r) return -1;
      var i = r - 1;
      return (
        n !== void 0 &&
          ((i = CR(n)), (i = n < 0 ? PR(r + i, 0) : LR(i, r - 1))),
        RR(e, wR(t, 3), i, !0)
      );
    }
    Td.exports = NR;
  });
  var Sd = f((b1, bd) => {
    var MR = Ni(),
      DR = Ad(),
      FR = MR(DR);
    bd.exports = FR;
  });
  function Od(e, t) {
    return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
  }
  function qR(e, t) {
    if (Od(e, t)) return !0;
    if (
      typeof e != "object" ||
      e === null ||
      typeof t != "object" ||
      t === null
    )
      return !1;
    let n = Object.keys(e),
      r = Object.keys(t);
    if (n.length !== r.length) return !1;
    for (let i = 0; i < n.length; i++)
      if (!Object.hasOwn(t, n[i]) || !Od(e[n[i]], t[n[i]])) return !1;
    return !0;
  }
  var ao,
    xd = ne(() => {
      "use strict";
      ao = qR;
    });
  var Wd = {};
  me(Wd, {
    cleanupHTMLElement: () => Mw,
    clearAllStyles: () => Nw,
    clearObjectCache: () => ew,
    getActionListProgress: () => Fw,
    getAffectedElements: () => fo,
    getComputedStyle: () => uw,
    getDestinationValues: () => hw,
    getElementId: () => iw,
    getInstanceId: () => nw,
    getInstanceOrigin: () => fw,
    getItemConfigByKey: () => gw,
    getMaxDurationItemIndex: () => kd,
    getNamespacedParameterId: () => Xw,
    getRenderType: () => Ud,
    getStyleProp: () => Ew,
    mediaQueriesEqual: () => Uw,
    observeStore: () => sw,
    reduceListToGroup: () => qw,
    reifyState: () => ow,
    renderHTMLElement: () => yw,
    shallowEqual: () => ao,
    shouldAllowMediaQuery: () => Vw,
    shouldNamespaceEventParameter: () => Gw,
    stringifyTarget: () => Bw,
  });
  function ew() {
    or.clear();
  }
  function nw() {
    return "i" + tw++;
  }
  function iw(e, t) {
    for (let n in e) {
      let r = e[n];
      if (r && r.ref === t) return r.id;
    }
    return "e" + rw++;
  }
  function ow({ events: e, actionLists: t, site: n } = {}) {
    let r = (0, cr.default)(
        e,
        (a, s) => {
          let { eventTypeId: u } = s;
          return a[u] || (a[u] = {}), (a[u][s.id] = s), a;
        },
        {}
      ),
      i = n && n.mediaQueries,
      o = [];
    return (
      i
        ? (o = i.map((a) => a.key))
        : ((i = []), console.warn("IX2 missing mediaQueries in site data")),
      {
        ixData: {
          events: e,
          actionLists: t,
          eventTypeMap: r,
          mediaQueries: i,
          mediaQueryKeys: o,
        },
      }
    );
  }
  function sw({ store: e, select: t, onChange: n, comparator: r = aw }) {
    let { getState: i, subscribe: o } = e,
      a = o(u),
      s = t(i());
    function u() {
      let l = t(i());
      if (l == null) {
        a();
        return;
      }
      r(l, s) || ((s = l), n(s, e));
    }
    return a;
  }
  function Cd(e) {
    let t = typeof e;
    if (t === "string") return { id: e };
    if (e != null && t === "object") {
      let {
        id: n,
        objectId: r,
        selector: i,
        selectorGuids: o,
        appliesTo: a,
        useEventTarget: s,
      } = e;
      return {
        id: n,
        objectId: r,
        selector: i,
        selectorGuids: o,
        appliesTo: a,
        useEventTarget: s,
      };
    }
    return {};
  }
  function fo({
    config: e,
    event: t,
    eventTarget: n,
    elementRoot: r,
    elementApi: i,
  }) {
    if (!i) throw new Error("IX2 missing elementApi");
    let { targets: o } = e;
    if (Array.isArray(o) && o.length > 0)
      return o.reduce(
        (C, _) =>
          C.concat(
            fo({
              config: { target: _ },
              event: t,
              eventTarget: n,
              elementRoot: r,
              elementApi: i,
            })
          ),
        []
      );
    let {
        getValidDocument: a,
        getQuerySelector: s,
        queryDocument: u,
        getChildElements: l,
        getSiblingElements: g,
        matchSelector: p,
        elementContains: d,
        isSiblingNode: E,
      } = i,
      { target: I } = e;
    if (!I) return [];
    let {
      id: v,
      objectId: b,
      selector: m,
      selectorGuids: O,
      appliesTo: A,
      useEventTarget: P,
    } = Cd(I);
    if (b) return [or.has(b) ? or.get(b) : or.set(b, {}).get(b)];
    if (A === oi.PAGE) {
      let C = a(v);
      return C ? [C] : [];
    }
    let R = (t?.action?.config?.affectedElements ?? {})[v || m] || {},
      D = !!(R.id || R.selector),
      F,
      G,
      U,
      B = t && s(Cd(t.target));
    if (
      (D
        ? ((F = R.limitAffectedElements), (G = B), (U = s(R)))
        : (G = U = s({ id: v, selector: m, selectorGuids: O })),
      t && P)
    ) {
      let C = n && (U || P === !0) ? [n] : u(B);
      if (U) {
        if (P === QR) return u(U).filter((_) => C.some((w) => d(_, w)));
        if (P === Rd) return u(U).filter((_) => C.some((w) => d(w, _)));
        if (P === wd) return u(U).filter((_) => C.some((w) => E(w, _)));
      }
      return C;
    }
    return G == null || U == null
      ? []
      : Pe && r
      ? u(U).filter((C) => r.contains(C))
      : F === Rd
      ? u(G, U)
      : F === $R
      ? l(u(G)).filter(p(U))
      : F === wd
      ? g(u(G)).filter(p(U))
      : u(U);
  }
  function uw({ element: e, actionItem: t }) {
    if (!Pe) return {};
    let { actionTypeId: n } = t;
    switch (n) {
      case Ct:
      case Pt:
      case Lt:
      case Nt:
      case fr:
        return window.getComputedStyle(e);
      default:
        return {};
    }
  }
  function fw(e, t = {}, n = {}, r, i) {
    let { getStyle: o } = i,
      { actionTypeId: a } = r;
    if (ot(a)) return Ji(a)(t[a], r);
    switch (r.actionTypeId) {
      case xt:
      case Rt:
      case wt:
      case ln:
        return t[r.actionTypeId] || po[r.actionTypeId];
      case fn:
        return cw(t[r.actionTypeId], r.config.filters);
      case dn:
        return lw(t[r.actionTypeId], r.config.fontVariations);
      case Gd:
        return { value: (0, ke.default)(parseFloat(o(e, sr)), 1) };
      case Ct: {
        let s = o(e, Xe),
          u = o(e, Ve),
          l,
          g;
        return (
          r.config.widthUnit === tt
            ? (l = Pd.test(s) ? parseFloat(s) : parseFloat(n.width))
            : (l = (0, ke.default)(parseFloat(s), parseFloat(n.width))),
          r.config.heightUnit === tt
            ? (g = Pd.test(u) ? parseFloat(u) : parseFloat(n.height))
            : (g = (0, ke.default)(parseFloat(u), parseFloat(n.height))),
          { widthValue: l, heightValue: g }
        );
      }
      case Pt:
      case Lt:
      case Nt:
        return Cw({
          element: e,
          actionTypeId: r.actionTypeId,
          computedStyle: n,
          getStyle: o,
        });
      case fr:
        return { value: (0, ke.default)(o(e, ur), n.display) };
      case JR:
        return t[r.actionTypeId] || { value: 0 };
      default:
        return;
    }
  }
  function hw({ element: e, actionItem: t, elementApi: n }) {
    if (ot(t.actionTypeId)) return eo(t.actionTypeId)(t.config);
    switch (t.actionTypeId) {
      case xt:
      case Rt:
      case wt:
      case ln: {
        let { xValue: r, yValue: i, zValue: o } = t.config;
        return { xValue: r, yValue: i, zValue: o };
      }
      case Ct: {
        let { getStyle: r, setStyle: i, getProperty: o } = n,
          { widthUnit: a, heightUnit: s } = t.config,
          { widthValue: u, heightValue: l } = t.config;
        if (!Pe) return { widthValue: u, heightValue: l };
        if (a === tt) {
          let g = r(e, Xe);
          i(e, Xe, ""), (u = o(e, "offsetWidth")), i(e, Xe, g);
        }
        if (s === tt) {
          let g = r(e, Ve);
          i(e, Ve, ""), (l = o(e, "offsetHeight")), i(e, Ve, g);
        }
        return { widthValue: u, heightValue: l };
      }
      case Pt:
      case Lt:
      case Nt: {
        let {
          rValue: r,
          gValue: i,
          bValue: o,
          aValue: a,
          globalSwatchId: s,
        } = t.config;
        if (s && s.startsWith("--")) {
          let { getStyle: u } = n,
            l = u(e, s),
            g = (0, Md.normalizeColor)(l);
          return {
            rValue: g.red,
            gValue: g.green,
            bValue: g.blue,
            aValue: g.alpha,
          };
        }
        return { rValue: r, gValue: i, bValue: o, aValue: a };
      }
      case fn:
        return t.config.filters.reduce(dw, {});
      case dn:
        return t.config.fontVariations.reduce(pw, {});
      default: {
        let { value: r } = t.config;
        return { value: r };
      }
    }
  }
  function Ud(e) {
    if (/^TRANSFORM_/.test(e)) return Fd;
    if (/^STYLE_/.test(e)) return co;
    if (/^GENERAL_/.test(e)) return uo;
    if (/^PLUGIN_/.test(e)) return qd;
  }
  function Ew(e, t) {
    return e === co ? t.replace("STYLE_", "").toLowerCase() : null;
  }
  function yw(e, t, n, r, i, o, a, s, u) {
    switch (s) {
      case Fd:
        return Tw(e, t, n, i, a);
      case co:
        return Pw(e, t, n, i, o, a);
      case uo:
        return Lw(e, i, a);
      case qd: {
        let { actionTypeId: l } = i;
        if (ot(l)) return to(l)(u, t, i);
      }
    }
  }
  function Tw(e, t, n, r, i) {
    let o = Iw.map((s) => {
        let u = po[s],
          {
            xValue: l = u.xValue,
            yValue: g = u.yValue,
            zValue: p = u.zValue,
            xUnit: d = "",
            yUnit: E = "",
            zUnit: I = "",
          } = t[s] || {};
        switch (s) {
          case xt:
            return `${VR}(${l}${d}, ${g}${E}, ${p}${I})`;
          case Rt:
            return `${UR}(${l}${d}, ${g}${E}, ${p}${I})`;
          case wt:
            return `${BR}(${l}${d}) ${HR}(${g}${E}) ${kR}(${p}${I})`;
          case ln:
            return `${WR}(${l}${d}, ${g}${E})`;
          default:
            return "";
        }
      }).join(" "),
      { setStyle: a } = i;
    st(e, et, i), a(e, et, o), Sw(r, n) && a(e, Jn, zR);
  }
  function Aw(e, t, n, r) {
    let i = (0, cr.default)(t, (a, s, u) => `${a} ${u}(${s}${_w(u, n)})`, ""),
      { setStyle: o } = r;
    st(e, sn, r), o(e, sn, i);
  }
  function bw(e, t, n, r) {
    let i = (0, cr.default)(
        t,
        (a, s, u) => (a.push(`"${u}" ${s}`), a),
        []
      ).join(", "),
      { setStyle: o } = r;
    st(e, un, r), o(e, un, i);
  }
  function Sw({ actionTypeId: e }, { xValue: t, yValue: n, zValue: r }) {
    return (
      (e === xt && r !== void 0) ||
      (e === Rt && r !== void 0) ||
      (e === wt && (t !== void 0 || n !== void 0))
    );
  }
  function ww(e, t) {
    let n = e.exec(t);
    return n ? n[1] : "";
  }
  function Cw({ element: e, actionTypeId: t, computedStyle: n, getStyle: r }) {
    let i = lo[t],
      o = r(e, i),
      a = xw.test(o) ? o : n[i],
      s = ww(Rw, a).split(cn);
    return {
      rValue: (0, ke.default)(parseInt(s[0], 10), 255),
      gValue: (0, ke.default)(parseInt(s[1], 10), 255),
      bValue: (0, ke.default)(parseInt(s[2], 10), 255),
      aValue: (0, ke.default)(parseFloat(s[3]), 1),
    };
  }
  function Pw(e, t, n, r, i, o) {
    let { setStyle: a } = o;
    switch (r.actionTypeId) {
      case Ct: {
        let { widthUnit: s = "", heightUnit: u = "" } = r.config,
          { widthValue: l, heightValue: g } = n;
        l !== void 0 && (s === tt && (s = "px"), st(e, Xe, o), a(e, Xe, l + s)),
          g !== void 0 &&
            (u === tt && (u = "px"), st(e, Ve, o), a(e, Ve, g + u));
        break;
      }
      case fn: {
        Aw(e, n, r.config, o);
        break;
      }
      case dn: {
        bw(e, n, r.config, o);
        break;
      }
      case Pt:
      case Lt:
      case Nt: {
        let s = lo[r.actionTypeId],
          u = Math.round(n.rValue),
          l = Math.round(n.gValue),
          g = Math.round(n.bValue),
          p = n.aValue;
        st(e, s, o),
          a(e, s, p >= 1 ? `rgb(${u},${l},${g})` : `rgba(${u},${l},${g},${p})`);
        break;
      }
      default: {
        let { unit: s = "" } = r.config;
        st(e, i, o), a(e, i, n.value + s);
        break;
      }
    }
  }
  function Lw(e, t, n) {
    let { setStyle: r } = n;
    switch (t.actionTypeId) {
      case fr: {
        let { value: i } = t.config;
        i === KR && Pe ? r(e, ur, qi) : r(e, ur, i);
        return;
      }
    }
  }
  function st(e, t, n) {
    if (!Pe) return;
    let r = Vd[t];
    if (!r) return;
    let { getStyle: i, setStyle: o } = n,
      a = i(e, Ot);
    if (!a) {
      o(e, Ot, r);
      return;
    }
    let s = a.split(cn).map(Xd);
    s.indexOf(r) === -1 && o(e, Ot, s.concat(r).join(cn));
  }
  function Bd(e, t, n) {
    if (!Pe) return;
    let r = Vd[t];
    if (!r) return;
    let { getStyle: i, setStyle: o } = n,
      a = i(e, Ot);
    !a ||
      a.indexOf(r) === -1 ||
      o(
        e,
        Ot,
        a
          .split(cn)
          .map(Xd)
          .filter((s) => s !== r)
          .join(cn)
      );
  }
  function Nw({ store: e, elementApi: t }) {
    let { ixData: n } = e.getState(),
      { events: r = {}, actionLists: i = {} } = n;
    Object.keys(r).forEach((o) => {
      let a = r[o],
        { config: s } = a.action,
        { actionListId: u } = s,
        l = i[u];
      l && Ld({ actionList: l, event: a, elementApi: t });
    }),
      Object.keys(i).forEach((o) => {
        Ld({ actionList: i[o], elementApi: t });
      });
  }
  function Ld({ actionList: e = {}, event: t, elementApi: n }) {
    let { actionItemGroups: r, continuousParameterGroups: i } = e;
    r &&
      r.forEach((o) => {
        Nd({ actionGroup: o, event: t, elementApi: n });
      }),
      i &&
        i.forEach((o) => {
          let { continuousActionGroups: a } = o;
          a.forEach((s) => {
            Nd({ actionGroup: s, event: t, elementApi: n });
          });
        });
  }
  function Nd({ actionGroup: e, event: t, elementApi: n }) {
    let { actionItems: r } = e;
    r.forEach((i) => {
      let { actionTypeId: o, config: a } = i,
        s;
      ot(o)
        ? (s = (u) => no(o)(u, i))
        : (s = Hd({ effect: Dw, actionTypeId: o, elementApi: n })),
        fo({ config: a, event: t, elementApi: n }).forEach(s);
    });
  }
  function Mw(e, t, n) {
    let { setStyle: r, getStyle: i } = n,
      { actionTypeId: o } = t;
    if (o === Ct) {
      let { config: a } = t;
      a.widthUnit === tt && r(e, Xe, ""), a.heightUnit === tt && r(e, Ve, "");
    }
    i(e, Ot) && Hd({ effect: Bd, actionTypeId: o, elementApi: n })(e);
  }
  function Dw(e, t, n) {
    let { setStyle: r } = n;
    Bd(e, t, n), r(e, t, ""), t === et && r(e, Jn, "");
  }
  function kd(e) {
    let t = 0,
      n = 0;
    return (
      e.forEach((r, i) => {
        let { config: o } = r,
          a = o.delay + o.duration;
        a >= t && ((t = a), (n = i));
      }),
      n
    );
  }
  function Fw(e, t) {
    let { actionItemGroups: n, useFirstGroupAsInitialState: r } = e,
      { actionItem: i, verboseTimeElapsed: o = 0 } = t,
      a = 0,
      s = 0;
    return (
      n.forEach((u, l) => {
        if (r && l === 0) return;
        let { actionItems: g } = u,
          p = g[kd(g)],
          { config: d, actionTypeId: E } = p;
        i.id === p.id && (s = a + o);
        let I = Ud(E) === uo ? 0 : d.duration;
        a += d.delay + I;
      }),
      a > 0 ? an(s / a) : 0
    );
  }
  function qw({ actionList: e, actionItemId: t, rawData: n }) {
    let { actionItemGroups: r, continuousParameterGroups: i } = e,
      o = [],
      a = (s) => (
        o.push((0, lr.mergeIn)(s, ["config"], { delay: 0, duration: 0 })),
        s.id === t
      );
    return (
      r && r.some(({ actionItems: s }) => s.some(a)),
      i &&
        i.some((s) => {
          let { continuousActionGroups: u } = s;
          return u.some(({ actionItems: l }) => l.some(a));
        }),
      (0, lr.setIn)(n, ["actionLists"], {
        [e.id]: { id: e.id, actionItemGroups: [{ actionItems: o }] },
      })
    );
  }
  function Gw(e, { basedOn: t }) {
    return (
      (e === Ce.SCROLLING_IN_VIEW && (t === qe.ELEMENT || t == null)) ||
      (e === Ce.MOUSE_MOVE && t === qe.ELEMENT)
    );
  }
  function Xw(e, t) {
    return e + ZR + t;
  }
  function Vw(e, t) {
    return t == null ? !0 : e.indexOf(t) !== -1;
  }
  function Uw(e, t) {
    return ao(e && e.sort(), t && t.sort());
  }
  function Bw(e) {
    if (typeof e == "string") return e;
    if (e.pluginElement && e.objectId) return e.pluginElement + so + e.objectId;
    if (e.objectId) return e.objectId;
    let { id: t = "", selector: n = "", useEventTarget: r = "" } = e;
    return t + so + n + so + r;
  }
  var ke,
    cr,
    ar,
    lr,
    Md,
    GR,
    XR,
    VR,
    UR,
    BR,
    HR,
    kR,
    WR,
    zR,
    KR,
    sr,
    sn,
    un,
    Xe,
    Ve,
    Dd,
    jR,
    YR,
    Rd,
    $R,
    wd,
    QR,
    ur,
    Ot,
    tt,
    cn,
    ZR,
    so,
    Fd,
    uo,
    co,
    qd,
    xt,
    Rt,
    wt,
    ln,
    Gd,
    fn,
    dn,
    Ct,
    Pt,
    Lt,
    Nt,
    fr,
    JR,
    Xd,
    lo,
    Vd,
    or,
    tw,
    rw,
    aw,
    Pd,
    cw,
    lw,
    dw,
    pw,
    gw,
    po,
    mw,
    vw,
    _w,
    Iw,
    Ow,
    xw,
    Rw,
    Hd,
    zd = ne(() => {
      "use strict";
      (ke = $(sd())), (cr = $(Id())), (ar = $(Sd())), (lr = $(Et()));
      ve();
      xd();
      Vi();
      Md = $(ji());
      ro();
      er();
      ({
        BACKGROUND: GR,
        TRANSFORM: XR,
        TRANSLATE_3D: VR,
        SCALE_3D: UR,
        ROTATE_X: BR,
        ROTATE_Y: HR,
        ROTATE_Z: kR,
        SKEW: WR,
        PRESERVE_3D: zR,
        FLEX: KR,
        OPACITY: sr,
        FILTER: sn,
        FONT_VARIATION_SETTINGS: un,
        WIDTH: Xe,
        HEIGHT: Ve,
        BACKGROUND_COLOR: Dd,
        BORDER_COLOR: jR,
        COLOR: YR,
        CHILDREN: Rd,
        IMMEDIATE_CHILDREN: $R,
        SIBLINGS: wd,
        PARENT: QR,
        DISPLAY: ur,
        WILL_CHANGE: Ot,
        AUTO: tt,
        COMMA_DELIMITER: cn,
        COLON_DELIMITER: ZR,
        BAR_DELIMITER: so,
        RENDER_TRANSFORM: Fd,
        RENDER_GENERAL: uo,
        RENDER_STYLE: co,
        RENDER_PLUGIN: qd,
      } = ce),
        ({
          TRANSFORM_MOVE: xt,
          TRANSFORM_SCALE: Rt,
          TRANSFORM_ROTATE: wt,
          TRANSFORM_SKEW: ln,
          STYLE_OPACITY: Gd,
          STYLE_FILTER: fn,
          STYLE_FONT_VARIATION: dn,
          STYLE_SIZE: Ct,
          STYLE_BACKGROUND_COLOR: Pt,
          STYLE_BORDER: Lt,
          STYLE_TEXT_COLOR: Nt,
          GENERAL_DISPLAY: fr,
          OBJECT_VALUE: JR,
        } = pe),
        (Xd = (e) => e.trim()),
        (lo = Object.freeze({ [Pt]: Dd, [Lt]: jR, [Nt]: YR })),
        (Vd = Object.freeze({
          [et]: XR,
          [Dd]: GR,
          [sr]: sr,
          [sn]: sn,
          [Xe]: Xe,
          [Ve]: Ve,
          [un]: un,
        })),
        (or = new Map());
      tw = 1;
      rw = 1;
      aw = (e, t) => e === t;
      (Pd = /px/),
        (cw = (e, t) =>
          t.reduce(
            (n, r) => (n[r.type] == null && (n[r.type] = mw[r.type]), n),
            e || {}
          )),
        (lw = (e, t) =>
          t.reduce(
            (n, r) => (
              n[r.type] == null &&
                (n[r.type] = vw[r.type] || r.defaultValue || 0),
              n
            ),
            e || {}
          ));
      (dw = (e, t) => (t && (e[t.type] = t.value || 0), e)),
        (pw = (e, t) => (t && (e[t.type] = t.value || 0), e)),
        (gw = (e, t, n) => {
          if (ot(e)) return Zi(e)(n, t);
          switch (e) {
            case fn: {
              let r = (0, ar.default)(n.filters, ({ type: i }) => i === t);
              return r ? r.value : 0;
            }
            case dn: {
              let r = (0, ar.default)(
                n.fontVariations,
                ({ type: i }) => i === t
              );
              return r ? r.value : 0;
            }
            default:
              return n[t];
          }
        });
      (po = {
        [xt]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [Rt]: Object.freeze({ xValue: 1, yValue: 1, zValue: 1 }),
        [wt]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [ln]: Object.freeze({ xValue: 0, yValue: 0 }),
      }),
        (mw = Object.freeze({
          blur: 0,
          "hue-rotate": 0,
          invert: 0,
          grayscale: 0,
          saturate: 100,
          sepia: 0,
          contrast: 100,
          brightness: 100,
        })),
        (vw = Object.freeze({ wght: 0, opsz: 0, wdth: 0, slnt: 0 })),
        (_w = (e, t) => {
          let n = (0, ar.default)(t.filters, ({ type: r }) => r === e);
          if (n && n.unit) return n.unit;
          switch (e) {
            case "blur":
              return "px";
            case "hue-rotate":
              return "deg";
            default:
              return "%";
          }
        }),
        (Iw = Object.keys(po));
      (Ow = "\\(([^)]+)\\)"), (xw = /^rgb/), (Rw = RegExp(`rgba?${Ow}`));
      Hd =
        ({ effect: e, actionTypeId: t, elementApi: n }) =>
        (r) => {
          switch (t) {
            case xt:
            case Rt:
            case wt:
            case ln:
              e(r, et, n);
              break;
            case fn:
              e(r, sn, n);
              break;
            case dn:
              e(r, un, n);
              break;
            case Gd:
              e(r, sr, n);
              break;
            case Ct:
              e(r, Xe, n), e(r, Ve, n);
              break;
            case Pt:
            case Lt:
            case Nt:
              e(r, lo[t], n);
              break;
            case fr:
              e(r, ur, n);
              break;
          }
        };
    });
  var ut = f((go) => {
    "use strict";
    Object.defineProperty(go, "__esModule", { value: !0 });
    function Hw(e, t) {
      for (var n in t)
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }
    Hw(go, {
      IX2BrowserSupport: function () {
        return kw;
      },
      IX2EasingUtils: function () {
        return zw;
      },
      IX2Easings: function () {
        return Ww;
      },
      IX2ElementsReducer: function () {
        return Kw;
      },
      IX2VanillaPlugins: function () {
        return jw;
      },
      IX2VanillaUtils: function () {
        return Yw;
      },
    });
    var kw = Mt((er(), Me(Xf))),
      Ww = Mt((Xi(), Me(on))),
      zw = Mt((Vi(), Me(zf))),
      Kw = Mt(($f(), Me(Yf))),
      jw = Mt((ro(), Me(od))),
      Yw = Mt((zd(), Me(Wd)));
    function Kd(e) {
      if (typeof WeakMap != "function") return null;
      var t = new WeakMap(),
        n = new WeakMap();
      return (Kd = function (r) {
        return r ? n : t;
      })(e);
    }
    function Mt(e, t) {
      if (!t && e && e.__esModule) return e;
      if (e === null || (typeof e != "object" && typeof e != "function"))
        return { default: e };
      var n = Kd(t);
      if (n && n.has(e)) return n.get(e);
      var r = { __proto__: null },
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var o in e)
        if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
          var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
          a && (a.get || a.set)
            ? Object.defineProperty(r, o, a)
            : (r[o] = e[o]);
        }
      return (r.default = e), n && n.set(e, r), r;
    }
  });
  var pr,
    We,
    $w,
    Qw,
    Zw,
    Jw,
    eC,
    tC,
    dr,
    jd,
    nC,
    rC,
    ho,
    iC,
    oC,
    aC,
    sC,
    Yd,
    $d = ne(() => {
      "use strict";
      ve();
      (pr = $(ut())),
        (We = $(Et())),
        ({
          IX2_RAW_DATA_IMPORTED: $w,
          IX2_SESSION_STOPPED: Qw,
          IX2_INSTANCE_ADDED: Zw,
          IX2_INSTANCE_STARTED: Jw,
          IX2_INSTANCE_REMOVED: eC,
          IX2_ANIMATION_FRAME_CHANGED: tC,
        } = se),
        ({
          optimizeFloat: dr,
          applyEasing: jd,
          createBezierEasing: nC,
        } = pr.IX2EasingUtils),
        ({ RENDER_GENERAL: rC } = ce),
        ({
          getItemConfigByKey: ho,
          getRenderType: iC,
          getStyleProp: oC,
        } = pr.IX2VanillaUtils),
        (aC = (e, t) => {
          let {
              position: n,
              parameterId: r,
              actionGroups: i,
              destinationKeys: o,
              smoothing: a,
              restingValue: s,
              actionTypeId: u,
              customEasingFn: l,
              skipMotion: g,
              skipToValue: p,
            } = e,
            { parameters: d } = t.payload,
            E = Math.max(1 - a, 0.01),
            I = d[r];
          I == null && ((E = 1), (I = s));
          let v = Math.max(I, 0) || 0,
            b = dr(v - n),
            m = g ? p : dr(n + b * E),
            O = m * 100;
          if (m === n && e.current) return e;
          let A, P, L, R;
          for (let F = 0, { length: G } = i; F < G; F++) {
            let { keyframe: U, actionItems: B } = i[F];
            if ((F === 0 && (A = B[0]), O >= U)) {
              A = B[0];
              let C = i[F + 1],
                _ = C && O !== U;
              (P = _ ? C.actionItems[0] : null),
                _ && ((L = U / 100), (R = (C.keyframe - U) / 100));
            }
          }
          let D = {};
          if (A && !P)
            for (let F = 0, { length: G } = o; F < G; F++) {
              let U = o[F];
              D[U] = ho(u, U, A.config);
            }
          else if (A && P && L !== void 0 && R !== void 0) {
            let F = (m - L) / R,
              G = A.config.easing,
              U = jd(G, F, l);
            for (let B = 0, { length: C } = o; B < C; B++) {
              let _ = o[B],
                w = ho(u, _, A.config),
                W = (ho(u, _, P.config) - w) * U + w;
              D[_] = W;
            }
          }
          return (0, We.merge)(e, { position: m, current: D });
        }),
        (sC = (e, t) => {
          let {
              active: n,
              origin: r,
              start: i,
              immediate: o,
              renderType: a,
              verbose: s,
              actionItem: u,
              destination: l,
              destinationKeys: g,
              pluginDuration: p,
              instanceDelay: d,
              customEasingFn: E,
              skipMotion: I,
            } = e,
            v = u.config.easing,
            { duration: b, delay: m } = u.config;
          p != null && (b = p),
            (m = d ?? m),
            a === rC ? (b = 0) : (o || I) && (b = m = 0);
          let { now: O } = t.payload;
          if (n && r) {
            let A = O - (i + m);
            if (s) {
              let F = O - i,
                G = b + m,
                U = dr(Math.min(Math.max(0, F / G), 1));
              e = (0, We.set)(e, "verboseTimeElapsed", G * U);
            }
            if (A < 0) return e;
            let P = dr(Math.min(Math.max(0, A / b), 1)),
              L = jd(v, P, E),
              R = {},
              D = null;
            return (
              g.length &&
                (D = g.reduce((F, G) => {
                  let U = l[G],
                    B = parseFloat(r[G]) || 0,
                    _ = (parseFloat(U) - B) * L + B;
                  return (F[G] = _), F;
                }, {})),
              (R.current = D),
              (R.position = P),
              P === 1 && ((R.active = !1), (R.complete = !0)),
              (0, We.merge)(e, R)
            );
          }
          return e;
        }),
        (Yd = (e = Object.freeze({}), t) => {
          switch (t.type) {
            case $w:
              return t.payload.ixInstances || Object.freeze({});
            case Qw:
              return Object.freeze({});
            case Zw: {
              let {
                  instanceId: n,
                  elementId: r,
                  actionItem: i,
                  eventId: o,
                  eventTarget: a,
                  eventStateKey: s,
                  actionListId: u,
                  groupIndex: l,
                  isCarrier: g,
                  origin: p,
                  destination: d,
                  immediate: E,
                  verbose: I,
                  continuous: v,
                  parameterId: b,
                  actionGroups: m,
                  smoothing: O,
                  restingValue: A,
                  pluginInstance: P,
                  pluginDuration: L,
                  instanceDelay: R,
                  skipMotion: D,
                  skipToValue: F,
                } = t.payload,
                { actionTypeId: G } = i,
                U = iC(G),
                B = oC(U, G),
                C = Object.keys(d).filter(
                  (w) => d[w] != null && typeof d[w] != "string"
                ),
                { easing: _ } = i.config;
              return (0, We.set)(e, n, {
                id: n,
                elementId: r,
                active: !1,
                position: 0,
                start: 0,
                origin: p,
                destination: d,
                destinationKeys: C,
                immediate: E,
                verbose: I,
                current: null,
                actionItem: i,
                actionTypeId: G,
                eventId: o,
                eventTarget: a,
                eventStateKey: s,
                actionListId: u,
                groupIndex: l,
                renderType: U,
                isCarrier: g,
                styleProp: B,
                continuous: v,
                parameterId: b,
                actionGroups: m,
                smoothing: O,
                restingValue: A,
                pluginInstance: P,
                pluginDuration: L,
                instanceDelay: R,
                skipMotion: D,
                skipToValue: F,
                customEasingFn:
                  Array.isArray(_) && _.length === 4 ? nC(_) : void 0,
              });
            }
            case Jw: {
              let { instanceId: n, time: r } = t.payload;
              return (0, We.mergeIn)(e, [n], {
                active: !0,
                complete: !1,
                start: r,
              });
            }
            case eC: {
              let { instanceId: n } = t.payload;
              if (!e[n]) return e;
              let r = {},
                i = Object.keys(e),
                { length: o } = i;
              for (let a = 0; a < o; a++) {
                let s = i[a];
                s !== n && (r[s] = e[s]);
              }
              return r;
            }
            case tC: {
              let n = e,
                r = Object.keys(e),
                { length: i } = r;
              for (let o = 0; o < i; o++) {
                let a = r[o],
                  s = e[a],
                  u = s.continuous ? aC : sC;
                n = (0, We.set)(n, a, u(s, t));
              }
              return n;
            }
            default:
              return e;
          }
        });
    });
  var uC,
    cC,
    lC,
    Qd,
    Zd = ne(() => {
      "use strict";
      ve();
      ({
        IX2_RAW_DATA_IMPORTED: uC,
        IX2_SESSION_STOPPED: cC,
        IX2_PARAMETER_CHANGED: lC,
      } = se),
        (Qd = (e = {}, t) => {
          switch (t.type) {
            case uC:
              return t.payload.ixParameters || {};
            case cC:
              return {};
            case lC: {
              let { key: n, value: r } = t.payload;
              return (e[n] = r), e;
            }
            default:
              return e;
          }
        });
    });
  var tp = {};
  me(tp, { default: () => dC });
  var Jd,
    ep,
    fC,
    dC,
    np = ne(() => {
      "use strict";
      Jd = $(ii());
      cs();
      Cs();
      Ns();
      ep = $(ut());
      $d();
      Zd();
      ({ ixElements: fC } = ep.IX2ElementsReducer),
        (dC = (0, Jd.combineReducers)({
          ixData: us,
          ixRequest: ws,
          ixSession: Ls,
          ixElements: fC,
          ixInstances: Yd,
          ixParameters: Qd,
        }));
    });
  var ip = f((B1, rp) => {
    var pC = Qe(),
      gC = ue(),
      hC = Be(),
      EC = "[object String]";
    function yC(e) {
      return typeof e == "string" || (!gC(e) && hC(e) && pC(e) == EC);
    }
    rp.exports = yC;
  });
  var ap = f((H1, op) => {
    var mC = Li(),
      vC = mC("length");
    op.exports = vC;
  });
  var up = f((k1, sp) => {
    var _C = "\\ud800-\\udfff",
      IC = "\\u0300-\\u036f",
      TC = "\\ufe20-\\ufe2f",
      AC = "\\u20d0-\\u20ff",
      bC = IC + TC + AC,
      SC = "\\ufe0e\\ufe0f",
      OC = "\\u200d",
      xC = RegExp("[" + OC + _C + bC + SC + "]");
    function RC(e) {
      return xC.test(e);
    }
    sp.exports = RC;
  });
  var yp = f((W1, Ep) => {
    var lp = "\\ud800-\\udfff",
      wC = "\\u0300-\\u036f",
      CC = "\\ufe20-\\ufe2f",
      PC = "\\u20d0-\\u20ff",
      LC = wC + CC + PC,
      NC = "\\ufe0e\\ufe0f",
      MC = "[" + lp + "]",
      Eo = "[" + LC + "]",
      yo = "\\ud83c[\\udffb-\\udfff]",
      DC = "(?:" + Eo + "|" + yo + ")",
      fp = "[^" + lp + "]",
      dp = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      pp = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      FC = "\\u200d",
      gp = DC + "?",
      hp = "[" + NC + "]?",
      qC = "(?:" + FC + "(?:" + [fp, dp, pp].join("|") + ")" + hp + gp + ")*",
      GC = hp + gp + qC,
      XC = "(?:" + [fp + Eo + "?", Eo, dp, pp, MC].join("|") + ")",
      cp = RegExp(yo + "(?=" + yo + ")|" + XC + GC, "g");
    function VC(e) {
      for (var t = (cp.lastIndex = 0); cp.test(e); ) ++t;
      return t;
    }
    Ep.exports = VC;
  });
  var vp = f((z1, mp) => {
    var UC = ap(),
      BC = up(),
      HC = yp();
    function kC(e) {
      return BC(e) ? HC(e) : UC(e);
    }
    mp.exports = kC;
  });
  var Ip = f((K1, _p) => {
    var WC = kn(),
      zC = Wn(),
      KC = rt(),
      jC = ip(),
      YC = vp(),
      $C = "[object Map]",
      QC = "[object Set]";
    function ZC(e) {
      if (e == null) return 0;
      if (KC(e)) return jC(e) ? YC(e) : e.length;
      var t = zC(e);
      return t == $C || t == QC ? e.size : WC(e).length;
    }
    _p.exports = ZC;
  });
  var Ap = f((j1, Tp) => {
    var JC = "Expected a function";
    function eP(e) {
      if (typeof e != "function") throw new TypeError(JC);
      return function () {
        var t = arguments;
        switch (t.length) {
          case 0:
            return !e.call(this);
          case 1:
            return !e.call(this, t[0]);
          case 2:
            return !e.call(this, t[0], t[1]);
          case 3:
            return !e.call(this, t[0], t[1], t[2]);
        }
        return !e.apply(this, t);
      };
    }
    Tp.exports = eP;
  });
  var mo = f((Y1, bp) => {
    var tP = Ze(),
      nP = (function () {
        try {
          var e = tP(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch {}
      })();
    bp.exports = nP;
  });
  var vo = f(($1, Op) => {
    var Sp = mo();
    function rP(e, t, n) {
      t == "__proto__" && Sp
        ? Sp(e, t, { configurable: !0, enumerable: !0, value: n, writable: !0 })
        : (e[t] = n);
    }
    Op.exports = rP;
  });
  var Rp = f((Q1, xp) => {
    var iP = vo(),
      oP = Mn(),
      aP = Object.prototype,
      sP = aP.hasOwnProperty;
    function uP(e, t, n) {
      var r = e[t];
      (!(sP.call(e, t) && oP(r, n)) || (n === void 0 && !(t in e))) &&
        iP(e, t, n);
    }
    xp.exports = uP;
  });
  var Pp = f((Z1, Cp) => {
    var cP = Rp(),
      lP = tn(),
      fP = Vn(),
      wp = Ge(),
      dP = bt();
    function pP(e, t, n, r) {
      if (!wp(e)) return e;
      t = lP(t, e);
      for (var i = -1, o = t.length, a = o - 1, s = e; s != null && ++i < o; ) {
        var u = dP(t[i]),
          l = n;
        if (u === "__proto__" || u === "constructor" || u === "prototype")
          return e;
        if (i != a) {
          var g = s[u];
          (l = r ? r(g, u, s) : void 0),
            l === void 0 && (l = wp(g) ? g : fP(t[i + 1]) ? [] : {});
        }
        cP(s, u, l), (s = s[u]);
      }
      return e;
    }
    Cp.exports = pP;
  });
  var Np = f((J1, Lp) => {
    var gP = jn(),
      hP = Pp(),
      EP = tn();
    function yP(e, t, n) {
      for (var r = -1, i = t.length, o = {}; ++r < i; ) {
        var a = t[r],
          s = gP(e, a);
        n(s, a) && hP(o, EP(a, e), s);
      }
      return o;
    }
    Lp.exports = yP;
  });
  var Dp = f((eG, Mp) => {
    var mP = Gn(),
      vP = Wr(),
      _P = yi(),
      IP = Ei(),
      TP = Object.getOwnPropertySymbols,
      AP = TP
        ? function (e) {
            for (var t = []; e; ) mP(t, _P(e)), (e = vP(e));
            return t;
          }
        : IP;
    Mp.exports = AP;
  });
  var qp = f((tG, Fp) => {
    function bP(e) {
      var t = [];
      if (e != null) for (var n in Object(e)) t.push(n);
      return t;
    }
    Fp.exports = bP;
  });
  var Xp = f((nG, Gp) => {
    var SP = Ge(),
      OP = Hn(),
      xP = qp(),
      RP = Object.prototype,
      wP = RP.hasOwnProperty;
    function CP(e) {
      if (!SP(e)) return xP(e);
      var t = OP(e),
        n = [];
      for (var r in e)
        (r == "constructor" && (t || !wP.call(e, r))) || n.push(r);
      return n;
    }
    Gp.exports = CP;
  });
  var Up = f((rG, Vp) => {
    var PP = vi(),
      LP = Xp(),
      NP = rt();
    function MP(e) {
      return NP(e) ? PP(e, !0) : LP(e);
    }
    Vp.exports = MP;
  });
  var Hp = f((iG, Bp) => {
    var DP = hi(),
      FP = Dp(),
      qP = Up();
    function GP(e) {
      return DP(e, qP, FP);
    }
    Bp.exports = GP;
  });
  var Wp = f((oG, kp) => {
    var XP = Pi(),
      VP = Je(),
      UP = Np(),
      BP = Hp();
    function HP(e, t) {
      if (e == null) return {};
      var n = XP(BP(e), function (r) {
        return [r];
      });
      return (
        (t = VP(t)),
        UP(e, n, function (r, i) {
          return t(r, i[0]);
        })
      );
    }
    kp.exports = HP;
  });
  var Kp = f((aG, zp) => {
    var kP = Je(),
      WP = Ap(),
      zP = Wp();
    function KP(e, t) {
      return zP(e, WP(kP(t)));
    }
    zp.exports = KP;
  });
  var Yp = f((sG, jp) => {
    var jP = kn(),
      YP = Wn(),
      $P = Yt(),
      QP = ue(),
      ZP = rt(),
      JP = Xn(),
      eL = Hn(),
      tL = Bn(),
      nL = "[object Map]",
      rL = "[object Set]",
      iL = Object.prototype,
      oL = iL.hasOwnProperty;
    function aL(e) {
      if (e == null) return !0;
      if (
        ZP(e) &&
        (QP(e) ||
          typeof e == "string" ||
          typeof e.splice == "function" ||
          JP(e) ||
          tL(e) ||
          $P(e))
      )
        return !e.length;
      var t = YP(e);
      if (t == nL || t == rL) return !e.size;
      if (eL(e)) return !jP(e).length;
      for (var n in e) if (oL.call(e, n)) return !1;
      return !0;
    }
    jp.exports = aL;
  });
  var Qp = f((uG, $p) => {
    var sL = vo(),
      uL = io(),
      cL = Je();
    function lL(e, t) {
      var n = {};
      return (
        (t = cL(t, 3)),
        uL(e, function (r, i, o) {
          sL(n, i, t(r, i, o));
        }),
        n
      );
    }
    $p.exports = lL;
  });
  var Jp = f((cG, Zp) => {
    function fL(e, t) {
      for (
        var n = -1, r = e == null ? 0 : e.length;
        ++n < r && t(e[n], n, e) !== !1;

      );
      return e;
    }
    Zp.exports = fL;
  });
  var tg = f((lG, eg) => {
    var dL = $n();
    function pL(e) {
      return typeof e == "function" ? e : dL;
    }
    eg.exports = pL;
  });
  var rg = f((fG, ng) => {
    var gL = Jp(),
      hL = oo(),
      EL = tg(),
      yL = ue();
    function mL(e, t) {
      var n = yL(e) ? gL : hL;
      return n(e, EL(t));
    }
    ng.exports = mL;
  });
  var og = f((dG, ig) => {
    var vL = we(),
      _L = function () {
        return vL.Date.now();
      };
    ig.exports = _L;
  });
  var ug = f((pG, sg) => {
    var IL = Ge(),
      _o = og(),
      ag = Qn(),
      TL = "Expected a function",
      AL = Math.max,
      bL = Math.min;
    function SL(e, t, n) {
      var r,
        i,
        o,
        a,
        s,
        u,
        l = 0,
        g = !1,
        p = !1,
        d = !0;
      if (typeof e != "function") throw new TypeError(TL);
      (t = ag(t) || 0),
        IL(n) &&
          ((g = !!n.leading),
          (p = "maxWait" in n),
          (o = p ? AL(ag(n.maxWait) || 0, t) : o),
          (d = "trailing" in n ? !!n.trailing : d));
      function E(R) {
        var D = r,
          F = i;
        return (r = i = void 0), (l = R), (a = e.apply(F, D)), a;
      }
      function I(R) {
        return (l = R), (s = setTimeout(m, t)), g ? E(R) : a;
      }
      function v(R) {
        var D = R - u,
          F = R - l,
          G = t - D;
        return p ? bL(G, o - F) : G;
      }
      function b(R) {
        var D = R - u,
          F = R - l;
        return u === void 0 || D >= t || D < 0 || (p && F >= o);
      }
      function m() {
        var R = _o();
        if (b(R)) return O(R);
        s = setTimeout(m, v(R));
      }
      function O(R) {
        return (s = void 0), d && r ? E(R) : ((r = i = void 0), a);
      }
      function A() {
        s !== void 0 && clearTimeout(s), (l = 0), (r = u = i = s = void 0);
      }
      function P() {
        return s === void 0 ? a : O(_o());
      }
      function L() {
        var R = _o(),
          D = b(R);
        if (((r = arguments), (i = this), (u = R), D)) {
          if (s === void 0) return I(u);
          if (p) return clearTimeout(s), (s = setTimeout(m, t)), E(u);
        }
        return s === void 0 && (s = setTimeout(m, t)), a;
      }
      return (L.cancel = A), (L.flush = P), L;
    }
    sg.exports = SL;
  });
  var lg = f((gG, cg) => {
    var OL = ug(),
      xL = Ge(),
      RL = "Expected a function";
    function wL(e, t, n) {
      var r = !0,
        i = !0;
      if (typeof e != "function") throw new TypeError(RL);
      return (
        xL(n) &&
          ((r = "leading" in n ? !!n.leading : r),
          (i = "trailing" in n ? !!n.trailing : i)),
        OL(e, t, { leading: r, maxWait: t, trailing: i })
      );
    }
    cg.exports = wL;
  });
  var dg = {};
  me(dg, {
    actionListPlaybackChanged: () => Ft,
    animationFrameChanged: () => hr,
    clearRequested: () => eN,
    elementStateChanged: () => Ro,
    eventListenerAdded: () => gr,
    eventStateChanged: () => So,
    instanceAdded: () => Oo,
    instanceRemoved: () => xo,
    instanceStarted: () => Er,
    mediaQueriesDefined: () => Co,
    parameterChanged: () => Dt,
    playbackRequested: () => ZL,
    previewRequested: () => QL,
    rawDataImported: () => Io,
    sessionInitialized: () => To,
    sessionStarted: () => Ao,
    sessionStopped: () => bo,
    stopRequested: () => JL,
    testFrameRendered: () => tN,
    viewportWidthChanged: () => wo,
  });
  var fg,
    CL,
    PL,
    LL,
    NL,
    ML,
    DL,
    FL,
    qL,
    GL,
    XL,
    VL,
    UL,
    BL,
    HL,
    kL,
    WL,
    zL,
    KL,
    jL,
    YL,
    $L,
    Io,
    To,
    Ao,
    bo,
    QL,
    ZL,
    JL,
    eN,
    gr,
    tN,
    So,
    hr,
    Dt,
    Oo,
    Er,
    xo,
    Ro,
    Ft,
    wo,
    Co,
    yr = ne(() => {
      "use strict";
      ve();
      (fg = $(ut())),
        ({
          IX2_RAW_DATA_IMPORTED: CL,
          IX2_SESSION_INITIALIZED: PL,
          IX2_SESSION_STARTED: LL,
          IX2_SESSION_STOPPED: NL,
          IX2_PREVIEW_REQUESTED: ML,
          IX2_PLAYBACK_REQUESTED: DL,
          IX2_STOP_REQUESTED: FL,
          IX2_CLEAR_REQUESTED: qL,
          IX2_EVENT_LISTENER_ADDED: GL,
          IX2_TEST_FRAME_RENDERED: XL,
          IX2_EVENT_STATE_CHANGED: VL,
          IX2_ANIMATION_FRAME_CHANGED: UL,
          IX2_PARAMETER_CHANGED: BL,
          IX2_INSTANCE_ADDED: HL,
          IX2_INSTANCE_STARTED: kL,
          IX2_INSTANCE_REMOVED: WL,
          IX2_ELEMENT_STATE_CHANGED: zL,
          IX2_ACTION_LIST_PLAYBACK_CHANGED: KL,
          IX2_VIEWPORT_WIDTH_CHANGED: jL,
          IX2_MEDIA_QUERIES_DEFINED: YL,
        } = se),
        ({ reifyState: $L } = fg.IX2VanillaUtils),
        (Io = (e) => ({ type: CL, payload: { ...$L(e) } })),
        (To = ({ hasBoundaryNodes: e, reducedMotion: t }) => ({
          type: PL,
          payload: { hasBoundaryNodes: e, reducedMotion: t },
        })),
        (Ao = () => ({ type: LL })),
        (bo = () => ({ type: NL })),
        (QL = ({ rawData: e, defer: t }) => ({
          type: ML,
          payload: { defer: t, rawData: e },
        })),
        (ZL = ({
          actionTypeId: e = pe.GENERAL_START_ACTION,
          actionListId: t,
          actionItemId: n,
          eventId: r,
          allowEvents: i,
          immediate: o,
          testManual: a,
          verbose: s,
          rawData: u,
        }) => ({
          type: DL,
          payload: {
            actionTypeId: e,
            actionListId: t,
            actionItemId: n,
            testManual: a,
            eventId: r,
            allowEvents: i,
            immediate: o,
            verbose: s,
            rawData: u,
          },
        })),
        (JL = (e) => ({ type: FL, payload: { actionListId: e } })),
        (eN = () => ({ type: qL })),
        (gr = (e, t) => ({
          type: GL,
          payload: { target: e, listenerParams: t },
        })),
        (tN = (e = 1) => ({ type: XL, payload: { step: e } })),
        (So = (e, t) => ({ type: VL, payload: { stateKey: e, newState: t } })),
        (hr = (e, t) => ({ type: UL, payload: { now: e, parameters: t } })),
        (Dt = (e, t) => ({ type: BL, payload: { key: e, value: t } })),
        (Oo = (e) => ({ type: HL, payload: { ...e } })),
        (Er = (e, t) => ({ type: kL, payload: { instanceId: e, time: t } })),
        (xo = (e) => ({ type: WL, payload: { instanceId: e } })),
        (Ro = (e, t, n, r) => ({
          type: zL,
          payload: { elementId: e, actionTypeId: t, current: n, actionItem: r },
        })),
        (Ft = ({ actionListId: e, isPlaying: t }) => ({
          type: KL,
          payload: { actionListId: e, isPlaying: t },
        })),
        (wo = ({ width: e, mediaQueries: t }) => ({
          type: jL,
          payload: { width: e, mediaQueries: t },
        })),
        (Co = () => ({ type: YL }));
    });
  var he = {};
  me(he, {
    elementContains: () => No,
    getChildElements: () => fN,
    getClosestElement: () => pn,
    getProperty: () => aN,
    getQuerySelector: () => Lo,
    getRefType: () => Mo,
    getSiblingElements: () => dN,
    getStyle: () => oN,
    getValidDocument: () => uN,
    isSiblingNode: () => lN,
    matchSelector: () => sN,
    queryDocument: () => cN,
    setStyle: () => iN,
  });
  function iN(e, t, n) {
    e.style[t] = n;
  }
  function oN(e, t) {
    return t.startsWith("--")
      ? window.getComputedStyle(document.documentElement).getPropertyValue(t)
      : e.style[t];
  }
  function aN(e, t) {
    return e[t];
  }
  function sN(e) {
    return (t) => t[Po](e);
  }
  function Lo({ id: e, selector: t }) {
    if (e) {
      let n = e;
      if (e.indexOf(pg) !== -1) {
        let r = e.split(pg),
          i = r[0];
        if (((n = r[1]), i !== document.documentElement.getAttribute(hg)))
          return null;
      }
      return `[data-w-id="${n}"], [data-w-id^="${n}_instance"]`;
    }
    return t;
  }
  function uN(e) {
    return e == null || e === document.documentElement.getAttribute(hg)
      ? document
      : null;
  }
  function cN(e, t) {
    return Array.prototype.slice.call(
      document.querySelectorAll(t ? e + " " + t : e)
    );
  }
  function No(e, t) {
    return e.contains(t);
  }
  function lN(e, t) {
    return e !== t && e.parentNode === t.parentNode;
  }
  function fN(e) {
    let t = [];
    for (let n = 0, { length: r } = e || []; n < r; n++) {
      let { children: i } = e[n],
        { length: o } = i;
      if (o) for (let a = 0; a < o; a++) t.push(i[a]);
    }
    return t;
  }
  function dN(e = []) {
    let t = [],
      n = [];
    for (let r = 0, { length: i } = e; r < i; r++) {
      let { parentNode: o } = e[r];
      if (!o || !o.children || !o.children.length || n.indexOf(o) !== -1)
        continue;
      n.push(o);
      let a = o.firstElementChild;
      for (; a != null; )
        e.indexOf(a) === -1 && t.push(a), (a = a.nextElementSibling);
    }
    return t;
  }
  function Mo(e) {
    return e != null && typeof e == "object"
      ? e instanceof Element
        ? nN
        : rN
      : null;
  }
  var gg,
    Po,
    pg,
    nN,
    rN,
    hg,
    pn,
    Eg = ne(() => {
      "use strict";
      gg = $(ut());
      ve();
      ({ ELEMENT_MATCHES: Po } = gg.IX2BrowserSupport),
        ({
          IX2_ID_DELIMITER: pg,
          HTML_ELEMENT: nN,
          PLAIN_OBJECT: rN,
          WF_PAGE: hg,
        } = ce);
      pn = Element.prototype.closest
        ? (e, t) => (document.documentElement.contains(e) ? e.closest(t) : null)
        : (e, t) => {
            if (!document.documentElement.contains(e)) return null;
            let n = e;
            do {
              if (n[Po] && n[Po](t)) return n;
              n = n.parentNode;
            } while (n != null);
            return null;
          };
    });
  var Do = f((yG, mg) => {
    var pN = Ge(),
      yg = Object.create,
      gN = (function () {
        function e() {}
        return function (t) {
          if (!pN(t)) return {};
          if (yg) return yg(t);
          e.prototype = t;
          var n = new e();
          return (e.prototype = void 0), n;
        };
      })();
    mg.exports = gN;
  });
  var mr = f((mG, vg) => {
    function hN() {}
    vg.exports = hN;
  });
  var _r = f((vG, _g) => {
    var EN = Do(),
      yN = mr();
    function vr(e, t) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__chain__ = !!t),
        (this.__index__ = 0),
        (this.__values__ = void 0);
    }
    vr.prototype = EN(yN.prototype);
    vr.prototype.constructor = vr;
    _g.exports = vr;
  });
  var bg = f((_G, Ag) => {
    var Ig = pt(),
      mN = Yt(),
      vN = ue(),
      Tg = Ig ? Ig.isConcatSpreadable : void 0;
    function _N(e) {
      return vN(e) || mN(e) || !!(Tg && e && e[Tg]);
    }
    Ag.exports = _N;
  });
  var xg = f((IG, Og) => {
    var IN = Gn(),
      TN = bg();
    function Sg(e, t, n, r, i) {
      var o = -1,
        a = e.length;
      for (n || (n = TN), i || (i = []); ++o < a; ) {
        var s = e[o];
        t > 0 && n(s)
          ? t > 1
            ? Sg(s, t - 1, n, r, i)
            : IN(i, s)
          : r || (i[i.length] = s);
      }
      return i;
    }
    Og.exports = Sg;
  });
  var wg = f((TG, Rg) => {
    var AN = xg();
    function bN(e) {
      var t = e == null ? 0 : e.length;
      return t ? AN(e, 1) : [];
    }
    Rg.exports = bN;
  });
  var Pg = f((AG, Cg) => {
    function SN(e, t, n) {
      switch (n.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, n[0]);
        case 2:
          return e.call(t, n[0], n[1]);
        case 3:
          return e.call(t, n[0], n[1], n[2]);
      }
      return e.apply(t, n);
    }
    Cg.exports = SN;
  });
  var Mg = f((bG, Ng) => {
    var ON = Pg(),
      Lg = Math.max;
    function xN(e, t, n) {
      return (
        (t = Lg(t === void 0 ? e.length - 1 : t, 0)),
        function () {
          for (
            var r = arguments, i = -1, o = Lg(r.length - t, 0), a = Array(o);
            ++i < o;

          )
            a[i] = r[t + i];
          i = -1;
          for (var s = Array(t + 1); ++i < t; ) s[i] = r[i];
          return (s[t] = n(a)), ON(e, this, s);
        }
      );
    }
    Ng.exports = xN;
  });
  var Fg = f((SG, Dg) => {
    function RN(e) {
      return function () {
        return e;
      };
    }
    Dg.exports = RN;
  });
  var Xg = f((OG, Gg) => {
    var wN = Fg(),
      qg = mo(),
      CN = $n(),
      PN = qg
        ? function (e, t) {
            return qg(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: wN(t),
              writable: !0,
            });
          }
        : CN;
    Gg.exports = PN;
  });
  var Ug = f((xG, Vg) => {
    var LN = 800,
      NN = 16,
      MN = Date.now;
    function DN(e) {
      var t = 0,
        n = 0;
      return function () {
        var r = MN(),
          i = NN - (r - n);
        if (((n = r), i > 0)) {
          if (++t >= LN) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    }
    Vg.exports = DN;
  });
  var Hg = f((RG, Bg) => {
    var FN = Xg(),
      qN = Ug(),
      GN = qN(FN);
    Bg.exports = GN;
  });
  var Wg = f((wG, kg) => {
    var XN = wg(),
      VN = Mg(),
      UN = Hg();
    function BN(e) {
      return UN(VN(e, void 0, XN), e + "");
    }
    kg.exports = BN;
  });
  var jg = f((CG, Kg) => {
    var zg = _i(),
      HN = zg && new zg();
    Kg.exports = HN;
  });
  var $g = f((PG, Yg) => {
    function kN() {}
    Yg.exports = kN;
  });
  var Fo = f((LG, Zg) => {
    var Qg = jg(),
      WN = $g(),
      zN = Qg
        ? function (e) {
            return Qg.get(e);
          }
        : WN;
    Zg.exports = zN;
  });
  var eh = f((NG, Jg) => {
    var KN = {};
    Jg.exports = KN;
  });
  var qo = f((MG, nh) => {
    var th = eh(),
      jN = Object.prototype,
      YN = jN.hasOwnProperty;
    function $N(e) {
      for (
        var t = e.name + "", n = th[t], r = YN.call(th, t) ? n.length : 0;
        r--;

      ) {
        var i = n[r],
          o = i.func;
        if (o == null || o == e) return i.name;
      }
      return t;
    }
    nh.exports = $N;
  });
  var Tr = f((DG, rh) => {
    var QN = Do(),
      ZN = mr(),
      JN = 4294967295;
    function Ir(e) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__dir__ = 1),
        (this.__filtered__ = !1),
        (this.__iteratees__ = []),
        (this.__takeCount__ = JN),
        (this.__views__ = []);
    }
    Ir.prototype = QN(ZN.prototype);
    Ir.prototype.constructor = Ir;
    rh.exports = Ir;
  });
  var oh = f((FG, ih) => {
    function eM(e, t) {
      var n = -1,
        r = e.length;
      for (t || (t = Array(r)); ++n < r; ) t[n] = e[n];
      return t;
    }
    ih.exports = eM;
  });
  var sh = f((qG, ah) => {
    var tM = Tr(),
      nM = _r(),
      rM = oh();
    function iM(e) {
      if (e instanceof tM) return e.clone();
      var t = new nM(e.__wrapped__, e.__chain__);
      return (
        (t.__actions__ = rM(e.__actions__)),
        (t.__index__ = e.__index__),
        (t.__values__ = e.__values__),
        t
      );
    }
    ah.exports = iM;
  });
  var lh = f((GG, ch) => {
    var oM = Tr(),
      uh = _r(),
      aM = mr(),
      sM = ue(),
      uM = Be(),
      cM = sh(),
      lM = Object.prototype,
      fM = lM.hasOwnProperty;
    function Ar(e) {
      if (uM(e) && !sM(e) && !(e instanceof oM)) {
        if (e instanceof uh) return e;
        if (fM.call(e, "__wrapped__")) return cM(e);
      }
      return new uh(e);
    }
    Ar.prototype = aM.prototype;
    Ar.prototype.constructor = Ar;
    ch.exports = Ar;
  });
  var dh = f((XG, fh) => {
    var dM = Tr(),
      pM = Fo(),
      gM = qo(),
      hM = lh();
    function EM(e) {
      var t = gM(e),
        n = hM[t];
      if (typeof n != "function" || !(t in dM.prototype)) return !1;
      if (e === n) return !0;
      var r = pM(n);
      return !!r && e === r[0];
    }
    fh.exports = EM;
  });
  var Eh = f((VG, hh) => {
    var ph = _r(),
      yM = Wg(),
      mM = Fo(),
      Go = qo(),
      vM = ue(),
      gh = dh(),
      _M = "Expected a function",
      IM = 8,
      TM = 32,
      AM = 128,
      bM = 256;
    function SM(e) {
      return yM(function (t) {
        var n = t.length,
          r = n,
          i = ph.prototype.thru;
        for (e && t.reverse(); r--; ) {
          var o = t[r];
          if (typeof o != "function") throw new TypeError(_M);
          if (i && !a && Go(o) == "wrapper") var a = new ph([], !0);
        }
        for (r = a ? r : n; ++r < n; ) {
          o = t[r];
          var s = Go(o),
            u = s == "wrapper" ? mM(o) : void 0;
          u &&
          gh(u[0]) &&
          u[1] == (AM | IM | TM | bM) &&
          !u[4].length &&
          u[9] == 1
            ? (a = a[Go(u[0])].apply(a, u[3]))
            : (a = o.length == 1 && gh(o) ? a[s]() : a.thru(o));
        }
        return function () {
          var l = arguments,
            g = l[0];
          if (a && l.length == 1 && vM(g)) return a.plant(g).value();
          for (var p = 0, d = n ? t[p].apply(this, l) : g; ++p < n; )
            d = t[p].call(this, d);
          return d;
        };
      });
    }
    hh.exports = SM;
  });
  var mh = f((UG, yh) => {
    var OM = Eh(),
      xM = OM();
    yh.exports = xM;
  });
  var _h = f((BG, vh) => {
    function RM(e, t, n) {
      return (
        e === e &&
          (n !== void 0 && (e = e <= n ? e : n),
          t !== void 0 && (e = e >= t ? e : t)),
        e
      );
    }
    vh.exports = RM;
  });
  var Th = f((HG, Ih) => {
    var wM = _h(),
      Xo = Qn();
    function CM(e, t, n) {
      return (
        n === void 0 && ((n = t), (t = void 0)),
        n !== void 0 && ((n = Xo(n)), (n = n === n ? n : 0)),
        t !== void 0 && ((t = Xo(t)), (t = t === t ? t : 0)),
        wM(Xo(e), t, n)
      );
    }
    Ih.exports = CM;
  });
  var Ph,
    Lh,
    Nh,
    Mh,
    PM,
    LM,
    NM,
    MM,
    DM,
    FM,
    qM,
    GM,
    XM,
    VM,
    UM,
    BM,
    HM,
    kM,
    WM,
    Dh,
    Fh,
    zM,
    KM,
    jM,
    qh,
    YM,
    $M,
    Gh,
    QM,
    Vo,
    Xh,
    Ah,
    bh,
    Vh,
    hn,
    ZM,
    Ue,
    Uh,
    JM,
    Ie,
    Le,
    En,
    Bh,
    Uo,
    Sh,
    Bo,
    eD,
    gn,
    tD,
    nD,
    rD,
    Hh,
    Oh,
    iD,
    xh,
    oD,
    aD,
    sD,
    Rh,
    br,
    Sr,
    wh,
    Ch,
    kh,
    Wh = ne(() => {
      "use strict";
      (Ph = $(mh())), (Lh = $(Yn())), (Nh = $(Th()));
      ve();
      Ho();
      yr();
      (Mh = $(ut())),
        ({
          MOUSE_CLICK: PM,
          MOUSE_SECOND_CLICK: LM,
          MOUSE_DOWN: NM,
          MOUSE_UP: MM,
          MOUSE_OVER: DM,
          MOUSE_OUT: FM,
          DROPDOWN_CLOSE: qM,
          DROPDOWN_OPEN: GM,
          SLIDER_ACTIVE: XM,
          SLIDER_INACTIVE: VM,
          TAB_ACTIVE: UM,
          TAB_INACTIVE: BM,
          NAVBAR_CLOSE: HM,
          NAVBAR_OPEN: kM,
          MOUSE_MOVE: WM,
          PAGE_SCROLL_DOWN: Dh,
          SCROLL_INTO_VIEW: Fh,
          SCROLL_OUT_OF_VIEW: zM,
          PAGE_SCROLL_UP: KM,
          SCROLLING_IN_VIEW: jM,
          PAGE_FINISH: qh,
          ECOMMERCE_CART_CLOSE: YM,
          ECOMMERCE_CART_OPEN: $M,
          PAGE_START: Gh,
          PAGE_SCROLL: QM,
        } = Ce),
        (Vo = "COMPONENT_ACTIVE"),
        (Xh = "COMPONENT_INACTIVE"),
        ({ COLON_DELIMITER: Ah } = ce),
        ({ getNamespacedParameterId: bh } = Mh.IX2VanillaUtils),
        (Vh = (e) => (t) => typeof t == "object" && e(t) ? !0 : t),
        (hn = Vh(({ element: e, nativeEvent: t }) => e === t.target)),
        (ZM = Vh(({ element: e, nativeEvent: t }) => e.contains(t.target))),
        (Ue = (0, Ph.default)([hn, ZM])),
        (Uh = (e, t) => {
          if (t) {
            let { ixData: n } = e.getState(),
              { events: r } = n,
              i = r[t];
            if (i && !eD[i.eventTypeId]) return i;
          }
          return null;
        }),
        (JM = ({ store: e, event: t }) => {
          let { action: n } = t,
            { autoStopEventId: r } = n.config;
          return !!Uh(e, r);
        }),
        (Ie = ({ store: e, event: t, element: n, eventStateKey: r }, i) => {
          let { action: o, id: a } = t,
            { actionListId: s, autoStopEventId: u } = o.config,
            l = Uh(e, u);
          return (
            l &&
              qt({
                store: e,
                eventId: u,
                eventTarget: n,
                eventStateKey: u + Ah + r.split(Ah)[1],
                actionListId: (0, Lh.default)(l, "action.config.actionListId"),
              }),
            qt({
              store: e,
              eventId: a,
              eventTarget: n,
              eventStateKey: r,
              actionListId: s,
            }),
            yn({
              store: e,
              eventId: a,
              eventTarget: n,
              eventStateKey: r,
              actionListId: s,
            }),
            i
          );
        }),
        (Le = (e, t) => (n, r) => e(n, r) === !0 ? t(n, r) : r),
        (En = { handler: Le(Ue, Ie) }),
        (Bh = { ...En, types: [Vo, Xh].join(" ") }),
        (Uo = [
          { target: window, types: "resize orientationchange", throttle: !0 },
          {
            target: document,
            types: "scroll wheel readystatechange IX2_PAGE_UPDATE",
            throttle: !0,
          },
        ]),
        (Sh = "mouseover mouseout"),
        (Bo = { types: Uo }),
        (eD = { PAGE_START: Gh, PAGE_FINISH: qh }),
        (gn = (() => {
          let e = window.pageXOffset !== void 0,
            n =
              document.compatMode === "CSS1Compat"
                ? document.documentElement
                : document.body;
          return () => ({
            scrollLeft: e ? window.pageXOffset : n.scrollLeft,
            scrollTop: e ? window.pageYOffset : n.scrollTop,
            stiffScrollTop: (0, Nh.default)(
              e ? window.pageYOffset : n.scrollTop,
              0,
              n.scrollHeight - window.innerHeight
            ),
            scrollWidth: n.scrollWidth,
            scrollHeight: n.scrollHeight,
            clientWidth: n.clientWidth,
            clientHeight: n.clientHeight,
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
          });
        })()),
        (tD = (e, t) =>
          !(
            e.left > t.right ||
            e.right < t.left ||
            e.top > t.bottom ||
            e.bottom < t.top
          )),
        (nD = ({ element: e, nativeEvent: t }) => {
          let { type: n, target: r, relatedTarget: i } = t,
            o = e.contains(r);
          if (n === "mouseover" && o) return !0;
          let a = e.contains(i);
          return !!(n === "mouseout" && o && a);
        }),
        (rD = (e) => {
          let {
              element: t,
              event: { config: n },
            } = e,
            { clientWidth: r, clientHeight: i } = gn(),
            o = n.scrollOffsetValue,
            u = n.scrollOffsetUnit === "PX" ? o : (i * (o || 0)) / 100;
          return tD(t.getBoundingClientRect(), {
            left: 0,
            top: u,
            right: r,
            bottom: i - u,
          });
        }),
        (Hh = (e) => (t, n) => {
          let { type: r } = t.nativeEvent,
            i = [Vo, Xh].indexOf(r) !== -1 ? r === Vo : n.isActive,
            o = { ...n, isActive: i };
          return ((!n || o.isActive !== n.isActive) && e(t, o)) || o;
        }),
        (Oh = (e) => (t, n) => {
          let r = { elementHovered: nD(t) };
          return (
            ((n ? r.elementHovered !== n.elementHovered : r.elementHovered) &&
              e(t, r)) ||
            r
          );
        }),
        (iD = (e) => (t, n) => {
          let r = { ...n, elementVisible: rD(t) };
          return (
            ((n ? r.elementVisible !== n.elementVisible : r.elementVisible) &&
              e(t, r)) ||
            r
          );
        }),
        (xh =
          (e) =>
          (t, n = {}) => {
            let { stiffScrollTop: r, scrollHeight: i, innerHeight: o } = gn(),
              {
                event: { config: a, eventTypeId: s },
              } = t,
              { scrollOffsetValue: u, scrollOffsetUnit: l } = a,
              g = l === "PX",
              p = i - o,
              d = Number((r / p).toFixed(2));
            if (n && n.percentTop === d) return n;
            let E = (g ? u : (o * (u || 0)) / 100) / p,
              I,
              v,
              b = 0;
            n &&
              ((I = d > n.percentTop),
              (v = n.scrollingDown !== I),
              (b = v ? d : n.anchorTop));
            let m = s === Dh ? d >= b + E : d <= b - E,
              O = {
                ...n,
                percentTop: d,
                inBounds: m,
                anchorTop: b,
                scrollingDown: I,
              };
            return (n && m && (v || O.inBounds !== n.inBounds) && e(t, O)) || O;
          }),
        (oD = (e, t) =>
          e.left > t.left &&
          e.left < t.right &&
          e.top > t.top &&
          e.top < t.bottom),
        (aD = (e) => (t, n) => {
          let r = { finished: document.readyState === "complete" };
          return r.finished && !(n && n.finshed) && e(t), r;
        }),
        (sD = (e) => (t, n) => {
          let r = { started: !0 };
          return n || e(t), r;
        }),
        (Rh =
          (e) =>
          (t, n = { clickCount: 0 }) => {
            let r = { clickCount: (n.clickCount % 2) + 1 };
            return (r.clickCount !== n.clickCount && e(t, r)) || r;
          }),
        (br = (e = !0) => ({
          ...Bh,
          handler: Le(
            e ? Ue : hn,
            Hh((t, n) => (n.isActive ? En.handler(t, n) : n))
          ),
        })),
        (Sr = (e = !0) => ({
          ...Bh,
          handler: Le(
            e ? Ue : hn,
            Hh((t, n) => (n.isActive ? n : En.handler(t, n)))
          ),
        })),
        (wh = {
          ...Bo,
          handler: iD((e, t) => {
            let { elementVisible: n } = t,
              { event: r, store: i } = e,
              { ixData: o } = i.getState(),
              { events: a } = o;
            return !a[r.action.config.autoStopEventId] && t.triggered
              ? t
              : (r.eventTypeId === Fh) === n
              ? (Ie(e), { ...t, triggered: !0 })
              : t;
          }),
        }),
        (Ch = 0.05),
        (kh = {
          [XM]: br(),
          [VM]: Sr(),
          [GM]: br(),
          [qM]: Sr(),
          [kM]: br(!1),
          [HM]: Sr(!1),
          [UM]: br(),
          [BM]: Sr(),
          [$M]: { types: "ecommerce-cart-open", handler: Le(Ue, Ie) },
          [YM]: { types: "ecommerce-cart-close", handler: Le(Ue, Ie) },
          [PM]: {
            types: "click",
            handler: Le(
              Ue,
              Rh((e, { clickCount: t }) => {
                JM(e) ? t === 1 && Ie(e) : Ie(e);
              })
            ),
          },
          [LM]: {
            types: "click",
            handler: Le(
              Ue,
              Rh((e, { clickCount: t }) => {
                t === 2 && Ie(e);
              })
            ),
          },
          [NM]: { ...En, types: "mousedown" },
          [MM]: { ...En, types: "mouseup" },
          [DM]: {
            types: Sh,
            handler: Le(
              Ue,
              Oh((e, t) => {
                t.elementHovered && Ie(e);
              })
            ),
          },
          [FM]: {
            types: Sh,
            handler: Le(
              Ue,
              Oh((e, t) => {
                t.elementHovered || Ie(e);
              })
            ),
          },
          [WM]: {
            types: "mousemove mouseout scroll",
            handler: (
              {
                store: e,
                element: t,
                eventConfig: n,
                nativeEvent: r,
                eventStateKey: i,
              },
              o = { clientX: 0, clientY: 0, pageX: 0, pageY: 0 }
            ) => {
              let {
                  basedOn: a,
                  selectedAxis: s,
                  continuousParameterGroupId: u,
                  reverse: l,
                  restingState: g = 0,
                } = n,
                {
                  clientX: p = o.clientX,
                  clientY: d = o.clientY,
                  pageX: E = o.pageX,
                  pageY: I = o.pageY,
                } = r,
                v = s === "X_AXIS",
                b = r.type === "mouseout",
                m = g / 100,
                O = u,
                A = !1;
              switch (a) {
                case qe.VIEWPORT: {
                  m = v
                    ? Math.min(p, window.innerWidth) / window.innerWidth
                    : Math.min(d, window.innerHeight) / window.innerHeight;
                  break;
                }
                case qe.PAGE: {
                  let {
                    scrollLeft: P,
                    scrollTop: L,
                    scrollWidth: R,
                    scrollHeight: D,
                  } = gn();
                  m = v ? Math.min(P + E, R) / R : Math.min(L + I, D) / D;
                  break;
                }
                case qe.ELEMENT:
                default: {
                  O = bh(i, u);
                  let P = r.type.indexOf("mouse") === 0;
                  if (P && Ue({ element: t, nativeEvent: r }) !== !0) break;
                  let L = t.getBoundingClientRect(),
                    { left: R, top: D, width: F, height: G } = L;
                  if (!P && !oD({ left: p, top: d }, L)) break;
                  (A = !0), (m = v ? (p - R) / F : (d - D) / G);
                  break;
                }
              }
              return (
                b && (m > 1 - Ch || m < Ch) && (m = Math.round(m)),
                (a !== qe.ELEMENT || A || A !== o.elementHovered) &&
                  ((m = l ? 1 - m : m), e.dispatch(Dt(O, m))),
                {
                  elementHovered: A,
                  clientX: p,
                  clientY: d,
                  pageX: E,
                  pageY: I,
                }
              );
            },
          },
          [QM]: {
            types: Uo,
            handler: ({ store: e, eventConfig: t }) => {
              let { continuousParameterGroupId: n, reverse: r } = t,
                { scrollTop: i, scrollHeight: o, clientHeight: a } = gn(),
                s = i / (o - a);
              (s = r ? 1 - s : s), e.dispatch(Dt(n, s));
            },
          },
          [jM]: {
            types: Uo,
            handler: (
              { element: e, store: t, eventConfig: n, eventStateKey: r },
              i = { scrollPercent: 0 }
            ) => {
              let {
                  scrollLeft: o,
                  scrollTop: a,
                  scrollWidth: s,
                  scrollHeight: u,
                  clientHeight: l,
                } = gn(),
                {
                  basedOn: g,
                  selectedAxis: p,
                  continuousParameterGroupId: d,
                  startsEntering: E,
                  startsExiting: I,
                  addEndOffset: v,
                  addStartOffset: b,
                  addOffsetValue: m = 0,
                  endOffsetValue: O = 0,
                } = n,
                A = p === "X_AXIS";
              if (g === qe.VIEWPORT) {
                let P = A ? o / s : a / u;
                return (
                  P !== i.scrollPercent && t.dispatch(Dt(d, P)),
                  { scrollPercent: P }
                );
              } else {
                let P = bh(r, d),
                  L = e.getBoundingClientRect(),
                  R = (b ? m : 0) / 100,
                  D = (v ? O : 0) / 100;
                (R = E ? R : 1 - R), (D = I ? D : 1 - D);
                let F = L.top + Math.min(L.height * R, l),
                  U = L.top + L.height * D - F,
                  B = Math.min(l + U, u),
                  _ = Math.min(Math.max(0, l - F), B) / B;
                return (
                  _ !== i.scrollPercent && t.dispatch(Dt(P, _)),
                  { scrollPercent: _ }
                );
              }
            },
          },
          [Fh]: wh,
          [zM]: wh,
          [Dh]: {
            ...Bo,
            handler: xh((e, t) => {
              t.scrollingDown && Ie(e);
            }),
          },
          [KM]: {
            ...Bo,
            handler: xh((e, t) => {
              t.scrollingDown || Ie(e);
            }),
          },
          [qh]: {
            types: "readystatechange IX2_PAGE_UPDATE",
            handler: Le(hn, aD(Ie)),
          },
          [Gh]: {
            types: "readystatechange IX2_PAGE_UPDATE",
            handler: Le(hn, sD(Ie)),
          },
        });
    });
  var uE = {};
  me(uE, {
    observeRequests: () => xD,
    startActionGroup: () => yn,
    startEngine: () => Pr,
    stopActionGroup: () => qt,
    stopAllActionGroups: () => oE,
    stopEngine: () => Lr,
  });
  function xD(e) {
    ct({ store: e, select: ({ ixRequest: t }) => t.preview, onChange: CD }),
      ct({ store: e, select: ({ ixRequest: t }) => t.playback, onChange: PD }),
      ct({ store: e, select: ({ ixRequest: t }) => t.stop, onChange: LD }),
      ct({ store: e, select: ({ ixRequest: t }) => t.clear, onChange: ND });
  }
  function RD(e) {
    ct({
      store: e,
      select: ({ ixSession: t }) => t.mediaQueryKey,
      onChange: () => {
        Lr(e),
          tE({ store: e, elementApi: he }),
          Pr({ store: e, allowEvents: !0 }),
          nE();
      },
    });
  }
  function wD(e, t) {
    let n = ct({
      store: e,
      select: ({ ixSession: r }) => r.tick,
      onChange: (r) => {
        t(r), n();
      },
    });
  }
  function CD({ rawData: e, defer: t }, n) {
    let r = () => {
      Pr({ store: n, rawData: e, allowEvents: !0 }), nE();
    };
    t ? setTimeout(r, 0) : r();
  }
  function nE() {
    document.dispatchEvent(new CustomEvent("IX2_PAGE_UPDATE"));
  }
  function PD(e, t) {
    let {
        actionTypeId: n,
        actionListId: r,
        actionItemId: i,
        eventId: o,
        allowEvents: a,
        immediate: s,
        testManual: u,
        verbose: l = !0,
      } = e,
      { rawData: g } = e;
    if (r && i && g && s) {
      let p = g.actionLists[r];
      p && (g = ED({ actionList: p, actionItemId: i, rawData: g }));
    }
    if (
      (Pr({ store: t, rawData: g, allowEvents: a, testManual: u }),
      (r && n === pe.GENERAL_START_ACTION) || ko(n))
    ) {
      qt({ store: t, actionListId: r }),
        iE({ store: t, actionListId: r, eventId: o });
      let p = yn({
        store: t,
        eventId: o,
        actionListId: r,
        immediate: s,
        verbose: l,
      });
      l && p && t.dispatch(Ft({ actionListId: r, isPlaying: !s }));
    }
  }
  function LD({ actionListId: e }, t) {
    e ? qt({ store: t, actionListId: e }) : oE({ store: t }), Lr(t);
  }
  function ND(e, t) {
    Lr(t), tE({ store: t, elementApi: he });
  }
  function Pr({ store: e, rawData: t, allowEvents: n, testManual: r }) {
    let { ixSession: i } = e.getState();
    t && e.dispatch(Io(t)),
      i.active ||
        (e.dispatch(
          To({
            hasBoundaryNodes: !!document.querySelector(xr),
            reducedMotion:
              document.body.hasAttribute("data-wf-ix-vacation") &&
              window.matchMedia("(prefers-reduced-motion)").matches,
          })
        ),
        n &&
          (XD(e), MD(), e.getState().ixSession.hasDefinedMediaQueries && RD(e)),
        e.dispatch(Ao()),
        DD(e, r));
  }
  function MD() {
    let { documentElement: e } = document;
    e.className.indexOf(zh) === -1 && (e.className += ` ${zh}`);
  }
  function DD(e, t) {
    let n = (r) => {
      let { ixSession: i, ixParameters: o } = e.getState();
      i.active &&
        (e.dispatch(hr(r, o)), t ? wD(e, n) : requestAnimationFrame(n));
    };
    n(window.performance.now());
  }
  function Lr(e) {
    let { ixSession: t } = e.getState();
    if (t.active) {
      let { eventListeners: n } = t;
      n.forEach(FD), _D(), e.dispatch(bo());
    }
  }
  function FD({ target: e, listenerParams: t }) {
    e.removeEventListener.apply(e, t);
  }
  function qD({
    store: e,
    eventStateKey: t,
    eventTarget: n,
    eventId: r,
    eventConfig: i,
    actionListId: o,
    parameterGroup: a,
    smoothing: s,
    restingValue: u,
  }) {
    let { ixData: l, ixSession: g } = e.getState(),
      { events: p } = l,
      d = p[r],
      { eventTypeId: E } = d,
      I = {},
      v = {},
      b = [],
      { continuousActionGroups: m } = a,
      { id: O } = a;
    yD(E, i) && (O = mD(t, O));
    let A = g.hasBoundaryNodes && n ? pn(n, xr) : null;
    m.forEach((P) => {
      let { keyframe: L, actionItems: R } = P;
      R.forEach((D) => {
        let { actionTypeId: F } = D,
          { target: G } = D.config;
        if (!G) return;
        let U = G.boundaryMode ? A : null,
          B = ID(G) + Wo + F;
        if (((v[B] = GD(v[B], L, D)), !I[B])) {
          I[B] = !0;
          let { config: C } = D;
          Rr({
            config: C,
            event: d,
            eventTarget: n,
            elementRoot: U,
            elementApi: he,
          }).forEach((_) => {
            b.push({ element: _, key: B });
          });
        }
      });
    }),
      b.forEach(({ element: P, key: L }) => {
        let R = v[L],
          D = (0, ze.default)(R, "[0].actionItems[0]", {}),
          { actionTypeId: F } = D,
          U = (
            F === pe.PLUGIN_RIVE
              ? (D.config?.target?.selectorGuids || []).length === 0
              : Cr(F)
          )
            ? Ko(F)(P, D)
            : null,
          B = zo({ element: P, actionItem: D, elementApi: he }, U);
        jo({
          store: e,
          element: P,
          eventId: r,
          actionListId: o,
          actionItem: D,
          destination: B,
          continuous: !0,
          parameterId: O,
          actionGroups: R,
          smoothing: s,
          restingValue: u,
          pluginInstance: U,
        });
      });
  }
  function GD(e = [], t, n) {
    let r = [...e],
      i;
    return (
      r.some((o, a) => (o.keyframe === t ? ((i = a), !0) : !1)),
      i == null && ((i = r.length), r.push({ keyframe: t, actionItems: [] })),
      r[i].actionItems.push(n),
      r
    );
  }
  function XD(e) {
    let { ixData: t } = e.getState(),
      { eventTypeMap: n } = t;
    rE(e),
      (0, Gt.default)(n, (i, o) => {
        let a = kh[o];
        if (!a) {
          console.warn(`IX2 event type not configured: ${o}`);
          return;
        }
        WD({ logic: a, store: e, events: i });
      });
    let { ixSession: r } = e.getState();
    r.eventListeners.length && UD(e);
  }
  function UD(e) {
    let t = () => {
      rE(e);
    };
    VD.forEach((n) => {
      window.addEventListener(n, t), e.dispatch(gr(window, [n, t]));
    }),
      t();
  }
  function rE(e) {
    let { ixSession: t, ixData: n } = e.getState(),
      r = window.innerWidth;
    if (r !== t.viewportWidth) {
      let { mediaQueries: i } = n;
      e.dispatch(wo({ width: r, mediaQueries: i }));
    }
  }
  function WD({ logic: e, store: t, events: n }) {
    zD(n);
    let { types: r, handler: i } = e,
      { ixData: o } = t.getState(),
      { actionLists: a } = o,
      s = BD(n, kD);
    if (!(0, Yh.default)(s)) return;
    (0, Gt.default)(s, (p, d) => {
      let E = n[d],
        { action: I, id: v, mediaQueries: b = o.mediaQueryKeys } = E,
        { actionListId: m } = I.config;
      TD(b, o.mediaQueryKeys) || t.dispatch(Co()),
        I.actionTypeId === pe.GENERAL_CONTINUOUS_ACTION &&
          (Array.isArray(E.config) ? E.config : [E.config]).forEach((A) => {
            let { continuousParameterGroupId: P } = A,
              L = (0, ze.default)(a, `${m}.continuousParameterGroups`, []),
              R = (0, jh.default)(L, ({ id: G }) => G === P),
              D = (A.smoothing || 0) / 100,
              F = (A.restingState || 0) / 100;
            R &&
              p.forEach((G, U) => {
                let B = v + Wo + U;
                qD({
                  store: t,
                  eventStateKey: B,
                  eventTarget: G,
                  eventId: v,
                  eventConfig: A,
                  actionListId: m,
                  parameterGroup: R,
                  smoothing: D,
                  restingValue: F,
                });
              });
          }),
        (I.actionTypeId === pe.GENERAL_START_ACTION || ko(I.actionTypeId)) &&
          iE({ store: t, actionListId: m, eventId: v });
    });
    let u = (p) => {
        let { ixSession: d } = t.getState();
        HD(s, (E, I, v) => {
          let b = n[I],
            m = d.eventState[v],
            { action: O, mediaQueries: A = o.mediaQueryKeys } = b;
          if (!wr(A, d.mediaQueryKey)) return;
          let P = (L = {}) => {
            let R = i(
              {
                store: t,
                element: E,
                event: b,
                eventConfig: L,
                nativeEvent: p,
                eventStateKey: v,
              },
              m
            );
            AD(R, m) || t.dispatch(So(v, R));
          };
          O.actionTypeId === pe.GENERAL_CONTINUOUS_ACTION
            ? (Array.isArray(b.config) ? b.config : [b.config]).forEach(P)
            : P();
        });
      },
      l = (0, Jh.default)(u, OD),
      g = ({ target: p = document, types: d, throttle: E }) => {
        d.split(" ")
          .filter(Boolean)
          .forEach((I) => {
            let v = E ? l : u;
            p.addEventListener(I, v), t.dispatch(gr(p, [I, v]));
          });
      };
    Array.isArray(r) ? r.forEach(g) : typeof r == "string" && g(e);
  }
  function zD(e) {
    if (!SD) return;
    let t = {},
      n = "";
    for (let r in e) {
      let { eventTypeId: i, target: o } = e[r],
        a = Lo(o);
      t[a] ||
        ((i === Ce.MOUSE_CLICK || i === Ce.MOUSE_SECOND_CLICK) &&
          ((t[a] = !0),
          (n += a + "{cursor: pointer;touch-action: manipulation;}")));
    }
    if (n) {
      let r = document.createElement("style");
      (r.textContent = n), document.body.appendChild(r);
    }
  }
  function iE({ store: e, actionListId: t, eventId: n }) {
    let { ixData: r, ixSession: i } = e.getState(),
      { actionLists: o, events: a } = r,
      s = a[n],
      u = o[t];
    if (u && u.useFirstGroupAsInitialState) {
      let l = (0, ze.default)(u, "actionItemGroups[0].actionItems", []),
        g = (0, ze.default)(s, "mediaQueries", r.mediaQueryKeys);
      if (!wr(g, i.mediaQueryKey)) return;
      l.forEach((p) => {
        let { config: d, actionTypeId: E } = p,
          I =
            d?.target?.useEventTarget === !0 && d?.target?.objectId == null
              ? { target: s.target, targets: s.targets }
              : d,
          v = Rr({ config: I, event: s, elementApi: he }),
          b = Cr(E);
        v.forEach((m) => {
          let O = b ? Ko(E)(m, p) : null;
          jo({
            destination: zo({ element: m, actionItem: p, elementApi: he }, O),
            immediate: !0,
            store: e,
            element: m,
            eventId: n,
            actionItem: p,
            actionListId: t,
            pluginInstance: O,
          });
        });
      });
    }
  }
  function oE({ store: e }) {
    let { ixInstances: t } = e.getState();
    (0, Gt.default)(t, (n) => {
      if (!n.continuous) {
        let { actionListId: r, verbose: i } = n;
        Yo(n, e), i && e.dispatch(Ft({ actionListId: r, isPlaying: !1 }));
      }
    });
  }
  function qt({
    store: e,
    eventId: t,
    eventTarget: n,
    eventStateKey: r,
    actionListId: i,
  }) {
    let { ixInstances: o, ixSession: a } = e.getState(),
      s = a.hasBoundaryNodes && n ? pn(n, xr) : null;
    (0, Gt.default)(o, (u) => {
      let l = (0, ze.default)(u, "actionItem.config.target.boundaryMode"),
        g = r ? u.eventStateKey === r : !0;
      if (u.actionListId === i && u.eventId === t && g) {
        if (s && l && !No(s, u.element)) return;
        Yo(u, e),
          u.verbose && e.dispatch(Ft({ actionListId: i, isPlaying: !1 }));
      }
    });
  }
  function yn({
    store: e,
    eventId: t,
    eventTarget: n,
    eventStateKey: r,
    actionListId: i,
    groupIndex: o = 0,
    immediate: a,
    verbose: s,
  }) {
    let { ixData: u, ixSession: l } = e.getState(),
      { events: g } = u,
      p = g[t] || {},
      { mediaQueries: d = u.mediaQueryKeys } = p,
      E = (0, ze.default)(u, `actionLists.${i}`, {}),
      { actionItemGroups: I, useFirstGroupAsInitialState: v } = E;
    if (!I || !I.length) return !1;
    o >= I.length && (0, ze.default)(p, "config.loop") && (o = 0),
      o === 0 && v && o++;
    let m =
        (o === 0 || (o === 1 && v)) && ko(p.action?.actionTypeId)
          ? p.config.delay
          : void 0,
      O = (0, ze.default)(I, [o, "actionItems"], []);
    if (!O.length || !wr(d, l.mediaQueryKey)) return !1;
    let A = l.hasBoundaryNodes && n ? pn(n, xr) : null,
      P = pD(O),
      L = !1;
    return (
      O.forEach((R, D) => {
        let { config: F, actionTypeId: G } = R,
          U = Cr(G),
          { target: B } = F;
        if (!B) return;
        let C = B.boundaryMode ? A : null;
        Rr({
          config: F,
          event: p,
          eventTarget: n,
          elementRoot: C,
          elementApi: he,
        }).forEach((w, q) => {
          let M = U ? Ko(G)(w, R) : null,
            W = U ? bD(G)(w, R) : null;
          L = !0;
          let k = P === D && q === 0,
            J = gD({ element: w, actionItem: R }),
            Te = zo({ element: w, actionItem: R, elementApi: he }, M);
          jo({
            store: e,
            element: w,
            actionItem: R,
            eventId: t,
            eventTarget: n,
            eventStateKey: r,
            actionListId: i,
            groupIndex: o,
            isCarrier: k,
            computedStyle: J,
            destination: Te,
            immediate: a,
            verbose: s,
            pluginInstance: M,
            pluginDuration: W,
            instanceDelay: m,
          });
        });
      }),
      L
    );
  }
  function jo(e) {
    let { store: t, computedStyle: n, ...r } = e,
      {
        element: i,
        actionItem: o,
        immediate: a,
        pluginInstance: s,
        continuous: u,
        restingValue: l,
        eventId: g,
      } = r,
      p = !u,
      d = fD(),
      { ixElements: E, ixSession: I, ixData: v } = t.getState(),
      b = lD(E, i),
      { refState: m } = E[b] || {},
      O = Mo(i),
      A = I.reducedMotion && si[o.actionTypeId],
      P;
    if (A && u)
      switch (v.events[g]?.eventTypeId) {
        case Ce.MOUSE_MOVE:
        case Ce.MOUSE_MOVE_IN_VIEWPORT:
          P = l;
          break;
        default:
          P = 0.5;
          break;
      }
    let L = hD(i, m, n, o, he, s);
    if (
      (t.dispatch(
        Oo({
          instanceId: d,
          elementId: b,
          origin: L,
          refType: O,
          skipMotion: A,
          skipToValue: P,
          ...r,
        })
      ),
      aE(document.body, "ix2-animation-started", d),
      a)
    ) {
      KD(t, d);
      return;
    }
    ct({ store: t, select: ({ ixInstances: R }) => R[d], onChange: sE }),
      p && t.dispatch(Er(d, I.tick));
  }
  function Yo(e, t) {
    aE(document.body, "ix2-animation-stopping", {
      instanceId: e.id,
      state: t.getState(),
    });
    let { elementId: n, actionItem: r } = e,
      { ixElements: i } = t.getState(),
      { ref: o, refType: a } = i[n] || {};
    a === eE && vD(o, r, he), t.dispatch(xo(e.id));
  }
  function aE(e, t, n) {
    let r = document.createEvent("CustomEvent");
    r.initCustomEvent(t, !0, !0, n), e.dispatchEvent(r);
  }
  function KD(e, t) {
    let { ixParameters: n } = e.getState();
    e.dispatch(Er(t, 0)), e.dispatch(hr(performance.now(), n));
    let { ixInstances: r } = e.getState();
    sE(r[t], e);
  }
  function sE(e, t) {
    let {
        active: n,
        continuous: r,
        complete: i,
        elementId: o,
        actionItem: a,
        actionTypeId: s,
        renderType: u,
        current: l,
        groupIndex: g,
        eventId: p,
        eventTarget: d,
        eventStateKey: E,
        actionListId: I,
        isCarrier: v,
        styleProp: b,
        verbose: m,
        pluginInstance: O,
      } = e,
      { ixData: A, ixSession: P } = t.getState(),
      { events: L } = A,
      R = L && L[p] ? L[p] : {},
      { mediaQueries: D = A.mediaQueryKeys } = R;
    if (wr(D, P.mediaQueryKey) && (r || n || i)) {
      if (l || (u === cD && i)) {
        t.dispatch(Ro(o, s, l, a));
        let { ixElements: F } = t.getState(),
          { ref: G, refType: U, refState: B } = F[o] || {},
          C = B && B[s];
        (U === eE || Cr(s)) && dD(G, B, C, p, a, b, he, u, O);
      }
      if (i) {
        if (v) {
          let F = yn({
            store: t,
            eventId: p,
            eventTarget: d,
            eventStateKey: E,
            actionListId: I,
            groupIndex: g + 1,
            verbose: m,
          });
          m && !F && t.dispatch(Ft({ actionListId: I, isPlaying: !1 }));
        }
        Yo(e, t);
      }
    }
  }
  var jh,
    ze,
    Yh,
    $h,
    Qh,
    Zh,
    Gt,
    Jh,
    Or,
    uD,
    ko,
    Wo,
    xr,
    eE,
    cD,
    zh,
    Rr,
    lD,
    zo,
    ct,
    fD,
    dD,
    tE,
    pD,
    gD,
    hD,
    ED,
    yD,
    mD,
    wr,
    vD,
    _D,
    ID,
    TD,
    AD,
    Cr,
    Ko,
    bD,
    Kh,
    SD,
    OD,
    VD,
    BD,
    HD,
    kD,
    Ho = ne(() => {
      "use strict";
      (jh = $(Fi())),
        (ze = $(Yn())),
        (Yh = $(Ip())),
        ($h = $(Kp())),
        (Qh = $(Yp())),
        (Zh = $(Qp())),
        (Gt = $(rg())),
        (Jh = $(lg()));
      ve();
      Or = $(ut());
      yr();
      Eg();
      Wh();
      (uD = Object.keys(xn)),
        (ko = (e) => uD.includes(e)),
        ({
          COLON_DELIMITER: Wo,
          BOUNDARY_SELECTOR: xr,
          HTML_ELEMENT: eE,
          RENDER_GENERAL: cD,
          W_MOD_IX: zh,
        } = ce),
        ({
          getAffectedElements: Rr,
          getElementId: lD,
          getDestinationValues: zo,
          observeStore: ct,
          getInstanceId: fD,
          renderHTMLElement: dD,
          clearAllStyles: tE,
          getMaxDurationItemIndex: pD,
          getComputedStyle: gD,
          getInstanceOrigin: hD,
          reduceListToGroup: ED,
          shouldNamespaceEventParameter: yD,
          getNamespacedParameterId: mD,
          shouldAllowMediaQuery: wr,
          cleanupHTMLElement: vD,
          clearObjectCache: _D,
          stringifyTarget: ID,
          mediaQueriesEqual: TD,
          shallowEqual: AD,
        } = Or.IX2VanillaUtils),
        ({
          isPluginType: Cr,
          createPluginInstance: Ko,
          getPluginDuration: bD,
        } = Or.IX2VanillaPlugins),
        (Kh = navigator.userAgent),
        (SD = Kh.match(/iPad/i) || Kh.match(/iPhone/)),
        (OD = 12);
      VD = ["resize", "orientationchange"];
      (BD = (e, t) => (0, $h.default)((0, Zh.default)(e, t), Qh.default)),
        (HD = (e, t) => {
          (0, Gt.default)(e, (n, r) => {
            n.forEach((i, o) => {
              let a = r + Wo + o;
              t(i, r, a);
            });
          });
        }),
        (kD = (e) => {
          let t = { target: e.target, targets: e.targets };
          return Rr({ config: t, elementApi: he });
        });
    });
  var fE = f((Qo) => {
    "use strict";
    Object.defineProperty(Qo, "__esModule", { value: !0 });
    function jD(e, t) {
      for (var n in t)
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }
    jD(Qo, {
      actions: function () {
        return QD;
      },
      destroy: function () {
        return lE;
      },
      init: function () {
        return tF;
      },
      setEnv: function () {
        return eF;
      },
      store: function () {
        return Nr;
      },
    });
    var YD = ii(),
      $D = ZD((np(), Me(tp))),
      $o = (Ho(), Me(uE)),
      QD = JD((yr(), Me(dg)));
    function ZD(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function cE(e) {
      if (typeof WeakMap != "function") return null;
      var t = new WeakMap(),
        n = new WeakMap();
      return (cE = function (r) {
        return r ? n : t;
      })(e);
    }
    function JD(e, t) {
      if (!t && e && e.__esModule) return e;
      if (e === null || (typeof e != "object" && typeof e != "function"))
        return { default: e };
      var n = cE(t);
      if (n && n.has(e)) return n.get(e);
      var r = { __proto__: null },
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var o in e)
        if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
          var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
          a && (a.get || a.set)
            ? Object.defineProperty(r, o, a)
            : (r[o] = e[o]);
        }
      return (r.default = e), n && n.set(e, r), r;
    }
    var Nr = (0, YD.createStore)($D.default);
    function eF(e) {
      e() && (0, $o.observeRequests)(Nr);
    }
    function tF(e) {
      lE(), (0, $o.startEngine)({ store: Nr, rawData: e, allowEvents: !0 });
    }
    function lE() {
      (0, $o.stopEngine)(Nr);
    }
  });
  var hE = f((JG, gE) => {
    "use strict";
    var dE = $e(),
      pE = fE();
    pE.setEnv(dE.env);
    dE.define(
      "ix2",
      (gE.exports = function () {
        return pE;
      })
    );
  });
  var yE = f((eX, EE) => {
    "use strict";
    var Xt = $e();
    Xt.define(
      "links",
      (EE.exports = function (e, t) {
        var n = {},
          r = e(window),
          i,
          o = Xt.env(),
          a = window.location,
          s = document.createElement("a"),
          u = "w--current",
          l = /index\.(html|php)$/,
          g = /\/$/,
          p,
          d;
        n.ready = n.design = n.preview = E;
        function E() {
          (i = o && Xt.env("design")),
            (d = Xt.env("slug") || a.pathname || ""),
            Xt.scroll.off(v),
            (p = []);
          for (var m = document.links, O = 0; O < m.length; ++O) I(m[O]);
          p.length && (Xt.scroll.on(v), v());
        }
        function I(m) {
          if (!m.getAttribute("hreflang")) {
            var O =
              (i && m.getAttribute("href-disabled")) || m.getAttribute("href");
            if (((s.href = O), !(O.indexOf(":") >= 0))) {
              var A = e(m);
              if (
                s.hash.length > 1 &&
                s.host + s.pathname === a.host + a.pathname
              ) {
                if (!/^#[a-zA-Z0-9\-\_]+$/.test(s.hash)) return;
                var P = e(s.hash);
                P.length && p.push({ link: A, sec: P, active: !1 });
                return;
              }
              if (!(O === "#" || O === "")) {
                var L =
                  s.href === a.href || O === d || (l.test(O) && g.test(d));
                b(A, u, L);
              }
            }
          }
        }
        function v() {
          var m = r.scrollTop(),
            O = r.height();
          t.each(p, function (A) {
            if (!A.link.attr("hreflang")) {
              var P = A.link,
                L = A.sec,
                R = L.offset().top,
                D = L.outerHeight(),
                F = O * 0.5,
                G = L.is(":visible") && R + D - F >= m && R + F <= m + O;
              A.active !== G && ((A.active = G), b(P, u, G));
            }
          });
        }
        function b(m, O, A) {
          var P = m.hasClass(O);
          (A && P) || (!A && !P) || (A ? m.addClass(O) : m.removeClass(O));
        }
        return n;
      })
    );
  });
  var vE = f((tX, mE) => {
    "use strict";
    var Mr = $e();
    Mr.define(
      "scroll",
      (mE.exports = function (e) {
        var t = {
            WF_CLICK_EMPTY: "click.wf-empty-link",
            WF_CLICK_SCROLL: "click.wf-scroll",
          },
          n = window.location,
          r = I() ? null : window.history,
          i = e(window),
          o = e(document),
          a = e(document.body),
          s =
            window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            function (C) {
              window.setTimeout(C, 15);
            },
          u = Mr.env("editor") ? ".w-editor-body" : "body",
          l =
            "header, " +
            u +
            " > .header, " +
            u +
            " > .w-nav:not([data-no-scroll])",
          g = 'a[href="#"]',
          p = 'a[href*="#"]:not(.w-tab-link):not(' + g + ")",
          d = '.wf-force-outline-none[tabindex="-1"]:focus{outline:none;}',
          E = document.createElement("style");
        E.appendChild(document.createTextNode(d));
        function I() {
          try {
            return !!window.frameElement;
          } catch {
            return !0;
          }
        }
        var v = /^#[a-zA-Z0-9][\w:.-]*$/;
        function b(C) {
          return v.test(C.hash) && C.host + C.pathname === n.host + n.pathname;
        }
        let m =
          typeof window.matchMedia == "function" &&
          window.matchMedia("(prefers-reduced-motion: reduce)");
        function O() {
          return (
            document.body.getAttribute("data-wf-scroll-motion") === "none" ||
            m.matches
          );
        }
        function A(C, _) {
          var w;
          switch (_) {
            case "add":
              (w = C.attr("tabindex")),
                w
                  ? C.attr("data-wf-tabindex-swap", w)
                  : C.attr("tabindex", "-1");
              break;
            case "remove":
              (w = C.attr("data-wf-tabindex-swap")),
                w
                  ? (C.attr("tabindex", w),
                    C.removeAttr("data-wf-tabindex-swap"))
                  : C.removeAttr("tabindex");
              break;
          }
          C.toggleClass("wf-force-outline-none", _ === "add");
        }
        function P(C) {
          var _ = C.currentTarget;
          if (
            !(
              Mr.env("design") ||
              (window.$.mobile && /(?:^|\s)ui-link(?:$|\s)/.test(_.className))
            )
          ) {
            var w = b(_) ? _.hash : "";
            if (w !== "") {
              var q = e(w);
              q.length &&
                (C && (C.preventDefault(), C.stopPropagation()),
                L(w, C),
                window.setTimeout(
                  function () {
                    R(q, function () {
                      A(q, "add"),
                        q.get(0).focus({ preventScroll: !0 }),
                        A(q, "remove");
                    });
                  },
                  C ? 0 : 300
                ));
            }
          }
        }
        function L(C) {
          if (
            n.hash !== C &&
            r &&
            r.pushState &&
            !(Mr.env.chrome && n.protocol === "file:")
          ) {
            var _ = r.state && r.state.hash;
            _ !== C && r.pushState({ hash: C }, "", C);
          }
        }
        function R(C, _) {
          var w = i.scrollTop(),
            q = D(C);
          if (w !== q) {
            var M = F(C, w, q),
              W = Date.now(),
              k = function () {
                var J = Date.now() - W;
                window.scroll(0, G(w, q, J, M)),
                  J <= M ? s(k) : typeof _ == "function" && _();
              };
            s(k);
          }
        }
        function D(C) {
          var _ = e(l),
            w = _.css("position") === "fixed" ? _.outerHeight() : 0,
            q = C.offset().top - w;
          if (C.data("scroll") === "mid") {
            var M = i.height() - w,
              W = C.outerHeight();
            W < M && (q -= Math.round((M - W) / 2));
          }
          return q;
        }
        function F(C, _, w) {
          if (O()) return 0;
          var q = 1;
          return (
            a.add(C).each(function (M, W) {
              var k = parseFloat(W.getAttribute("data-scroll-time"));
              !isNaN(k) && k >= 0 && (q = k);
            }),
            (472.143 * Math.log(Math.abs(_ - w) + 125) - 2e3) * q
          );
        }
        function G(C, _, w, q) {
          return w > q ? _ : C + (_ - C) * U(w / q);
        }
        function U(C) {
          return C < 0.5
            ? 4 * C * C * C
            : (C - 1) * (2 * C - 2) * (2 * C - 2) + 1;
        }
        function B() {
          var { WF_CLICK_EMPTY: C, WF_CLICK_SCROLL: _ } = t;
          o.on(_, p, P),
            o.on(C, g, function (w) {
              w.preventDefault();
            }),
            document.head.insertBefore(E, document.head.firstChild);
        }
        return { ready: B };
      })
    );
  });
  var IE = f((nX, _E) => {
    "use strict";
    var nF = $e();
    nF.define(
      "touch",
      (_E.exports = function (e) {
        var t = {},
          n = window.getSelection;
        (e.event.special.tap = { bindType: "click", delegateType: "click" }),
          (t.init = function (o) {
            return (
              (o = typeof o == "string" ? e(o).get(0) : o), o ? new r(o) : null
            );
          });
        function r(o) {
          var a = !1,
            s = !1,
            u = Math.min(Math.round(window.innerWidth * 0.04), 40),
            l,
            g;
          o.addEventListener("touchstart", p, !1),
            o.addEventListener("touchmove", d, !1),
            o.addEventListener("touchend", E, !1),
            o.addEventListener("touchcancel", I, !1),
            o.addEventListener("mousedown", p, !1),
            o.addEventListener("mousemove", d, !1),
            o.addEventListener("mouseup", E, !1),
            o.addEventListener("mouseout", I, !1);
          function p(b) {
            var m = b.touches;
            (m && m.length > 1) ||
              ((a = !0),
              m ? ((s = !0), (l = m[0].clientX)) : (l = b.clientX),
              (g = l));
          }
          function d(b) {
            if (a) {
              if (s && b.type === "mousemove") {
                b.preventDefault(), b.stopPropagation();
                return;
              }
              var m = b.touches,
                O = m ? m[0].clientX : b.clientX,
                A = O - g;
              (g = O),
                Math.abs(A) > u &&
                  n &&
                  String(n()) === "" &&
                  (i("swipe", b, { direction: A > 0 ? "right" : "left" }), I());
            }
          }
          function E(b) {
            if (a && ((a = !1), s && b.type === "mouseup")) {
              b.preventDefault(), b.stopPropagation(), (s = !1);
              return;
            }
          }
          function I() {
            a = !1;
          }
          function v() {
            o.removeEventListener("touchstart", p, !1),
              o.removeEventListener("touchmove", d, !1),
              o.removeEventListener("touchend", E, !1),
              o.removeEventListener("touchcancel", I, !1),
              o.removeEventListener("mousedown", p, !1),
              o.removeEventListener("mousemove", d, !1),
              o.removeEventListener("mouseup", E, !1),
              o.removeEventListener("mouseout", I, !1),
              (o = null);
          }
          this.destroy = v;
        }
        function i(o, a, s) {
          var u = e.Event(o, { originalEvent: a });
          e(a.target).trigger(u, s);
        }
        return (t.instance = t.init(document)), t;
      })
    );
  });
  ha();
  ya();
  _a();
  xa();
  hE();
  yE();
  vE();
  IE();
})();
/*!
 * tram.js v0.8.2-global
 * Cross-browser CSS3 transitions in JavaScript
 * https://github.com/bkwld/tram
 * MIT License
 */
/*!
 * Webflow._ (aka) Underscore.js 1.6.0 (custom build)
 *
 * http://underscorejs.org
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Underscore may be freely distributed under the MIT license.
 * @license MIT
 */
/*! Bundled license information:

timm/lib/timm.js:
  (*!
   * Timm
   *
   * Immutability helpers with fast reads and acceptable writes.
   *
   * @copyright Guillermo Grau Panea 2016
   * @license MIT
   *)
*/
/**
 * ----------------------------------------------------------------------
 * Webflow: Interactions 2.0: Init
 */
Webflow.require("ix2").init({
  events: {
    e: {
      id: "e",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|8167da7e-d3fa-a936-6949-4a15c8f035a5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|8167da7e-d3fa-a936-6949-4a15c8f035a5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-p",
          smoothing: 65,
          startsEntering: false,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1688033242338,
    },
    "e-2": {
      id: "e-2",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-11" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b909405",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b909405",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 600,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727805196627,
    },
    "e-3": {
      id: "e-3",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-3", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-3-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727817129312,
    },
    "e-4": {
      id: "e-4",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-2", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e3",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e3",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-2-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727816801527,
    },
    "e-5": {
      id: "e-5",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-9" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e7",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e7",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727802388546,
    },
    "e-8": {
      id: "e-8",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-6" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093ef",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093ef",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 500,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727805160272,
    },
    "e-10": {
      id: "e-10",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-13" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e9",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e9",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1688039154055,
    },
    "e-12": {
      id: "e-12",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-7" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093ec",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093ec",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 400,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1688039168637,
    },
    "e-14": {
      id: "e-14",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-15" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|00930c1c-8820-2f6f-0897-f828fba07dd9",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|00930c1c-8820-2f6f-0897-f828fba07dd9",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727812555214,
    },
    "e-16": {
      id: "e-16",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-17" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|00930c1c-8820-2f6f-0897-f828fba07ddc",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|00930c1c-8820-2f6f-0897-f828fba07ddc",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 400,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727812555214,
    },
    "e-18": {
      id: "e-18",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-19" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|00930c1c-8820-2f6f-0897-f828fba07ddf",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|00930c1c-8820-2f6f-0897-f828fba07ddf",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 500,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727812555214,
    },
    "e-20": {
      id: "e-20",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-21" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|00930c1c-8820-2f6f-0897-f828fba07df0",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|00930c1c-8820-2f6f-0897-f828fba07df0",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 600,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727812555214,
    },
    "e-22": {
      id: "e-22",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-23" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|b4dd3d74-fb09-cf55-344d-2fa201b72a18",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|b4dd3d74-fb09-cf55-344d-2fa201b72a18",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727812556836,
    },
    "e-24": {
      id: "e-24",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-25" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|b4dd3d74-fb09-cf55-344d-2fa201b72a1b",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|b4dd3d74-fb09-cf55-344d-2fa201b72a1b",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 400,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727812556836,
    },
    "e-26": {
      id: "e-26",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-27" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|b4dd3d74-fb09-cf55-344d-2fa201b72a1e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|b4dd3d74-fb09-cf55-344d-2fa201b72a1e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 500,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727812556836,
    },
    "e-28": {
      id: "e-28",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-29" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|b4dd3d74-fb09-cf55-344d-2fa201b72a3e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|b4dd3d74-fb09-cf55-344d-2fa201b72a3e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 600,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727812556836,
    },
    "e-30": {
      id: "e-30",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-31" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|b2800256-b247-0da0-198a-f06b5f5ec7d2",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|b2800256-b247-0da0-198a-f06b5f5ec7d2",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727815399030,
    },
    "e-32": {
      id: "e-32",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-33" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|b2800256-b247-0da0-198a-f06b5f5ec7d5",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|b2800256-b247-0da0-198a-f06b5f5ec7d5",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 400,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727815399030,
    },
    "e-34": {
      id: "e-34",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-35" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|b2800256-b247-0da0-198a-f06b5f5ec7d8",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|b2800256-b247-0da0-198a-f06b5f5ec7d8",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 500,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727815399030,
    },
    "e-36": {
      id: "e-36",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-37" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|b2800256-b247-0da0-198a-f06b5f5ec7e4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|b2800256-b247-0da0-198a-f06b5f5ec7e4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 600,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727815399030,
    },
    "e-38": {
      id: "e-38",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-4", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|e22934c8-5e86-a1d1-38e4-344dd0a30624",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|e22934c8-5e86-a1d1-38e4-344dd0a30624",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-4-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727819108193,
    },
    "e-39": {
      id: "e-39",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-5", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|d1968b69-2666-0340-a097-31927ffc8394",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|d1968b69-2666-0340-a097-31927ffc8394",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-5-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727829579143,
    },
    "e-40": {
      id: "e-40",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-6", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|35a6e0e5-ecc2-566b-1c0e-4f6ca5bd4335",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|35a6e0e5-ecc2-566b-1c0e-4f6ca5bd4335",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-6-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727900922979,
    },
    "e-41": {
      id: "e-41",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-8", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|57e9f670-656d-c467-4a04-6c7d1d3ba8e7",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|57e9f670-656d-c467-4a04-6c7d1d3ba8e7",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-8-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727909438774,
    },
    "e-42": {
      id: "e-42",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-10", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|fdf5c975-f53a-b760-d063-6ab975ec391a",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|fdf5c975-f53a-b760-d063-6ab975ec391a",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-10-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727910268195,
    },
    "e-43": {
      id: "e-43",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-11", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|1069cf5b-55e6-18ed-0f24-c9f1433f26fe",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|1069cf5b-55e6-18ed-0f24-c9f1433f26fe",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-11-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727965096609,
    },
    "e-44": {
      id: "e-44",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-12", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|49e95129-e31c-093c-f52f-8963a2e1f0ea",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|49e95129-e31c-093c-f52f-8963a2e1f0ea",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-12-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727965471691,
    },
    "e-45": {
      id: "e-45",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-13", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|068e37ec-672a-51bf-68c0-846a96492fef",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|068e37ec-672a-51bf-68c0-846a96492fef",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-13-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727965864537,
    },
    "e-46": {
      id: "e-46",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-47" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|8d054776-89f1-6b89-91dc-c4e7060f9632",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|8d054776-89f1-6b89-91dc-c4e7060f9632",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727966341030,
    },
    "e-48": {
      id: "e-48",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLLING_IN_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-14", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|008162a2-086c-1548-20eb-c14309c90e50",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|008162a2-086c-1548-20eb-c14309c90e50",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-14-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1727967561021,
    },
    "e-49": {
      id: "e-49",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-50" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|f6ede8ab-768f-ce42-151f-606ef4dec226",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|f6ede8ab-768f-ce42-151f-606ef4dec226",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727968258624,
    },
    "e-51": {
      id: "e-51",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "SLIDE_EFFECT",
        instant: false,
        config: { actionListId: "slideInBottom", autoStopEventId: "e-52" },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|bde89eaa-c842-cd3e-af26-cb71c9ef99fd",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|bde89eaa-c842-cd3e-af26-cb71c9ef99fd",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: "BOTTOM",
        effectIn: true,
      },
      createdOn: 1727968887022,
    },
    "e-55": {
      id: "e-55",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OVER",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-15",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-56",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|3298b271-e780-507d-2b8a-1e0c1bb133a4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|3298b271-e780-507d-2b8a-1e0c1bb133a4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1727970997073,
    },
    "e-56": {
      id: "e-56",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OUT",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-16",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-55",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|3298b271-e780-507d-2b8a-1e0c1bb133a4",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|3298b271-e780-507d-2b8a-1e0c1bb133a4",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1727970997074,
    },
    "e-57": {
      id: "e-57",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OVER",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-15",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-58",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|3447d8e7-e078-eaef-851b-c7f99f4a621f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|3447d8e7-e078-eaef-851b-c7f99f4a621f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1727971032386,
    },
    "e-58": {
      id: "e-58",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OUT",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-16",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-57",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|3447d8e7-e078-eaef-851b-c7f99f4a621f",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|3447d8e7-e078-eaef-851b-c7f99f4a621f",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1727971032387,
    },
    "e-59": {
      id: "e-59",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OVER",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-15",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-60",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|9fb93c59-43e4-83ce-bee5-6648bb5374aa",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|9fb93c59-43e4-83ce-bee5-6648bb5374aa",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1727972264604,
    },
    "e-60": {
      id: "e-60",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OUT",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-16",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-59",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "66fb1132ee1ccbe420bbfde7|9fb93c59-43e4-83ce-bee5-6648bb5374aa",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "66fb1132ee1ccbe420bbfde7|9fb93c59-43e4-83ce-bee5-6648bb5374aa",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1727972264605,
    },
  },
  actionLists: {
    a: {
      id: "a",
      title: "Typo Zoom Scroll Animation",
      continuousParameterGroups: [
        {
          id: "a-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 2,
              actionItems: [
                {
                  id: "a-n",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "inCubic",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".typo-zoom-text-wrapper",
                      selectorGuids: ["57552a25-faeb-d505-91eb-51b792c14cfa"],
                    },
                    xValue: 0,
                    yValue: 0,
                    xUnit: "vw",
                    yUnit: "vw",
                    zUnit: "PX",
                  },
                },
                {
                  id: "a-n-2",
                  actionTypeId: "STYLE_SIZE",
                  config: {
                    delay: 0,
                    easing: "inCubic",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".typo-zoom-text-wrapper",
                      selectorGuids: ["57552a25-faeb-d505-91eb-51b792c14cfa"],
                    },
                    widthValue: 80,
                    widthUnit: "vw",
                    heightUnit: "PX",
                    locked: false,
                  },
                },
              ],
            },
            {
              keyframe: 70,
              actionItems: [
                {
                  id: "a-n-3",
                  actionTypeId: "STYLE_SIZE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".typo-zoom-text-wrapper",
                      selectorGuids: ["57552a25-faeb-d505-91eb-51b792c14cfa"],
                    },
                    widthValue: 20000,
                    widthUnit: "vw",
                    heightUnit: "PX",
                    locked: false,
                  },
                },
                {
                  id: "a-n-4",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: "CHILDREN",
                      selector: ".typo-zoom-text-wrapper",
                      selectorGuids: ["57552a25-faeb-d505-91eb-51b792c14cfa"],
                    },
                    xValue: -100,
                    yValue: 100,
                    xUnit: "vw",
                    yUnit: "vw",
                    zUnit: "PX",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1688033245539,
    },
    "a-3": {
      id: "a-3",
      title: "events-animation",
      continuousParameterGroups: [
        {
          id: "a-3-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-3-n",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e4",
                    },
                    yValue: 95,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
            {
              keyframe: 100,
              actionItems: [
                {
                  id: "a-3-n-2",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e4",
                    },
                    yValue: -50,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727817135815,
    },
    "a-2": {
      id: "a-2",
      title: "Pie-Scrolling",
      continuousParameterGroups: [
        {
          id: "a-2-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-2-n",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e3",
                    },
                    yValue: 0,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
            {
              keyframe: 100,
              actionItems: [
                {
                  id: "a-2-n-2",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|61ddaee4-91c5-c842-d1ba-5b374b9093e3",
                    },
                    yValue: -156,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727816857572,
    },
    "a-4": {
      id: "a-4",
      title: "collection-scroll",
      continuousParameterGroups: [
        {
          id: "a-4-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-4-n",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|e22934c8-5e86-a1d1-38e4-344dd0a30624",
                    },
                    yValue: 0,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
            {
              keyframe: 100,
              actionItems: [
                {
                  id: "a-4-n-2",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|e22934c8-5e86-a1d1-38e4-344dd0a30624",
                    },
                    yValue: -271,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727819113835,
    },
    "a-5": {
      id: "a-5",
      title: "menu-animation",
      continuousParameterGroups: [
        {
          id: "a-5-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-5-n",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|d1968b69-2666-0340-a097-31927ffc8394",
                    },
                    xValue: 0,
                    yValue: 65,
                    xUnit: "px",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
                {
                  id: "a-5-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|d1968b69-2666-0340-a097-31927ffc8394",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 30,
              actionItems: [
                {
                  id: "a-5-n-3",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|d1968b69-2666-0340-a097-31927ffc8394",
                    },
                    xValue: 0,
                    yValue: 65,
                    xUnit: "px",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
                {
                  id: "a-5-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|d1968b69-2666-0340-a097-31927ffc8394",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 60,
              actionItems: [
                {
                  id: "a-5-n-2",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|d1968b69-2666-0340-a097-31927ffc8394",
                    },
                    xValue: 0,
                    yValue: 0,
                    xUnit: "px",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
                {
                  id: "a-5-n-6",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|d1968b69-2666-0340-a097-31927ffc8394",
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727829584194,
    },
    "a-6": {
      id: "a-6",
      title: "filters-scrolling",
      continuousParameterGroups: [
        {
          id: "a-6-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-6-n",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|35a6e0e5-ecc2-566b-1c0e-4f6ca5bd4335",
                    },
                    yValue: 0,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
            {
              keyframe: 100,
              actionItems: [
                {
                  id: "a-6-n-2",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|35a6e0e5-ecc2-566b-1c0e-4f6ca5bd4335",
                    },
                    yValue: -500,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727900929402,
    },
    "a-8": {
      id: "a-8",
      title: "Tap Animation",
      continuousParameterGroups: [
        {
          id: "a-8-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-8-n",
                  actionTypeId: "TRANSFORM_SCALE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|57e9f670-656d-c467-4a04-6c7d1d3ba8e7",
                    },
                    xValue: 1,
                    yValue: 1,
                    locked: true,
                  },
                },
              ],
            },
            {
              keyframe: 40,
              actionItems: [
                {
                  id: "a-8-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|57e9f670-656d-c467-4a04-6c7d1d3ba8e7",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 44,
              actionItems: [
                {
                  id: "a-8-n-5",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|57e9f670-656d-c467-4a04-6c7d1d3ba8e7",
                    },
                    value: 1,
                    unit: "",
                  },
                },
                {
                  id: "a-8-n-6",
                  actionTypeId: "TRANSFORM_SCALE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|57e9f670-656d-c467-4a04-6c7d1d3ba8e7",
                    },
                    xValue: 1,
                    yValue: 1,
                    locked: true,
                  },
                },
              ],
            },
            {
              keyframe: 69,
              actionItems: [
                {
                  id: "a-8-n-2",
                  actionTypeId: "TRANSFORM_SCALE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|57e9f670-656d-c467-4a04-6c7d1d3ba8e7",
                    },
                    xValue: 2,
                    yValue: 2,
                    locked: true,
                  },
                },
                {
                  id: "a-8-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|57e9f670-656d-c467-4a04-6c7d1d3ba8e7",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727909443634,
    },
    "a-10": {
      id: "a-10",
      title: "New Scroll Animation",
      continuousParameterGroups: [
        {
          id: "a-10-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 33,
              actionItems: [
                {
                  id: "a-10-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|e30f89f8-b266-38d1-3134-9f92f85eb456",
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 34,
              actionItems: [
                {
                  id: "a-10-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|e30f89f8-b266-38d1-3134-9f92f85eb456",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727909978917,
    },
    "a-11": {
      id: "a-11",
      title: "Circles Fade In-Out",
      continuousParameterGroups: [
        {
          id: "a-11-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 20,
              actionItems: [
                {
                  id: "a-11-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|1069cf5b-55e6-18ed-0f24-c9f1433f26fe",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 30,
              actionItems: [
                {
                  id: "a-11-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|1069cf5b-55e6-18ed-0f24-c9f1433f26fe",
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 50,
              actionItems: [
                {
                  id: "a-11-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|1069cf5b-55e6-18ed-0f24-c9f1433f26fe",
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 60,
              actionItems: [
                {
                  id: "a-11-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|1069cf5b-55e6-18ed-0f24-c9f1433f26fe",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727965126952,
    },
    "a-12": {
      id: "a-12",
      title: "Lines Fade In-Out",
      continuousParameterGroups: [
        {
          id: "a-12-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 34,
              actionItems: [
                {
                  id: "a-12-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|49e95129-e31c-093c-f52f-8963a2e1f0ea",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 39,
              actionItems: [
                {
                  id: "a-12-n-3",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|49e95129-e31c-093c-f52f-8963a2e1f0ea",
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 50,
              actionItems: [
                {
                  id: "a-12-n-4",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|49e95129-e31c-093c-f52f-8963a2e1f0ea",
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 60,
              actionItems: [
                {
                  id: "a-12-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|49e95129-e31c-093c-f52f-8963a2e1f0ea",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727965656407,
    },
    "a-13": {
      id: "a-13",
      title: "logo fade in",
      continuousParameterGroups: [
        {
          id: "a-13-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 50,
              actionItems: [
                {
                  id: "a-13-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|068e37ec-672a-51bf-68c0-846a96492fef",
                    },
                    value: 0,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 60,
              actionItems: [
                {
                  id: "a-13-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|068e37ec-672a-51bf-68c0-846a96492fef",
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727965870138,
    },
    "a-14": {
      id: "a-14",
      title: "pantone-scroll-red",
      continuousParameterGroups: [
        {
          id: "a-14-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 55,
              actionItems: [
                {
                  id: "a-14-n",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|008162a2-086c-1548-20eb-c14309c90e50",
                    },
                    value: 0,
                    unit: "",
                  },
                },
                {
                  id: "a-14-n-3",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "easeInOut",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|008162a2-086c-1548-20eb-c14309c90e50",
                    },
                    yValue: 0,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
            {
              keyframe: 68,
              actionItems: [
                {
                  id: "a-14-n-2",
                  actionTypeId: "STYLE_OPACITY",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|008162a2-086c-1548-20eb-c14309c90e50",
                    },
                    value: 1,
                    unit: "",
                  },
                },
              ],
            },
            {
              keyframe: 100,
              actionItems: [
                {
                  id: "a-14-n-4",
                  actionTypeId: "TRANSFORM_MOVE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      useEventTarget: true,
                      id: "66fb1132ee1ccbe420bbfde7|008162a2-086c-1548-20eb-c14309c90e50",
                    },
                    yValue: -100,
                    xUnit: "PX",
                    yUnit: "px",
                    zUnit: "PX",
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1727967564846,
    },
    "a-15": {
      id: "a-15",
      title: "archive-hover",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-15-n",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "easeInOut",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".archive-child",
                  selectorGuids: ["ce42ae39-64fb-4846-1927-aa5e8d3fd42c"],
                },
                xValue: 1,
                yValue: 1,
                locked: true,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-15-n-2",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "easeInOut",
                duration: 250,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".archive-child",
                  selectorGuids: ["ce42ae39-64fb-4846-1927-aa5e8d3fd42c"],
                },
                xValue: 1,
                yValue: 1,
                locked: true,
              },
            },
            {
              id: "a-15-n-3",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".archive-child",
                  selectorGuids: ["ce42ae39-64fb-4846-1927-aa5e8d3fd42c"],
                },
                xValue: 1.3,
                yValue: 1.3,
                locked: true,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1727970394892,
    },
    "a-16": {
      id: "a-16",
      title: "archive-hover-out",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-16-n",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".archive-child",
                  selectorGuids: ["ce42ae39-64fb-4846-1927-aa5e8d3fd42c"],
                },
                xValue: 1,
                yValue: 1,
                locked: true,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-16-n-2",
              actionTypeId: "TRANSFORM_SCALE",
              config: {
                delay: 0,
                easing: "",
                duration: 250,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".archive-child",
                  selectorGuids: ["ce42ae39-64fb-4846-1927-aa5e8d3fd42c"],
                },
                xValue: 1,
                yValue: 1,
                locked: true,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1727970818036,
    },
    slideInBottom: {
      id: "slideInBottom",
      useFirstGroupAsInitialState: true,
      actionItemGroups: [
        {
          actionItems: [
            {
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                duration: 0,
                target: {
                  id: "N/A",
                  appliesTo: "TRIGGER_ELEMENT",
                  useEventTarget: true,
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                duration: 0,
                target: {
                  id: "N/A",
                  appliesTo: "TRIGGER_ELEMENT",
                  useEventTarget: true,
                },
                xValue: 0,
                yValue: 100,
                xUnit: "PX",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "outQuart",
                duration: 1000,
                target: {
                  id: "N/A",
                  appliesTo: "TRIGGER_ELEMENT",
                  useEventTarget: true,
                },
                xValue: 0,
                yValue: 0,
                xUnit: "PX",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "outQuart",
                duration: 1000,
                target: {
                  id: "N/A",
                  appliesTo: "TRIGGER_ELEMENT",
                  useEventTarget: true,
                },
                value: 1,
              },
            },
          ],
        },
      ],
    },
  },
  site: {
    mediaQueries: [
      { key: "main", min: 992, max: 10000 },
      { key: "medium", min: 768, max: 991 },
      { key: "small", min: 480, max: 767 },
      { key: "tiny", min: 0, max: 479 },
    ],
  },
});
